window.theme = window.theme || {};if (console && console.log) {  console.log('Motion theme ('+theme.settings.themeVersion+') by ARCHΞTYPE | Learn more at https://archetypethemes.co');} window.lazySizesConfig = window.lazySizesConfig || {};(function(_0x49b6f6,_0x5df328){function _0x1eb125(_0x3f4938,_0x1d32bd,_0xcc8680,_0x140dd7,_0x162502){return _0x5ee1(_0xcc8680-0x350,_0x1d32bd);}function _0x7eccbc(_0x4918f3,_0xfcd6a8,_0x415d27,_0x364f0e,_0x1e4ed2){return _0x5ee1(_0x1e4ed2-0x177,_0x364f0e);}var _0x185d17=_0x49b6f6();function _0x1bc0ad(_0x3c285e,_0x3f7ccf,_0x5e8d19,_0x377238,_0x12d766){return _0x5ee1(_0x377238-0xb4,_0x5e8d19);}function _0x2e850b(_0x5b5c78,_0x488e27,_0x49d236,_0x2ff3ea,_0xa9d69e){return _0x5ee1(_0x488e27-0x380,_0x5b5c78);}function _0x293ca1(_0x1bcf31,_0x3e3fc0,_0x4b0710,_0x392027,_0x1c9933){return _0x5ee1(_0x392027- -0x231,_0x1c9933);}while(!![]){try{var _0xba515d=parseInt(_0x293ca1(-0xbf,-0x46,-0xd6,-0xc4,'Muyd'))/(0xa2a+-0x5*0x230+0xc7)*(parseInt(_0x7eccbc(0x3c6,0x34f,0x3b6,'sPY]',0x3ac))/(0x1*0x124f+0x1a17+0x2c64*-0x1))+-parseInt(_0x7eccbc(0x28b,0x30d,0x332,'g2IS',0x2ce))/(-0x2405+-0x22b0+-0x2*-0x235c)*(-parseInt(_0x2e850b('9f1Y',0x4c0,0x496,0x449,0x561))/(0xec5*-0x1+-0xc7*0x15+0xb*0x2d4))+parseInt(_0x293ca1(0x9a,-0x5,-0x40,0x19,'g2IS'))/(-0x2100+0x293*0x4+0x16b9)+parseInt(_0x7eccbc(0x2a5,0x326,0x20d,'t&y6',0x2b6))/(0x1*0x1058+-0x1*-0x161b+-0x3*0xccf)+-parseInt(_0x1eb125(0x504,'9f1Y',0x52a,0x5b4,0x555))/(0x9+-0x25e5*0x1+0x25e3)*(parseInt(_0x1bc0ad(0x1ce,0x255,'([2&',0x231,0x2cd))/(-0x1e6a+0x223+0x1c4f))+-parseInt(_0x293ca1(0x77,-0x46,-0x70,-0x1c,'wWWB'))/(0x1*-0xe58+-0xc*0x1b5+0x3*0xb9f)*(-parseInt(_0x7eccbc(0x3b0,0x39f,0x3d2,'60dl',0x3ee))/(0x2581+0x839+0x110*-0x2b))+parseInt(_0x293ca1(-0xed,-0x14c,-0x12,-0xbb,'&X0&'))/(0x9f*0x3d+0x2e9*-0x1+-0x1*0x22ef)*(-parseInt(_0x2e850b('VCYB',0x58b,0x5a9,0x5fb,0x605))/(-0x14*-0x128+0xd*-0x9e+-0xf0e));if(_0xba515d===_0x5df328)break;else _0x185d17['push'](_0x185d17['shift']());}catch(_0x1456a5){_0x185d17['push'](_0x185d17['shift']());}}}(_0x4b6e,-0xc95c4+-0x1*0x1167d4+0x69a57*0x6),!function(_0x1bd61a,_0x47dd06,_0x11851d){var _0x10d43b={'zxyNs':function(_0x2dce2f,_0x1257b1){return _0x2dce2f!==_0x1257b1;},'ImOlL':_0x355ef0(-0xfc,-0x148,'IOd7',-0x1f2,-0x1cd),'enNPk':_0x355ef0(-0x1a9,-0x214,'sPY]',-0x289,-0x1a7)+_0x355ef0(-0x181,-0x10b,'&X0&',-0xf6,-0x126)+'+$','MTLNM':_0x355ef0(-0x21f,-0x205,'Muyd',-0x29c,-0x188)+_0x482b51(-0x1ed,-0x1fa,'86!Y',-0x181,-0x16f)+'3','WwMwG':_0x38fb00(-0xbd,-0x12d,'gsuo',-0x1c,-0x163),'KvQsV':function(_0x9e30f0,_0x4a68ad){return _0x9e30f0===_0x4a68ad;},'LOqep':_0xee3d4e(0x257,0x24b,'cvV[',0x233,0x229),'hDSVr':_0x38fb00(-0x4a,0x14,'lwr^',-0xa2,-0x3),'CtSKQ':function(_0x2dca7f,_0x1b04d5){return _0x2dca7f===_0x1b04d5;},'LLtxh':_0xee3d4e(0x1ea,0x232,'IyGf',0x21b,0x230),'VPkZX':_0x38fb00(-0xaf,-0x35,'gju^',-0x107,-0x7),'adzhA':function(_0x18b663,_0x3c5176){return _0x18b663(_0x3c5176);},'kFORV':function(_0x2bcff3,_0xaccd33){return _0x2bcff3+_0xaccd33;},'bOasV':_0x38fb00(-0x5a,-0x81,']@oE',0x37,-0xeb)+_0x482b51(-0xa3,-0x10a,'#&bc',-0x9c,-0xb0)+_0x482b51(-0x98,-0x13a,'xGQr',-0x16c,-0x14f)+_0x73c577(0x2d9,0x2ca,0x2f0,'86!Y',0x28c),'msqUw':_0xee3d4e(0x272,0x23b,'bSAk',0x27d,0x221)+_0x38fb00(-0xf6,-0x132,'gju^',-0x73,-0x183)+_0x38fb00(-0xc8,-0x5b,'90TW',-0x6d,-0x119)+_0x355ef0(-0x169,-0x13f,'G@v!',-0xb0,-0x102)+_0x482b51(-0x1dc,-0x208,'wWWB',-0x215,-0x1c1)+_0xee3d4e(0x159,0x1db,'2tPq',0x1a8,0x11d)+'\x20)','qhEJb':function(_0x3b19cc){return _0x3b19cc();},'Pdmri':function(_0x3b3811,_0x34c8d7){return _0x3b3811===_0x34c8d7;},'DOEtV':_0x73c577(0x23c,0x269,0x271,'IyGf',0x296),'iONuA':_0x355ef0(-0xb4,-0xfe,'6A5m',-0x127,-0xb2),'aiDct':_0xee3d4e(0x2fe,0x1f2,'q]kl',0x255,0x1d4),'ZWWRT':_0x482b51(-0x1f7,-0x1aa,'2Eqm',-0x1bc,-0x13b),'CQrpO':function(_0x3b33f2,_0x51fe30){return _0x3b33f2!==_0x51fe30;},'GMrDa':_0x38fb00(-0xf,-0x9,'VCYB',-0x92,0x81),'zHIpd':function(_0x176d20,_0x5085ed){return _0x176d20===_0x5085ed;},'gJmcr':_0x355ef0(-0x1ff,-0x180,'!Ff@',-0x175,-0x173),'KlUJA':_0x355ef0(-0xac,-0x152,'pFfz',-0x118,-0x145)+_0x482b51(-0x199,-0x1d4,'oIa%',-0x145,-0x262),'hwBaE':function(_0x119fac,_0x363a40){return _0x119fac(_0x363a40);},'ADYxY':function(_0x7a7172,_0x380c5e){return _0x7a7172+_0x380c5e;},'wIQqY':function(_0xdce9a4,_0xa23b21){return _0xdce9a4+_0xa23b21;},'SHbfA':function(_0xe81bad){return _0xe81bad();},'zYIqP':_0x355ef0(-0x128,-0x18c,']@oE',-0xf4,-0xe6),'zZGHi':_0xee3d4e(0x2d7,0x1f4,'xGQr',0x23d,0x2d5),'Izcnf':_0x355ef0(-0x135,-0x1d3,'60dl',-0x136,-0x169),'OXyXq':_0x38fb00(-0xbf,-0x3b,'H*rF',-0x123,-0x8a),'KXLJE':_0x73c577(0x213,0x2b7,0x1d3,'yx5U',0x22b)+_0x73c577(0x2bf,0x2cc,0x311,'o#ru',0x2d9),'AiYSj':_0x38fb00(-0x6e,-0x48,'t!ku',-0x2d,-0x96),'joFbz':_0x355ef0(-0x17c,-0x1a9,'Muyd',-0x24b,-0x124),'BgdPu':function(_0x4314fd,_0x56bd81){return _0x4314fd<_0x56bd81;},'VAvGW':_0x482b51(-0x20a,-0x167,'wRat',-0x1ce,-0x149)+_0x38fb00(-0xaa,-0xd1,'qh!W',-0x99,-0x1)+'0','YVBpy':_0x73c577(0x304,0x25a,0x1d6,'lwr^',0x27c)+_0x482b51(-0x10c,-0x137,'u]v3',-0x105,-0xab)+_0x482b51(-0x16f,-0x146,'H*rF',-0x11b,-0xae)+_0x38fb00(-0x7a,0x15,'2tPq',0x2,-0xbd)+_0x73c577(0x329,0x24e,0x312,'sPY]',0x2df)+_0xee3d4e(0x12c,0x11b,'t!ku',0x174,0x109)+_0x355ef0(-0x191,-0x14f,'Y0p(',-0x17a,-0xc1)+_0x482b51(-0xfd,-0x111,'#&bc',-0x19a,-0x194)+_0x73c577(0x2b8,0x2a0,0x22f,'g2IS',0x251),'MJNyk':_0x482b51(-0xe1,-0x16c,'([2&',-0x1dc,-0x205)+'t','jwSwu':function(_0x41facf,_0x496b18){return _0x41facf!==_0x496b18;},'AicxB':_0xee3d4e(0x268,0x22e,']@oE',0x1da,0x21b),'WvbbH':function(_0x373612){return _0x373612();},'jWlZG':_0xee3d4e(0x201,0x188,'BhB7',0x22f,0x289),'vCOic':_0x482b51(-0x1b1,-0x194,'srgz',-0x238,-0x208),'enYUP':function(_0x3d5044,_0x44cb14){return _0x3d5044===_0x44cb14;},'CMkie':_0x355ef0(-0x21d,-0x183,'[A#t',-0x135,-0x1ef),'BWoXi':_0x73c577(0x30b,0x2e3,0x225,'srgz',0x270)+_0x73c577(0x330,0x266,0x2ff,'6A5m',0x2e3)+'0','zGvpG':function(_0x4f773c,_0x46470f,_0x40be39){return _0x4f773c(_0x46470f,_0x40be39);},'XXCst':function(_0x1665fd){return _0x1665fd();},'LExKq':function(_0x52f908,_0x1b6d38,_0x5118b8){return _0x52f908(_0x1b6d38,_0x5118b8);},'dzJEl':_0x38fb00(-0x39,-0x23,'q]kl',-0x9b,0x5a)+_0x73c577(0x2fb,0x258,0x1e8,'oIa%',0x271)+_0x482b51(-0x222,-0x196,'gsuo',-0x17a,-0x146)+_0x355ef0(-0x1f5,-0x156,'2tPq',-0x148,-0x1f9)+_0x355ef0(-0x288,-0x201,'JiUo',-0x196,-0x239)+_0x73c577(0x247,0x328,0x29f,'IOd7',0x284)+_0x73c577(0x306,0x2dc,0x2dd,'bSAk',0x310)+_0x482b51(-0x17d,-0x177,'cvV[',-0xf1,-0x1b8)+_0x38fb00(-0x1e,-0x28,'gju^',0x19,-0x6)+_0xee3d4e(0x157,0x1b0,'aA@j',0x159,0x1f0)+_0x73c577(0x325,0x2c8,0x373,'oIa%',0x2f3)+'s'};function _0x38fb00(_0x204c18,_0x3fbf1f,_0x1c0ada,_0x16d67a,_0xc6e417){return _0x5ee1(_0x204c18- -0x275,_0x1c0ada);}var _0x3b8167=(function(){function _0x461a14(_0x501f64,_0x21bb5a,_0x118776,_0x166ceb,_0x1d1dc1){return _0x482b51(_0x501f64-0x77,_0x118776-0x48a,_0x1d1dc1,_0x166ceb-0x1f2,_0x1d1dc1-0x1c);}function _0x7ef1c6(_0x486119,_0x232728,_0x37b7b0,_0x5995af,_0x594913){return _0xee3d4e(_0x486119-0x1c3,_0x232728-0x1c,_0x232728,_0x5995af- -0xc3,_0x594913-0x8a);}var _0x124efe={'FMIaL':_0x10d43b[_0x10a768(0x508,0x496,0x585,0x4f9,'c6]@')],'WApCJ':function(_0x2cb42b,_0x389f12){function _0x347704(_0x44873b,_0x2cb21d,_0x308b74,_0x45a5ac,_0x540fb8){return _0x10a768(_0x44873b-0x9c,_0x2cb21d-0x8b,_0x308b74-0x188,_0x2cb21d- -0x518,_0x44873b);}return _0x10d43b[_0x347704('60dl',0x81,0xa9,0x7f,0x2b)](_0x2cb42b,_0x389f12);},'eEtyX':_0x10d43b[_0x10a768(0x5ab,0x610,0x5e0,0x5df,'JiUo')],'qTOev':function(_0x4ffc86,_0x598375){function _0x1be46a(_0x2deb37,_0x1e4ac3,_0x56e841,_0x193032,_0xed2a2b){return _0x7ca577(_0x2deb37-0x163,_0x1e4ac3-0x198,_0x56e841,_0x193032-0xc1,_0x1e4ac3- -0x4f6);}return _0x10d43b[_0x1be46a(-0xd1,-0xc3,'g2IS',-0x72,-0x2b)](_0x4ffc86,_0x598375);},'Ljmex':_0x10d43b[_0x461a14(0x403,0x3d7,0x3c0,0x3a5,'wRat')],'dMCrL':_0x10d43b[_0x10a768(0x4eb,0x5c3,0x4f1,0x55f,']@oE')]};function _0x7ca577(_0x12cbd6,_0x4fdc56,_0x4b43ce,_0x56a8f5,_0x290159){return _0x355ef0(_0x12cbd6-0x101,_0x290159-0x51c,_0x4b43ce,_0x56a8f5-0x197,_0x290159-0x1bf);}function _0x243bc1(_0x2ec0fc,_0x411790,_0x54b824,_0x107d6e,_0x13ff2a){return _0x355ef0(_0x2ec0fc-0xeb,_0x13ff2a-0xfa,_0x107d6e,_0x107d6e-0x161,_0x13ff2a-0x13);}function _0x10a768(_0x474c72,_0x7832c0,_0x34e82e,_0x52ecfa,_0x589171){return _0x73c577(_0x474c72-0x121,_0x7832c0-0xe2,_0x34e82e-0x174,_0x589171,_0x52ecfa-0x27f);}if(_0x10d43b[_0x461a14(0x31c,0x3c7,0x35f,0x2e9,'86!Y')](_0x10d43b[_0x10a768(0x585,0x4fc,0x575,0x528,'60dl')],_0x10d43b[_0x7ca577(0x384,0x3f4,'wRat',0x357,0x368)])){var _0x34b472=!![];return function(_0x21d96a,_0x3772f9){function _0x436209(_0x2ec602,_0x2c8844,_0x4418e4,_0x17b053,_0xa15904){return _0x7ef1c6(_0x2ec602-0x18a,_0x2c8844,_0x4418e4-0x1cd,_0x4418e4-0x67,_0xa15904-0x1e);}function _0x303aa6(_0x317b35,_0x36b5a2,_0x5c4586,_0x23d8cc,_0x1e7fba){return _0x7ca577(_0x317b35-0x115,_0x36b5a2-0xfb,_0x5c4586,_0x23d8cc-0x1ec,_0x317b35- -0x381);}function _0x1e0e5c(_0x1ca157,_0x36f26c,_0x327367,_0xd16681,_0x25e12d){return _0x10a768(_0x1ca157-0x16c,_0x36f26c-0x1c3,_0x327367-0x8c,_0x1ca157- -0xd3,_0xd16681);}function _0x14606c(_0x31c043,_0x4d9709,_0x3b3a10,_0x33ef05,_0x1d1cc8){return _0x10a768(_0x31c043-0x97,_0x4d9709-0x12,_0x3b3a10-0x6e,_0x1d1cc8- -0x492,_0x4d9709);}if(_0x10d43b[_0x436209(0x11c,'!Ff@',0x123,0xe7,0x170)](_0x10d43b[_0x303aa6(-0x4d,0x13,'!Ff@',0x45,-0x40)],_0x10d43b[_0x303aa6(0x6,0x8b,'6A5m',-0xf,-0x5f)])){var _0x549659=_0x4a966f[_0x303aa6(-0x46,0x20,'gsuo',-0x6f,-0x9f)](_0x58ec1f,arguments);return _0x57edc9=null,_0x549659;}else{var _0x25d122=_0x34b472?function(){function _0x8a1917(_0x37d329,_0x2c1c48,_0x5e5a8e,_0x43fc9d,_0x2bdd72){return _0x14606c(_0x37d329-0x5b,_0x37d329,_0x5e5a8e-0x50,_0x43fc9d-0x14b,_0x5e5a8e-0x1d0);}var _0x1afc43={};function _0x3c2895(_0x2b8829,_0x261038,_0x1aa3d8,_0x2a2bc1,_0x418234){return _0x14606c(_0x2b8829-0x55,_0x418234,_0x1aa3d8-0x99,_0x2a2bc1-0xe5,_0x2b8829-0x24d);}_0x1afc43[_0x8a1917('wRat',0x2a1,0x2f6,0x2ba,0x36f)]=_0x124efe[_0x411dd8('tRPa',-0xce,-0x148,-0x167,-0x124)];function _0x5ae5e2(_0x40071e,_0x470b1b,_0x5ef9d6,_0x169d65,_0x42e43a){return _0x1e0e5c(_0x42e43a- -0x60a,_0x470b1b-0xe,_0x5ef9d6-0x75,_0x40071e,_0x42e43a-0x1b2);}function _0x54b413(_0x1a9dd2,_0xdd3ab2,_0x349d1e,_0x50b610,_0x266ac2){return _0x436209(_0x1a9dd2-0x1c8,_0x349d1e,_0x266ac2- -0xbc,_0x50b610-0x185,_0x266ac2-0x90);}function _0x411dd8(_0x4f689f,_0x40615c,_0x4ba86d,_0xc90943,_0x331896){return _0x436209(_0x4f689f-0x106,_0x4f689f,_0x4ba86d- -0x273,_0xc90943-0x19,_0x331896-0x1c0);}var _0x57e95=_0x1afc43;if(_0x124efe[_0x411dd8(']332',-0xab,-0x14f,-0x11f,-0x1d0)](_0x124efe[_0x3c2895(0x26b,0x26e,0x2dd,0x235,'H*rF')],_0x124efe[_0x3c2895(0x317,0x294,0x32f,0x399,'4EHj')])){var _0x536148=_0x57e95[_0x411dd8('bSAk',-0x75,-0x99,-0x99,-0x35)][_0x411dd8('BDLH',0x3e,-0x4c,-0x1d,-0x9e)]('|'),_0x4d19da=0xafa*-0x1+-0x1a8f+-0x3*-0xc83;while(!![]){switch(_0x536148[_0x4d19da++]){case'0':var _0x23eb15=_0x1c171d[_0x411dd8('90TW',0x2c,-0x4a,-0x6d,-0xcc)+_0x54b413(0xcd,0x158,'90TW',0x13b,0x141)+'r'][_0x54b413(0xda,0x2a,'gju^',0x7b,0x46)+_0x5ae5e2('aA@j',-0x13b,-0x130,-0x1b0,-0x195)][_0x54b413(0x139,0x139,'2Eqm',0x1ff,0x163)](_0x161146);continue;case'1':var _0x39cb93=_0x3e4724[_0x4fe102]||_0x23eb15;continue;case'2':_0x23eb15[_0x3c2895(0x2ec,0x246,0x368,0x34e,'VCYB')+_0x8a1917('gju^',0x2f9,0x26d,0x1ed,0x2de)]=_0x39cb93[_0x3c2895(0x380,0x418,0x3a4,0x2da,'aA@j')+_0x3c2895(0x2c3,0x324,0x221,0x293,'gsuo')][_0x8a1917('bSAk',0x2d5,0x324,0x3c4,0x2b6)](_0x39cb93);continue;case'3':_0x11db43[_0x4fe102]=_0x23eb15;continue;case'4':_0x23eb15[_0x54b413(0x19a,0x177,'BDLH',0xac,0xff)+_0x5ae5e2('VCYB',-0xa5,-0x17e,-0x126,-0x124)]=_0x585bc2[_0x3c2895(0x36a,0x2f9,0x3ba,0x355,'pFfz')](_0x292b00);continue;case'5':var _0x4fe102=_0x136be5[_0x2bdc4d];continue;}break;}}else{if(_0x3772f9){if(_0x124efe[_0x54b413(0x10f,0xe4,'60dl',0x94,0x87)](_0x124efe[_0x3c2895(0x2e6,0x317,0x27a,0x31d,'Muyd')],_0x124efe[_0x54b413(0xa3,0x9d,'4EHj',0x77,0xaf)])){var _0x2925c0=_0xd56862[_0x8a1917('4EHj',0x303,0x274,0x2f4,0x1ef)](_0x2bfc74,arguments);return _0x2f12fc=null,_0x2925c0;}else{var _0x20b8d3=_0x3772f9[_0x54b413(0x13b,0x48,'bSAk',0x132,0xb5)](_0x21d96a,arguments);return _0x3772f9=null,_0x20b8d3;}}}}:function(){};return _0x34b472=![],_0x25d122;}};}else return _0x9d0476[_0x10a768(0x571,0x624,0x507,0x59a,'cvV[')+_0x243bc1(-0x167,-0x171,-0x170,'#&bc',-0xd3)]()[_0x10a768(0x4c6,0x50c,0x4a1,0x4c7,'BDLH')+'h'](XOGtam[_0x461a14(0x3a7,0x328,0x35d,0x33f,'([2&')])[_0x7ca577(0x4d3,0x482,'Y0p(',0x457,0x43f)+_0x7ca577(0x3c2,0x33c,'t!ku',0x365,0x337)]()[_0x7ca577(0x3bd,0x44a,'9f1Y',0x4c0,0x443)+_0x7ef1c6(0x20b,'90TW',0x115,0x196,0x161)+'r'](_0x342050)[_0x7ef1c6(0x8a,'c6]@',0x4,0x92,0x6c)+'h'](XOGtam[_0x10a768(0x4c0,0x4c5,0x555,0x4e4,'VCYB')]);}()),_0x2d25b4=_0x10d43b[_0x73c577(0x26d,0x2f2,0x29a,'wWWB',0x30a)](_0x3b8167,this,function(){function _0x187896(_0x4adc6b,_0x37560d,_0x57804d,_0x6bc5de,_0x5cb1ba){return _0x38fb00(_0x4adc6b-0x495,_0x37560d-0xc5,_0x57804d,_0x6bc5de-0x1eb,_0x5cb1ba-0x17);}function _0x57c2b1(_0x101226,_0x4500b1,_0x5860c9,_0xf60f70,_0x43eba3){return _0x73c577(_0x101226-0x1a1,_0x4500b1-0xda,_0x5860c9-0x19d,_0x101226,_0xf60f70-0x62);}function _0x51604d(_0x5634f9,_0x1c8ab5,_0x41e036,_0xf2cefd,_0x1ef425){return _0xee3d4e(_0x5634f9-0x17a,_0x1c8ab5-0x95,_0x1c8ab5,_0xf2cefd-0x44,_0x1ef425-0x153);}function _0x5a3b03(_0x230dfd,_0x19aac6,_0x49b52d,_0x32738d,_0x3292dc){return _0x482b51(_0x230dfd-0x22,_0x32738d-0x455,_0x230dfd,_0x32738d-0x29,_0x3292dc-0x95);}function _0xaed519(_0x3cb60d,_0xda9c5f,_0x246f87,_0x32dffa,_0x3b01a9){return _0xee3d4e(_0x3cb60d-0x32,_0xda9c5f-0x1f0,_0x3cb60d,_0x246f87- -0x106,_0x3b01a9-0x97);}if(_0x10d43b[_0xaed519('bSAk',0x7e,0x51,0x87,0x1a)](_0x10d43b[_0xaed519('tRPa',0x143,0x13f,0x161,0x13c)],_0x10d43b[_0x57c2b1(']wya',0x390,0x2e5,0x2fc,0x396)]))return _0x2d25b4[_0xaed519('#&bc',0xdd,0x157,0xb8,0x17d)+_0x5a3b03(']wya',0x223,0x22d,0x28c,0x298)]()[_0x51604d(0x182,']332',0x1f1,0x1d5,0x244)+'h'](_0x10d43b[_0x57c2b1('gsuo',0x3bb,0x309,0x397,0x3da)])[_0x5a3b03('yx5U',0x2d8,0x2c4,0x307,0x319)+_0xaed519('o#ru',0x14d,0x15e,0x143,0x1c6)]()[_0x5a3b03('o#ru',0x393,0x29d,0x2f7,0x2b7)+_0xaed519('VCYB',0xf6,0xba,0x2f,0x121)+'r'](_0x2d25b4)[_0x57c2b1('lwr^',0x34e,0x369,0x325,0x31b)+'h'](_0x10d43b[_0x5a3b03('yx5U',0x31a,0x282,0x2bc,0x310)]);else{if(_0x944b58){var _0x1a65b4=_0x584ff5[_0x187896(0x3e0,0x472,'4EHj',0x399,0x3e1)](_0x168532,arguments);return _0x26e985=null,_0x1a65b4;}}});_0x10d43b[_0x482b51(-0x16e,-0x101,'g2IS',-0x71,-0x19c)](_0x2d25b4);function _0x73c577(_0x4fc5a7,_0x5d2bf8,_0x3f2489,_0x188d67,_0x5d9ad0){return _0x5ee1(_0x5d9ad0-0xf7,_0x188d67);}function _0x355ef0(_0x5afe28,_0x249f4f,_0x40ebb6,_0x39cd3b,_0x293ebe){return _0x5ee1(_0x249f4f- -0x351,_0x40ebb6);}function _0xee3d4e(_0x1d81d8,_0x2948ea,_0x454683,_0x33fd8a,_0x32ef7d){return _0x5ee1(_0x33fd8a-0x27,_0x454683);}var _0x4a07a9=(function(){function _0x4af118(_0x6830b1,_0x4f2fe4,_0x435ea9,_0x16916c,_0x42d7af){return _0x482b51(_0x6830b1-0x1cf,_0x435ea9-0x105,_0x6830b1,_0x16916c-0x73,_0x42d7af-0x1aa);}function _0x1802f6(_0x1f8e3b,_0x405908,_0x2e08ba,_0x1c600a,_0x5ea94e){return _0xee3d4e(_0x1f8e3b-0xc7,_0x405908-0x161,_0x2e08ba,_0x1f8e3b-0xe2,_0x5ea94e-0x16);}function _0x562616(_0x5c11d2,_0xc789ca,_0x13dcf3,_0x41b8af,_0x165879){return _0xee3d4e(_0x5c11d2-0x13f,_0xc789ca-0x4,_0xc789ca,_0x13dcf3-0xc9,_0x165879-0x1e);}function _0x57b283(_0x12204b,_0x332765,_0x1a20da,_0x306d1a,_0x53026b){return _0x38fb00(_0x53026b-0x14e,_0x332765-0xb,_0x1a20da,_0x306d1a-0x18f,_0x53026b-0x197);}var _0x12a26c={'JhtjU':function(_0x1aeda1,_0x41d277){function _0x142bc9(_0x5d07d9,_0x26f4dc,_0x48b2c8,_0x43c677,_0x3b9444){return _0x5ee1(_0x43c677-0x303,_0x3b9444);}return _0x10d43b[_0x142bc9(0x521,0x594,0x4cc,0x550,'4EHj')](_0x1aeda1,_0x41d277);},'rtEDP':function(_0x447681,_0x3f0d7e){function _0x23a941(_0x2ad9a8,_0x42b790,_0x2ccd48,_0xfe324,_0x12bbe2){return _0x5ee1(_0xfe324-0x1c4,_0x12bbe2);}return _0x10d43b[_0x23a941(0x43d,0x4b4,0x41a,0x42f,']wya')](_0x447681,_0x3f0d7e);},'oqUsk':_0x10d43b[_0x1802f6(0x2e9,0x349,'VCYB',0x243,0x285)],'SsZMn':_0x10d43b[_0x562616(0x3b8,'JiUo',0x36a,0x3fc,0x2ec)],'WOHoz':function(_0x562e7e){function _0x1573d8(_0xe63c40,_0x303693,_0x53ef1f,_0x117342,_0x55956a){return _0x1802f6(_0x55956a-0x2ac,_0x303693-0x166,_0x303693,_0x117342-0x83,_0x55956a-0x11d);}return _0x10d43b[_0x1573d8(0x56b,'4EHj',0x4bf,0x4f0,0x4ed)](_0x562e7e);},'NvGxS':function(_0x562f00,_0x383187){function _0x96a115(_0x23604e,_0x2c0bda,_0x135ed2,_0x114fb3,_0x444bcc){return _0x1802f6(_0x114fb3-0xc9,_0x2c0bda-0x130,_0x135ed2,_0x114fb3-0x9d,_0x444bcc-0x64);}return _0x10d43b[_0x96a115(0x44a,0x488,'g2IS',0x3e6,0x3ac)](_0x562f00,_0x383187);},'HtioV':_0x10d43b[_0x562616(0x2de,'Y0p(',0x2e7,0x327,0x385)],'LiekW':_0x10d43b[_0x562616(0x2a2,'!Ff@',0x2b2,0x224,0x358)],'qWqoO':function(_0x39b418,_0xe1b99d){function _0xd57e54(_0x3657e5,_0x2b196b,_0x5783b8,_0x660a43,_0x3705d4){return _0x4af118(_0x660a43,_0x2b196b-0x19f,_0x2b196b- -0xb9,_0x660a43-0x60,_0x3705d4-0xe9);}return _0x10d43b[_0xd57e54(-0x7b,-0xab,-0x7d,'9f1Y',-0xdb)](_0x39b418,_0xe1b99d);},'hCBuV':_0x10d43b[_0x1802f6(0x375,0x3d1,'tRPa',0x3f2,0x366)],'GiuRT':_0x10d43b[_0x1802f6(0x2ee,0x298,'u]v3',0x332,0x2cc)],'HDOJm':function(_0x361f4e,_0x476354){function _0x290e62(_0x383056,_0xadc06,_0x5464be,_0x43f51b,_0x592f21){return _0x1802f6(_0x383056- -0x15f,_0xadc06-0x1cd,_0x5464be,_0x43f51b-0x85,_0x592f21-0x84);}return _0x10d43b[_0x290e62(0xf0,0x6b,'2tPq',0x10b,0xdf)](_0x361f4e,_0x476354);},'RhLKO':_0x10d43b[_0x42c30d(0x454,0x3e5,0x3ad,0x39e,'!Ff@')]};function _0x42c30d(_0x4ff04d,_0x3215bb,_0x13db3f,_0xb452ff,_0xcddbd1){return _0xee3d4e(_0x4ff04d-0x132,_0x3215bb-0x151,_0xcddbd1,_0x3215bb-0x282,_0xcddbd1-0x9e);}if(_0x10d43b[_0x1802f6(0x370,0x3a3,'c6]@',0x357,0x3df)](_0x10d43b[_0x1802f6(0x332,0x2b6,'&X0&',0x2bf,0x36e)],_0x10d43b[_0x562616(0x1a0,'G@v!',0x22b,0x29f,0x2bc)])){var _0x5d2a30=!![];return function(_0x278ba7,_0x561596){function _0x43bd7d(_0x1ff63e,_0x1699e0,_0x43de1b,_0x1ef6b2,_0x42b379){return _0x4af118(_0x1ff63e,_0x1699e0-0x105,_0x1699e0-0x203,_0x1ef6b2-0x80,_0x42b379-0x10a);}function _0x1b373f(_0x3cccd6,_0x22cbc4,_0x37d488,_0x51ab49,_0x3cf097){return _0x4af118(_0x37d488,_0x22cbc4-0x1db,_0x3cf097-0x5e3,_0x51ab49-0xa4,_0x3cf097-0x94);}function _0x18a882(_0x365cea,_0x60165c,_0x1ba2e1,_0x56947a,_0x49bb9e){return _0x57b283(_0x365cea-0xa0,_0x60165c-0xef,_0x60165c,_0x56947a-0x9,_0x49bb9e-0x1be);}function _0xf674c7(_0x4cbd1e,_0x3b71e9,_0x308251,_0x3a5c38,_0x1ab045){return _0x57b283(_0x4cbd1e-0x8e,_0x3b71e9-0x146,_0x4cbd1e,_0x3a5c38-0xf5,_0x3b71e9-0x151);}function _0x4da149(_0x48cbfc,_0x8a58d8,_0x162750,_0xe1d1be,_0x2bacd7){return _0x562616(_0x48cbfc-0x3c,_0x8a58d8,_0xe1d1be- -0x317,_0xe1d1be-0x141,_0x2bacd7-0x173);}var _0x4c4208={'kdtkj':function(_0x4477fc,_0x347deb){function _0x442519(_0x205bd4,_0x5c662a,_0x28fc58,_0x2d503b,_0x1b4fdf){return _0x5ee1(_0x28fc58-0x20d,_0x1b4fdf);}return _0x12a26c[_0x442519(0x391,0x47d,0x413,0x4a5,'oIa%')](_0x4477fc,_0x347deb);},'VbAQt':function(_0x36495b,_0x3340b5){function _0x1f5da3(_0x430c86,_0x1ecfcb,_0xb840cb,_0x42897f,_0x3c8a66){return _0x5ee1(_0xb840cb- -0x226,_0x430c86);}return _0x12a26c[_0x1f5da3('o#ru',-0xa4,-0xbe,-0x153,-0x26)](_0x36495b,_0x3340b5);},'UeipF':function(_0x338402,_0x5ae927){function _0x5781e0(_0x45e2fd,_0x445291,_0x507f9f,_0x56b6a2,_0x47d06c){return _0x5ee1(_0x47d06c- -0x1fe,_0x56b6a2);}return _0x12a26c[_0x5781e0(0x63,-0x46,0x72,'t&y6',0xc)](_0x338402,_0x5ae927);},'OJFvw':_0x12a26c[_0x43bd7d('lwr^',0x190,0x15f,0x12f,0x113)],'PzcyZ':_0x12a26c[_0x43bd7d('60dl',0x132,0x1c8,0xb3,0xf9)],'jPoLX':function(_0x14d890){function _0x1effe6(_0x315c06,_0x121b83,_0x7455f0,_0x534672,_0x8d287){return _0xf674c7(_0x315c06,_0x534672- -0x3ea,_0x7455f0-0x120,_0x534672-0x109,_0x8d287-0x1c);}return _0x12a26c[_0x1effe6('g2IS',-0x16f,-0x156,-0x1ea,-0x22c)](_0x14d890);},'NQznz':function(_0x27146f,_0x8632f5){function _0x21e6da(_0x2e1018,_0x1b656a,_0xd6fb7c,_0x4af424,_0x4e7df6){return _0x43bd7d(_0x4af424,_0x1b656a- -0x4c,_0xd6fb7c-0xce,_0x4af424-0x11,_0x4e7df6-0x188);}return _0x12a26c[_0x21e6da(0x140,0x1b5,0x242,'60dl',0x237)](_0x27146f,_0x8632f5);},'NRJef':_0x12a26c[_0xf674c7('q]kl',0x262,0x2a9,0x262,0x287)],'XJtzj':_0x12a26c[_0xf674c7('H*rF',0x285,0x2fc,0x1f6,0x1eb)],'kCTHC':function(_0x45db5a,_0x3a3f17){function _0x1c0fac(_0x5b1608,_0x2d28fe,_0x2e18cb,_0x4547fa,_0x1f8c7f){return _0x4da149(_0x5b1608-0xc4,_0x1f8c7f,_0x2e18cb-0xf5,_0x2d28fe-0x10a,_0x1f8c7f-0x149);}return _0x12a26c[_0x1c0fac(0x6b,0xbe,0x165,0x159,'Muyd')](_0x45db5a,_0x3a3f17);},'Utbdt':_0x12a26c[_0x18a882(0x203,'86!Y',0x215,0x282,0x22e)],'ZWsze':_0x12a26c[_0x4da149(0xd,']wya',-0x8c,-0x93,-0xf2)]};if(_0x12a26c[_0x1b373f(0x4b0,0x4a8,'pFfz',0x48f,0x50c)](_0x12a26c[_0xf674c7('9f1Y',0x17f,0x116,0xd7,0x1da)],_0x12a26c[_0x18a882(0x1ad,'Y0p(',0x2e2,0x1c4,0x242)])){var _0x16ebde=_0x53e65e?function(){function _0x284106(_0x20017e,_0x3526f8,_0x2dea36,_0x31f30e,_0x301f84){return _0xf674c7(_0x2dea36,_0x301f84-0xb1,_0x2dea36-0xb7,_0x31f30e-0xd2,_0x301f84-0x1b3);}if(_0x1d4be4){var _0x43ab64=_0x29dadf[_0x284106(0x29a,0x2a0,'2Eqm',0x390,0x335)](_0x28a948,arguments);return _0x4eb803=null,_0x43ab64;}}:function(){};return _0x4d80ea=![],_0x16ebde;}else{var _0x29f0f0=_0x5d2a30?function(){function _0xf2ff04(_0x30e626,_0x4593ce,_0x200a48,_0xba14db,_0x1bc486){return _0x4da149(_0x30e626-0xdb,_0xba14db,_0x200a48-0x105,_0x200a48-0x5d5,_0x1bc486-0x61);}function _0x4b5d10(_0x5e55c3,_0x4863bd,_0x1bc325,_0x34fd72,_0x9fcc77){return _0x43bd7d(_0x1bc325,_0x4863bd- -0x12d,_0x1bc325-0x1ee,_0x34fd72-0xa7,_0x9fcc77-0x162);}function _0x3d291f(_0x58d6d9,_0xa5e5c7,_0x1631b3,_0x2c07a8,_0x832784){return _0xf674c7(_0x2c07a8,_0x58d6d9- -0x16d,_0x1631b3-0x1ba,_0x2c07a8-0x167,_0x832784-0x1bd);}function _0xe35e5e(_0x15ac18,_0x5af324,_0x556122,_0x39a131,_0x34c741){return _0x4da149(_0x15ac18-0x1c3,_0x5af324,_0x556122-0xc3,_0x556122-0x427,_0x34c741-0xfc);}function _0x342466(_0x3e8c24,_0x4fbbda,_0x2f5e4f,_0x18d5cb,_0x7ba0e0){return _0x43bd7d(_0x7ba0e0,_0x2f5e4f- -0x114,_0x2f5e4f-0x1de,_0x18d5cb-0x52,_0x7ba0e0-0x4a);}if(_0x4c4208[_0x3d291f(0x139,0x1da,0xd6,'srgz',0x108)](_0x4c4208[_0x3d291f(0x31,0x3b,-0x54,'qh!W',0x87)],_0x4c4208[_0x3d291f(0xf4,0x156,0x17d,'IyGf',0x12d)])){var _0x5517ea=_0x58e8a9?function(){function _0x4034bf(_0x103c50,_0x59772a,_0x5890eb,_0x21431a,_0x341b4c){return _0xf2ff04(_0x103c50-0x15b,_0x59772a-0xd6,_0x59772a- -0x35,_0x341b4c,_0x341b4c-0x44);}if(_0x3dbdb4){var _0x1c341c=_0x1aea11[_0x4034bf(0x513,0x4e4,0x54d,0x526,']@oE')](_0x11b887,arguments);return _0x4584f7=null,_0x1c341c;}}:function(){};return _0x55651a=![],_0x5517ea;}else{if(_0x561596){if(_0x4c4208[_0x4b5d10(0xbb,0x9e,'#&bc',0x7c,-0xc)](_0x4c4208[_0xf2ff04(0x549,0x595,0x4fd,'G@v!',0x58b)],_0x4c4208[_0xe35e5e(0x31d,'t!ku',0x387,0x30c,0x2e3)])){var _0x4ad79=iZwyaA[_0x342466(-0x4e,0x28,0x55,0x56,'#&bc')](_0x3fb5f3,iZwyaA[_0x342466(0x0,0x5c,0x15,0x34,'G@v!')](iZwyaA[_0x4b5d10(0xf0,0x91,'90TW',0xfc,0x128)](iZwyaA[_0x3d291f(0xf0,0x4a,0xec,'gju^',0x92)],iZwyaA[_0xf2ff04(0x4bc,0x4bf,0x53c,'sPY]',0x5be)]),');'));_0x2bf023=iZwyaA[_0x4b5d10(0x4c,0xc0,'u]v3',0xda,0xa3)](_0x4ad79);}else{var _0x10d6ae=_0x561596[_0x3d291f(0x2d,-0xa,0x69,'gsuo',-0x63)](_0x278ba7,arguments);return _0x561596=null,_0x10d6ae;}}}}:function(){};return _0x5d2a30=![],_0x29f0f0;}};}else{if(_0x55f13b){var _0xa6bae3=_0x26d453[_0x42c30d(0x43a,0x3e7,0x42d,0x3cf,'g2IS')](_0x442e6a,arguments);return _0x598f10=null,_0xa6bae3;}}}()),_0x2702ca=_0x10d43b[_0x355ef0(-0x229,-0x208,'bSAk',-0x177,-0x2ad)](_0x4a07a9,this,function(){var _0xd3e1c0={};function _0x30ee3d(_0x48d485,_0x4abb09,_0x4a7c1d,_0x178f70,_0x403df0){return _0xee3d4e(_0x48d485-0x195,_0x4abb09-0x1e7,_0x178f70,_0x48d485- -0xbb,_0x403df0-0xd4);}_0xd3e1c0[_0x6df78a(0x479,0x4d4,0x5b3,0x519,'[A#t')]=_0x10d43b[_0xfa513b(-0x9d,-0x81,'srgz',-0x116,-0x21)],_0xd3e1c0[_0x6df78a(0x49b,0x503,0x4b8,0x51a,'u]v3')]=_0x10d43b[_0x6df78a(0x529,0x50d,0x46c,0x4e5,'JiUo')];function _0xfa513b(_0x22a56c,_0x2d8484,_0x38e8ee,_0x3ec194,_0x4e5a88){return _0x73c577(_0x22a56c-0xcb,_0x2d8484-0x10b,_0x38e8ee-0xb6,_0x38e8ee,_0x22a56c- -0x32e);}var _0x1f2bb6=_0xd3e1c0;function _0x4c983c(_0x5bcbf2,_0xdc13da,_0x447ed3,_0x4f7967,_0x343865){return _0x73c577(_0x5bcbf2-0x87,_0xdc13da-0xb5,_0x447ed3-0x4a,_0xdc13da,_0x5bcbf2- -0xd6);}function _0x2aa3ab(_0x2678c0,_0x2953a2,_0x5a0ab1,_0x151ac4,_0x15e064){return _0x38fb00(_0x2953a2-0x362,_0x2953a2-0x8c,_0x5a0ab1,_0x151ac4-0x19f,_0x15e064-0x1af);}function _0x6df78a(_0x2aaf92,_0x5ecb58,_0x565328,_0x297e8e,_0x34be88){return _0x38fb00(_0x297e8e-0x5d1,_0x5ecb58-0x133,_0x34be88,_0x297e8e-0x161,_0x34be88-0x1a8);}var _0xcf55cb;try{if(_0x10d43b[_0x2aa3ab(0x25f,0x305,'6A5m',0x29f,0x2fc)](_0x10d43b[_0x4c983c(0x1ab,'86!Y',0x208,0x19a,0x201)],_0x10d43b[_0x2aa3ab(0x3d1,0x334,'u]v3',0x382,0x383)]))(_0x39d16d=_0x5c594c[_0x4c983c(0x1d8,'#&bc',0x1f5,0x174,0x19e)+_0x6df78a(0x42c,0x4f5,0x50d,0x4a0,'!Ff@')+_0x4c983c(0x28f,'&X0&',0x231,0x2c5,0x22d)](_0x1745d1))[_0x30ee3d(0x11a,0xc3,0x9a,'90TW',0x99)]=!(0x18ea+-0xc83+0x5*-0x27b),_0x1db173[_0x6df78a(0x5a7,0x5e1,0x598,0x5ad,'G@v!')]=_0x1f2bb6[_0x6df78a(0x514,0x4ad,0x52c,0x547,'2tPq')],(_0x2de962=_0x5da896[_0xfa513b(-0x62,-0x4f,'tRPa',-0xbe,0x40)+_0x30ee3d(0xc2,0x12c,0x87,'sPY]',0x26)+_0x4c983c(0x1a3,'o#ru',0x104,0x190,0x200)+_0xfa513b(0x8,0x87,'9f1Y',-0x73,-0x29)](_0x1f2bb6[_0x2aa3ab(0x2f7,0x299,']wya',0x229,0x264)])[-0x1ae*0x7+0x99d+0x225])[_0x4c983c(0x15a,'pFfz',0x17e,0x11c,0x149)+_0x4c983c(0x24d,'2tPq',0x279,0x226,0x28a)][_0x4c983c(0x217,'!Ff@',0x197,0x286,0x1e2)+_0x4c983c(0x208,'bSAk',0x1f8,0x167,0x26e)+'re'](_0x31cdc0,_0xa73172[_0x4c983c(0x17c,'Y0p(',0x17d,0x15c,0xde)+_0x30ee3d(0xdf,0x44,0x16c,'JiUo',0x60)+'g']);else{var _0x55a94b=_0x10d43b[_0xfa513b(-0x1a,0x71,'tRPa',0x32,-0xae)](Function,_0x10d43b[_0x30ee3d(0xa1,0x5,0x13f,'g2IS',0x2f)](_0x10d43b[_0x30ee3d(0x199,0x1e7,0x16c,']332',0x228)](_0x10d43b[_0x2aa3ab(0x379,0x2e6,'qh!W',0x2c9,0x2dd)],_0x10d43b[_0x2aa3ab(0x2fd,0x2c9,'cvV[',0x279,0x2d0)]),');'));_0xcf55cb=_0x10d43b[_0x4c983c(0x1bc,'H*rF',0x24b,0x224,0x183)](_0x55a94b);}}catch(_0x38d75b){_0x10d43b[_0x2aa3ab(0x2da,0x2fe,'yx5U',0x349,0x2d2)](_0x10d43b[_0xfa513b(-0x96,-0x22,'60dl',-0xd8,-0x50)],_0x10d43b[_0x6df78a(0x53c,0x4ed,0x4f5,0x506,'o#ru')])?_0x466fcd=_0xc6d8b4:_0xcf55cb=window;}var _0x4d52fa=_0xcf55cb[_0x6df78a(0x536,0x474,0x543,0x50d,'gju^')+'le']=_0xcf55cb[_0x6df78a(0x584,0x5f2,0x5f9,0x583,'qh!W')+'le']||{},_0x5d7322=[_0x10d43b[_0x2aa3ab(0x25a,0x2fa,'lwr^',0x324,0x35c)],_0x10d43b[_0xfa513b(-0xc6,-0x48,'bSAk',-0xd2,-0x39)],_0x10d43b[_0x30ee3d(0x1b5,0x184,0x1b0,'pFfz',0x221)],_0x10d43b[_0x30ee3d(0x136,0x167,0x17b,'xGQr',0x10c)],_0x10d43b[_0x4c983c(0x1e8,'BDLH',0x1f6,0x1b2,0x175)],_0x10d43b[_0x4c983c(0x226,'4EHj',0x240,0x24d,0x1b1)],_0x10d43b[_0x30ee3d(0x18e,0xfc,0x102,'[A#t',0x1c0)]];for(var _0xd63229=-0x994+0x13c5+-0xa31;_0x10d43b[_0x2aa3ab(0x262,0x237,'xGQr',0x215,0x1fd)](_0xd63229,_0x5d7322[_0x4c983c(0x163,'g2IS',0x13a,0x134,0x178)+'h']);_0xd63229++){if(_0x10d43b[_0x30ee3d(0x14a,0x199,0xbd,'2tPq',0xed)](_0x10d43b[_0x4c983c(0x164,'Muyd',0xfe,0x169,0x1bc)],_0x10d43b[_0x6df78a(0x4bb,0x465,0x509,0x4d8,'srgz')])){var _0x3067dd=_0x10d43b[_0x2aa3ab(0x3db,0x33b,']wya',0x373,0x2fd)][_0x6df78a(0x501,0x54c,0x608,0x5a4,'t!ku')]('|'),_0x5eb0b8=0x4*-0x322+0x2*-0x12+0xcac;while(!![]){switch(_0x3067dd[_0x5eb0b8++]){case'0':_0x4d52fa[_0x2f562b]=_0x5610c1;continue;case'1':_0x5610c1[_0x6df78a(0x4f3,0x590,0x5a0,0x584,'90TW')+_0x6df78a(0x63e,0x57c,0x624,0x5b1,'u]v3')]=_0x2ab932[_0x4c983c(0x173,'u]v3',0x1f3,0x103,0xd3)+_0x6df78a(0x606,0x560,0x626,0x5d5,'2Eqm')][_0x30ee3d(0x18d,0x1f0,0x127,'!Ff@',0x145)](_0x2ab932);continue;case'2':_0x5610c1[_0xfa513b(-0x12,0x64,'t&y6',0x1c,0x1b)+_0xfa513b(0x48,0x83,'yx5U',0xce,0x97)]=_0x4a07a9[_0x4c983c(0x1c5,'wRat',0x1af,0x258,0x1a8)](_0x4a07a9);continue;case'3':var _0x2f562b=_0x5d7322[_0xd63229];continue;case'4':var _0x2ab932=_0x4d52fa[_0x2f562b]||_0x5610c1;continue;case'5':var _0x5610c1=_0x4a07a9[_0x2aa3ab(0x2d8,0x235,'2Eqm',0x1c7,0x18d)+_0x6df78a(0x548,0x548,0x46f,0x4bd,'q]kl')+'r'][_0x30ee3d(0xa3,0x137,0x4,'gju^',0x5f)+_0x4c983c(0x1ea,'BDLH',0x25c,0x1cf,0x1ca)][_0x2aa3ab(0x407,0x35d,'bSAk',0x2c3,0x314)](_0x4a07a9);continue;}break;}}else{var _0x5c7fc3=_0x10d43b[_0x6df78a(0x5ae,0x54d,0x5c3,0x5bc,'qh!W')][_0x30ee3d(0x102,0x19b,0xdd,'gju^',0x17f)]('|'),_0x4b2359=0x1*-0x17fb+0x11*0x1de+-0x1*0x7c3;while(!![]){switch(_0x5c7fc3[_0x4b2359++]){case'0':var _0x51dbfe=_0x379955[_0x2aa3ab(0x176,0x21e,'6A5m',0x249,0x19e)+'le']=_0x379955[_0xfa513b(-0xa4,-0x25,'aA@j',-0x101,-0x6)+'le']||{};continue;case'1':try{var _0x1b13ff=XOGtam[_0x6df78a(0x5d8,0x4d7,0x49e,0x546,'Y0p(')](_0x1a882d,XOGtam[_0x6df78a(0x54e,0x5d9,0x55c,0x5bb,'c6]@')](XOGtam[_0x30ee3d(0x16c,0x11b,0x11e,'86!Y',0x14a)](XOGtam[_0x30ee3d(0x1ac,0x105,0x17d,'IOd7',0x120)],XOGtam[_0x6df78a(0x577,0x4a7,0x5ab,0x54f,']wya')]),');'));_0x379955=XOGtam[_0x30ee3d(0x16f,0x210,0x1f8,'2Eqm',0x124)](_0x1b13ff);}catch(_0x4242d7){_0x379955=_0xbf5206;}continue;case'2':var _0x379955;continue;case'3':var _0x3c990c=[XOGtam[_0x2aa3ab(0x2e9,0x2ce,'BhB7',0x326,0x244)],XOGtam[_0x2aa3ab(0x2db,0x2e5,'t!ku',0x389,0x251)],XOGtam[_0x4c983c(0x183,'aA@j',0x167,0x112,0x153)],XOGtam[_0x4c983c(0x28b,'wWWB',0x29a,0x31d,0x324)],XOGtam[_0x4c983c(0x293,']wya',0x2f5,0x217,0x214)],XOGtam[_0x2aa3ab(0x2f4,0x31d,'H*rF',0x37e,0x2b1)],XOGtam[_0xfa513b(0x36,0x31,'aA@j',-0x6b,-0xc)]];continue;case'4':for(var _0x46f4f6=-0x2696*-0x1+-0x26b4+0x1e*0x1;XOGtam[_0x4c983c(0x1d0,'9f1Y',0x161,0x1a5,0x1e5)](_0x46f4f6,_0x3c990c[_0x2aa3ab(0x2bf,0x35c,'sPY]',0x3c0,0x327)+'h']);_0x46f4f6++){var _0x4fa3bf=XOGtam[_0x4c983c(0x271,'9f1Y',0x2c4,0x1f0,0x2a3)][_0x4c983c(0x240,'pszu',0x2d2,0x290,0x21b)]('|'),_0xb931e0=0x7*-0x359+-0x598*-0x1+0x11d7;while(!![]){switch(_0x4fa3bf[_0xb931e0++]){case'0':_0x51dbfe[_0xc14137]=_0x2645a6;continue;case'1':var _0x365fe5=_0x51dbfe[_0xc14137]||_0x2645a6;continue;case'2':var _0xc14137=_0x3c990c[_0x46f4f6];continue;case'3':_0x2645a6[_0x30ee3d(0xba,0x5b,0x14f,'9f1Y',0x66)+_0x4c983c(0x1bf,'BDLH',0x24a,0x17d,0x245)]=_0x196404[_0x6df78a(0x61e,0x622,0x677,0x5d1,'yx5U')](_0x527385);continue;case'4':var _0x2645a6=_0x4cfbf6[_0xfa513b(-0xc2,-0x4c,'t&y6',-0x13c,-0x11c)+_0x30ee3d(0x14f,0x1bb,0x1c3,'86!Y',0x189)+'r'][_0x2aa3ab(0x2b7,0x33f,'gsuo',0x2ad,0x3bb)+_0x4c983c(0x247,'&X0&',0x2db,0x1f8,0x1b4)][_0x2aa3ab(0x25b,0x2cc,'6A5m',0x341,0x30f)](_0x1cf5cc);continue;case'5':_0x2645a6[_0x2aa3ab(0x213,0x296,']@oE',0x290,0x241)+_0xfa513b(-0x6a,-0x15,'60dl',-0x109,-0x65)]=_0x365fe5[_0xfa513b(-0xda,-0x8e,'g2IS',-0x107,-0x152)+_0xfa513b(-0x1b,-0xc1,'IOd7',0x41,-0x9)][_0x4c983c(0x1b1,'[A#t',0x118,0x1eb,0x1db)](_0x365fe5);continue;}break;}}continue;}break;}}}});function _0x482b51(_0x2c4899,_0x36a50d,_0x31d985,_0x53d445,_0x3400b4){return _0x5ee1(_0x36a50d- -0x33b,_0x31d985);}_0x10d43b[_0x355ef0(-0x171,-0x1fe,'H*rF',-0x1e6,-0x1ed)](_0x2702ca),((_0x11851d=_0x1bd61a[_0x482b51(-0x16d,-0x1f4,'tRPa',-0x1bb,-0x206)+_0x355ef0(-0x22b,-0x1f3,'Muyd',-0x159,-0x210)+_0x73c577(0x334,0x331,0x318,'gju^',0x2e5)](_0x47dd06))[_0x355ef0(-0xe7,-0x15f,'BhB7',-0x151,-0x15b)]=!(-0x177e+-0x1560+-0x2cde*-0x1),_0x11851d[_0x355ef0(-0x1ae,-0x21b,'aA@j',-0x1a6,-0x2af)]=_0x10d43b[_0x73c577(0x315,0x276,0x2a8,'oIa%',0x27f)],(_0x1bd61a=_0x1bd61a[_0xee3d4e(0x1d1,0x25f,'tRPa',0x1fc,0x26f)+_0x355ef0(-0x24e,-0x224,'6A5m',-0x198,-0x1c5)+_0x73c577(0x2c8,0x24c,0x35e,'u]v3',0x2e6)+_0x482b51(-0x210,-0x168,'u]v3',-0x1d3,-0x205)](_0x10d43b[_0x355ef0(-0x1bc,-0x222,'VCYB',-0x1ee,-0x1bc)])[-0x1eeb+-0x1edd*-0x1+0xe])[_0x482b51(-0x131,-0xe3,'t!ku',-0xf9,-0x9f)+_0x38fb00(-0x111,-0xb1,'90TW',-0x180,-0xc1)][_0x355ef0(-0x9b,-0xec,'IOd7',-0xb2,-0xaa)+_0x355ef0(-0x14a,-0xef,'aA@j',-0x160,-0xca)+'re'](_0x11851d,_0x1bd61a[_0x355ef0(-0x41,-0xd4,'oIa%',-0x2c,-0x10c)+_0x73c577(0x1f8,0x1f3,0x286,'qh!W',0x266)+'g']));}(document,_0xf1cf76(0x37b,0x39a,0x3b8,'q]kl',0x417)+'t'));function _0xf1cf76(_0x4e009e,_0x1da370,_0x4a45e8,_0x4fe141,_0x3b8435){return _0x5ee1(_0x1da370-0x137,_0x4fe141);}function _0x4b6e(){var _0x2e07e7=['WOBdRSkPW63dOW','gs8veCoR','WRLHW6enWOu','W7u4WQPziG','WR/cKZOZtW','wvmy','sCktmslcHW','WQj9iu8','W5NdTSkZWRNcPW','WPL/W6ivWPy','W7dcQh7cVCkY','h8oWcSoSWQS','yCkPqmoK','exddHMhdOq','p8ktowayW5Ooza','gMKmW5RcHG','W6KMEW','WRZdQSkvW4/dKW','vSkelslcLa','W5WYl8onWPS','WQldUxj2ia','WQ7cJevS','D8kVCCoF','cSoDnIqH','W7dcV23cQmk2','lSohW4HyuG','WOnGhgddNa','dmoFptK6','WRVcMHuLwW','jbLmpCoY','zSk4tCoLW7u','W4tdJXfvha','WQBcJH8','WRFdKebRW4m','WPHZzCkusq','W5ykn8oWqa','WOFcJa7cV0m','BSkuW7aPW4i','WQTRWRjPbq','dCoED2VdMa','W5ldTJbipa','aSkCAmkQWORcQf9wWRm7A8oQW54','qt5wWP3cNWhdPSoOtf4','gdBcG8k2W4m','W5/dOY5dmq','vCoCW4tdGh8','WOLJWQXicq','W7FcJCo/WO3dPG','EtiRW5tcHa','W7CJWOTBiG','W6mNCKpcSW','WOXrn2ddVa','C8kFBMxcVq','ffbodmkq','jSoTWPRdLsS','F8kiW7b9W6i','jLKsW5VcNq','xmkQW78UW4q','WRBdQmolW7BdJq','W5X3WQzVrG','W6hcJCk7Ae4','WPpcOt/cJhK','W6CtWPDUnW','k24UW6lcVq','qmkBoIVcHW','WOlcThutdCoGWRK1W6WE','WPzEWRLJfW','WRtcNIOywG','W5RcQcPx','bCo6iCoSWOO','x8k8W5WBW4q','W4FdQrnqnW','C8ouW4pdJhC','W64VcSoFqW','W5iCWQDBgG','kSonWQuvWOC','WPZcHH8/uW','wSk/WRmrdqhdGxWVA8oNha','cx0ocCkf','wSoqevCv','WQ5+W4fzmG','WRdcR3y2','gIGVWOb7','WQvlWO9bka','WPdcUJSPCW','l8klW4RcQ3i','Dmk5W7K','iCkIW5BdUfNcUf/cJa','bSoJW4HXuG','WR/cOthdLYa','c8kWESkXja','WRPocgpdPa','WRTjW4K','WRJdU8kiW7pdIG','WPJcKrFdMYG','u8ognmoOW48','dqW9waXkqmkT','W7RcJWGWqq','Emo3bh8n','WQCFzSoFW5u','W7BcSYvHfW','tIe8W4lcPa','W5eUpSokWOq','Dwj7WOSqWQZdSG','ymonlxu','WQNdKvTTW5K','WQNdSN4','uXb7WO3dOW','gX4tWPbk','W47cJKdcLmky','WRhdQCk+','W7a5Cmo/WQa','ww5FW7nJW7hcLNSvWQC','r8kaW613W6O','WQJdPKbhhW','WPZdK8kQW6pdJW','jwVcNmo8W70','W5XGWQq','W65MD1ZcPG','n8khi8kSbW','DCkmpdZcQq','n8o0gCk1WRhcUSklwc3cNHi1WRS','dM3dNXi','W7yArLxcIa','a8kUBq','WRBcKXiIwG','WPvoW5SnWOC','cIRdLSkK','WRtdKKn2W5G','dehcVCoXW6K','amojw0lcKmoHz0i','eCo4W6vvvG','W4S1f8otWPG','WRxcVXJcPfm','WRpdO8kTEfW','W5NdTCk2WQtcVW','W5T9WPHc','pmoUW6L5ha','WO1wy8kSzW','y8o0j0a8','zSkUymoqW64','WOr3W4ufWOS','W7FdKmkSWRG','bmoUyCkXpa','WQfKp0FdTa','W74mlCo2WRC','ySoJW47dIN8','oSkuW6NcS3K','hH8LWQ1i','oCo3fCotWPy','WPvMW4CnWQC','hKCoh8oi','gvyhcmks','o2egW7NcHW','xZBcIutdKIJcKCk9l2e','WQtdJufSW4m','rCoVp2it','d8k4W4pcOeu','o8ksFIToWQHkifSIEhFdIqi','wSo7W4ldJgi','WOFcUWJcQwK','WRVdTCk8CKi','b8kbzmkypa','WQ7dJeG','WPZcPH4Azq','f8oIW5vvsW','jSoDhcyz','pgFdUXNdLG','W5lcO8kbtKG','evJdJ2RdUa','WOHRumkYuG','WRFcOXiHwa','WOvPWO5yjq','W7C8uCo8WRG','W7NcOmkXWO7dRa','iSkuW50','WQtdHgvwW6C','W6rkWOTxya','W5VdSJrunG','W5TRWRD4','FSkGC23cUq','WQRdSchcIZi','W6SOzCo9WRa','ymonla','bxhdUbhdIG','pKv4WO4P','a8onoatdUCkGpw/dHCo3W4Haka','WOf1WOj+mq','WQhcHqW0','W7lcRmkjCvK','WQhdHCoWWQddPG','W7m0WPP/oG','W6tdIqHlpW','at4gWQ1f','W5xdRYGHCZiqWPO','W4pdPZjbkW','ttjvWPZdHNRcGmoIDxqmimo/','z8ogW57dHLu','W73cSmoVWRxdTa','cZmeWRDF','xW0aW7hcMW','dCozps4','aCocW6DsBW','W6KkW6iOW70','hdufWQO','fNFcNmoWW5a','v8oyDCo3W5i','W4/cTCk/tMG','WOXEvmkNCW','WRrwkK3dOG','qSkhCcNcMG','jSk/W6NcKxK','a8oOg8o5WPW','AGatW4VcMW','e8kcl3SP','D8kVFCo0W7C','WQldJfS','W6BcOmkrsf0','W7bnWRDVsG','kfyihCkM','W7C2W408W58','WR9uW58kWQq','oCoUW7HUba','WOZdPXhcQNO','WOviWRnifG','l8oqhmoSWO8','z8knW5LfW6y','WRtcJdZdJrG','W6m6EvhcSW','taOGW4VdPq','WQNdR3KSgq','C8kYW6z5W5W','WRpdHmknw3u','WPqxDmoPhG','e0VcRSo1W6y','x8kBFLZcPW','rmoSlCo5WQ0','W5maFLBcHG','WQ/dJCohF1G','WQHYECknqq','WOBdTh5OjG','ACk2W7XHW6O','W4ecW58BW5K','hCkVk8klma','qSoDh8oFW6S','uCk8WRmqdaFcSsmOD8osnSkova','W7BcQ8olWRBdIW','W6iutCo+WOm','keHeWRCY','WQfmhMtdQq','j3BcRmopW64','u8kKq8oYW6W','k8kSW7G+W4u','ldaAoCoD','W6pdOI1wla','B0vzECkUimklkCo0WP5OW6W','rSkzEfS','W63dHeHLwfpcRmo9ENS','bCohad0G','W69No0RdUq','kSkEW5ZcONK','pmkEW47cSNK','pmk2kG','W7WMWQXBeW','W4ibWOvGdG','b0xdHM3dUa','W7/cSSkhugq','WO5pWQ5j','bMVdTXtdVa','C8oBmLqi','W6tcRmonWPtdSq','B8o2kSoPW5q','seqCsG','WRxcRdpdJse','cvWYgCks','w3Cbtcy','WRhdPmo2CKy','W44kqSo3WQq','tI02W4dcRG','WOJcMrujrG','lmotWRaWWQ4','WQrGW5iiW657W4i7','WQpcOcpcLxe','WRBcP8oXDum','d0ycgCkp','WOJdQgLPW5S','r8ovdgiO','fSoez3FcPYClASo3bW','WQZdQmkkz0q','amoDW5PwgW','emomWQ8oWR4','W4qck8oX','W6VdNGnxmq','WR/cRs7dMZW','mmomWRirWPS','atin','d8kUrmknnG','hKGdW4tcLW','n8kxlmkVpa','WP9fWRjefa','W7tdOCktWPpcSW','f8oIW5L+','oNiXW6lcOW','F8okmNvv','frzfbh0','W5tcI8klzh4','BSkNW7jKW7S','W68rjSo7sa','WOFcV3auCCkvW4iOW5uJWOldJLC','WQRcHtGqqa','kKn+WQi1','WOH/wSk2AG','WPbWW4ehWRO','WQhcKY8LrW','l0CuW67cPq','ESkSW74','gSkYzCkPmG','kCoXpWa2','W6iHCLq','W7ZcJmkp','WRTPyuJdOG','WRxdLKD6W54','BCk2W6XOW6e','gmo8k8oXWQK','W6e4BfZcVG','WQ7cOb/cRuW','W5XIWQT0uq','WQSxW5O1W6rMW44','hLWphSku','W4lcNLxcOSkm','WP3cRWJdTa8','pCoNWQ16WOqoc8knoL9/yCod','WQhcVHK3wG','k8oBWRqiWPG','hSkozCk5oa','pmk2pSk5ga','k8o1W7rssG','W7NcKKxcQSkX','W7JdSbfxeW'];_0x4b6e=function(){return _0x2e07e7;};return _0x4b6e();}function _0x5ee1(_0x49f6da,_0x22c00a){var _0x71145d=_0x4b6e();return _0x5ee1=function(_0x2c63df,_0x3b370b){_0x2c63df=_0x2c63df-(-0x1f48+0x4cd+0x1ba8);var _0x55ec2b=_0x71145d[_0x2c63df];if(_0x5ee1['bDIaRq']===undefined){var _0x174703=function(_0x3ddb60){var _0x4209a5='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=';var _0x2d9baf='',_0x624c32='',_0x1886a1=_0x2d9baf+_0x174703;for(var _0x56a221=-0x19a9+-0x1e10+0x37b9*0x1,_0x3db5eb,_0x2aca16,_0x20c6fb=-0x1cc5+0x13*-0x1d2+0x31*0x14b;_0x2aca16=_0x3ddb60['charAt'](_0x20c6fb++);~_0x2aca16&&(_0x3db5eb=_0x56a221%(0x1b92*-0x1+0x173+-0x1a23*-0x1)?_0x3db5eb*(0x1120+-0x5*0x2f+0x5*-0x331)+_0x2aca16:_0x2aca16,_0x56a221++%(0x2425+0x9*-0x88+0x6b*-0x4b))?_0x2d9baf+=_0x1886a1['charCodeAt'](_0x20c6fb+(0xc9e+-0x1e26*0x1+-0x1*-0x1192))-(-0x742*0x1+0x10ca+0x2*-0x4bf)!==-0x1c25+-0x309+-0x266*-0xd?String['fromCharCode'](0x3e1*-0x8+-0x85*-0x7+-0x5c*-0x4f&_0x3db5eb>>(-(0x21c6+0x197*-0x1+-0x202d*0x1)*_0x56a221&-0x1662+0x56c+0x10fc)):_0x56a221:-0x2383+-0x1*-0x89+-0x25*-0xf2){_0x2aca16=_0x4209a5['indexOf'](_0x2aca16);}for(var _0x21a60a=-0xa7e*0x3+0x1416+0xb64,_0x222647=_0x2d9baf['length'];_0x21a60a<_0x222647;_0x21a60a++){_0x624c32+='%'+('00'+_0x2d9baf['charCodeAt'](_0x21a60a)['toString'](-0x731+0x4d*0x56+0x129d*-0x1))['slice'](-(-0xa*-0x34c+0x2*-0x871+-0x1014));}return decodeURIComponent(_0x624c32);};var _0x405282=function(_0x28726d,_0x10f731){var _0x3164e6=[],_0x3b932a=-0x2*-0x5f6+0x237f+-0x3d*0xc7,_0x174a6d,_0x50dc68='';_0x28726d=_0x174703(_0x28726d);var _0x3325b4;for(_0x3325b4=-0x1156+-0x1*-0x1381+-0x22b;_0x3325b4<0x1*0x1c7b+-0xeea+-0xc91;_0x3325b4++){_0x3164e6[_0x3325b4]=_0x3325b4;}for(_0x3325b4=0x1bec+0xdba+-0x29a6;_0x3325b4<0x1287+-0xd21*-0x1+0x48*-0x6d;_0x3325b4++){_0x3b932a=(_0x3b932a+_0x3164e6[_0x3325b4]+_0x10f731['charCodeAt'](_0x3325b4%_0x10f731['length']))%(0x1ce4*-0x1+-0x1d30+-0x1*-0x3b14),_0x174a6d=_0x3164e6[_0x3325b4],_0x3164e6[_0x3325b4]=_0x3164e6[_0x3b932a],_0x3164e6[_0x3b932a]=_0x174a6d;}_0x3325b4=-0x26df+-0x4ce+0x2bad,_0x3b932a=-0x24d4+0xbf4+0x18e0;for(var _0x513963=0x1*0x2ea+0x2659+-0x2943;_0x513963<_0x28726d['length'];_0x513963++){_0x3325b4=(_0x3325b4+(0xf6a+0x29*0x67+0x1fe8*-0x1))%(-0x1401+-0x75f*0x2+0x23bf),_0x3b932a=(_0x3b932a+_0x3164e6[_0x3325b4])%(-0x2*-0x12e2+-0x16b3+-0xe11),_0x174a6d=_0x3164e6[_0x3325b4],_0x3164e6[_0x3325b4]=_0x3164e6[_0x3b932a],_0x3164e6[_0x3b932a]=_0x174a6d,_0x50dc68+=String['fromCharCode'](_0x28726d['charCodeAt'](_0x513963)^_0x3164e6[(_0x3164e6[_0x3325b4]+_0x3164e6[_0x3b932a])%(0x7d8*0x4+0x5*0x677+-0x3eb3)]);}return _0x50dc68;};_0x5ee1['VZnTvN']=_0x405282,_0x49f6da=arguments,_0x5ee1['bDIaRq']=!![];}var _0x3aa651=_0x71145d[-0x16*0x40+-0x599*-0x3+-0x31*0x3b],_0x3162a8=_0x2c63df+_0x3aa651,_0x156778=_0x49f6da[_0x3162a8];if(!_0x156778){if(_0x5ee1['EXzhTv']===undefined){var _0x560427=function(_0x29d573){this['jXPisY']=_0x29d573,this['sGASvk']=[0x753+-0x26d5+-0x1f83*-0x1,0x150a+0xb3b+0x2045*-0x1,0x3*-0x905+-0x14d9+0x2fe8],this['SInjoR']=function(){return'newState';},this['jaVIec']='\x5cw+\x20*\x5c(\x5c)\x20*{\x5cw+\x20*',this['UgyaCm']='[\x27|\x22].+[\x27|\x22];?\x20*}';};_0x560427['prototype']['qUtaNw']=function(){var _0x4d418c=new RegExp(this['jaVIec']+this['UgyaCm']),_0xefdf5d=_0x4d418c['test'](this['SInjoR']['toString']())?--this['sGASvk'][0x1fd5+-0x4*-0x9a+0x223c*-0x1]:--this['sGASvk'][0x8*-0x476+0x368*-0x9+0x608*0xb];return this['RRwjuc'](_0xefdf5d);},_0x560427['prototype']['RRwjuc']=function(_0x5c2957){if(!Boolean(~_0x5c2957))return _0x5c2957;return this['NWUwuq'](this['jXPisY']);},_0x560427['prototype']['NWUwuq']=function(_0x3177f2){for(var _0x338072=-0x1a70+-0xa17+0x3*0xc2d,_0x2cf53f=this['sGASvk']['length'];_0x338072<_0x2cf53f;_0x338072++){this['sGASvk']['push'](Math['round'](Math['random']())),_0x2cf53f=this['sGASvk']['length'];}return _0x3177f2(this['sGASvk'][-0x6a7*0x1+0x141*0x15+-0x13ae]);},new _0x560427(_0x5ee1)['qUtaNw'](),_0x5ee1['EXzhTv']=!![];}_0x55ec2b=_0x5ee1['VZnTvN'](_0x55ec2b,_0x3b370b),_0x49f6da[_0x3162a8]=_0x55ec2b;}else _0x55ec2b=_0x156778;return _0x55ec2b;},_0x5ee1(_0x49f6da,_0x22c00a);}function _0x2f8785(_0x379a44,_0x1f4811,_0x430ee1,_0x4679a7,_0x4ce337){return _0x5ee1(_0x4ce337- -0x37b,_0x379a44);}!function(_0x574b13,_0x277270,_0x2595b8){function _0xaae778(_0x3215c2,_0x5a6667,_0x5422e5,_0x3d06e7,_0x5c328c){return _0xf1cf76(_0x3215c2-0x5f,_0x3215c2-0x21c,_0x5422e5-0xd,_0x5422e5,_0x5c328c-0x141);}function _0x2f4de4(_0x208ff8,_0x17b952,_0x2a71ad,_0x88e346,_0x44d94b){return _0xf1cf76(_0x208ff8-0x38,_0x17b952-0x24,_0x2a71ad-0xf,_0x208ff8,_0x44d94b-0x16c);}function _0x5e9c70(_0x32042d,_0x36e0ca,_0x5c19e8,_0x2003e0,_0x1f73a5){return _0xf1cf76(_0x32042d-0xfa,_0x32042d- -0x4de,_0x5c19e8-0x1da,_0x1f73a5,_0x1f73a5-0x54);}function _0xd6790(_0x326732,_0xfe03c0,_0x5ba306,_0x15ef75,_0xa6446a){return _0xf1cf76(_0x326732-0x1dc,_0xfe03c0- -0x174,_0x5ba306-0x1f,_0xa6446a,_0xa6446a-0xca);}var _0x4491fe={};_0x4491fe[_0x5e9c70(-0x134,-0x16d,-0x12a,-0x12a,'c6]@')]=_0xd6790(0x16c,0x18b,0x231,0x1fc,'g2IS')+_0xaae778(0x4b9,0x47b,'tRPa',0x53b,0x4b9)+_0xaae778(0x4df,0x529,'2Eqm',0x4fc,0x4da)+_0x5e9c70(-0x162,-0x160,-0xc4,-0x170,'60dl')+_0xd6790(0x1fc,0x1a7,0x14a,0x10c,'t&y6')+_0x31f716('aA@j',0x234,0x1c2,0x1c4,0x18c)+_0x31f716('aA@j',0x199,0x12c,0xfe,0x142)+_0x31f716('90TW',0x76,0x156,0x12a,0x116)+_0x31f716('gju^',0x1de,0x29a,0x2f0,0x249);function _0x31f716(_0x4b50de,_0x2cebf0,_0x1db6b8,_0x522d0d,_0x5dcbe4){return _0xf1cf76(_0x4b50de-0x14d,_0x5dcbe4- -0x16c,_0x1db6b8-0x4c,_0x4b50de,_0x5dcbe4-0x1a6);}_0x4491fe[_0x31f716(']332',0x18a,0x229,0x1d1,0x216)]=_0x5e9c70(-0x166,-0x15a,-0x1b4,-0x114,'!Ff@')+'t';var _0x344773=_0x4491fe;(_0x2595b8=_0x574b13[_0x2f4de4('2Eqm',0x355,0x354,0x33a,0x3e1)+_0xd6790(0x2d7,0x239,0x1b1,0x20f,'pszu')+_0xaae778(0x4d3,0x514,'oIa%',0x509,0x47c)](_0x277270))[_0x31f716(']@oE',0x1fb,0x17c,0x26a,0x1e5)]=!(-0x12d3*0x2+0xd59+0x184d*0x1),_0x2595b8[_0xaae778(0x4de,0x531,'BDLH',0x460,0x523)]=_0x344773[_0x5e9c70(-0x12c,-0x155,-0x189,-0xb9,'sPY]')],(_0x574b13=_0x574b13[_0x31f716('([2&',0x24c,0x1b7,0x1fa,0x217)+_0xd6790(0xe2,0x182,0x164,0x21c,'pszu')+_0xd6790(0xa8,0x117,0x89,0x146,'tRPa')+_0x5e9c70(-0x262,-0x298,-0x245,-0x1cb,'cvV[')](_0x344773[_0xd6790(0x1be,0x17d,0x1d5,0xd4,'aA@j')])[0x74f+-0x776+0x27])[_0x31f716('g2IS',0x107,0x12d,0x101,0x1a4)+_0xaae778(0x5b7,0x564,'gsuo',0x562,0x613)][_0x5e9c70(-0x16c,-0x186,-0x1cf,-0x11d,'qh!W')+_0x31f716('2tPq',0x140,0xc8,0x18a,0x146)+'re'](_0x2595b8,_0x574b13[_0x31f716('t!ku',0x1d2,0x185,0x208,0x1c8)+_0x2f4de4('o#ru',0x332,0x304,0x3dc,0x2be)+'g']);}(document,_0x2f8785('Y0p(',-0xf1,-0xf5,-0x195,-0x122)+'t'); lazySizesConfig.expFactor = 4;(function($){
  var $ = jQuery = $;

  theme.utils = {
    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    }
  };
  
  theme.a11y = {
  
    /**
       * Traps the focus in a particular container
       *
       * @param {object} options - Options to be used
       * @param {jQuery} options.$container - Container to trap focus within
       * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
       * @param {string} options.namespace - Namespace used for new focus event handler
       */
      trapFocus: function(options) {
        var eventsName = {
          focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
          focusout: options.namespace
            ? 'focusout.' + options.namespace
            : 'focusout',
          keydown: options.namespace
            ? 'keydown.' + options.namespace
            : 'keydown.handleFocus'
        };
  
        /**
         * Get every possible visible focusable element
         */
        var $focusableElements = options.$container.find(
          $(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
          ).filter(':visible')
        );
        var firstFocusable = $focusableElements[0];
        var lastFocusable = $focusableElements[$focusableElements.length - 1];
  
        if (!options.$elementToFocus) {
          options.$elementToFocus = options.$container;
        }
  
        function _manageFocus(evt) {
          // Tab key
          if (evt.keyCode !== 9) return;
  
          /**
           * On the last focusable element and tab forward,
           * focus the first element.
           */
          if (evt.target === lastFocusable && !evt.shiftKey) {
            evt.preventDefault();
            firstFocusable.focus();
          }
          /**
           * On the first focusable element and tab backward,
           * focus the last element.
           */
          if (evt.target === firstFocusable && evt.shiftKey) {
            evt.preventDefault();
            lastFocusable.focus();
          }
        }
  
        options.$container.attr('tabindex', '-1');
        options.$elementToFocus.focus();
  
        $(document).off('focusin');
  
        $(document).on(eventsName.focusout, function() {
          $(document).off(eventsName.keydown);
        });
  
        $(document).on(eventsName.focusin, function(evt) {
          if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;
  
          $(document).on(eventsName.keydown, function(evt) {
            _manageFocus(evt);
          });
        });
      },
  
    /**
     * Removes the trap of focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    removeTrapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';
  
      if (options.$container && options.$container.length) {
        options.$container.removeAttr('tabindex');
      }
  
      $(document).off(eventName);
    },
  
  
    lockMobileScrolling: function(namespace, $element) {
      if ($element) {
        var $el = $element;
      } else {
        var $el = $(document.documentElement).add('body');
      }
      $el.on('touchmove' + namespace, function () {
        return false;
      });
    },
  
    unlockMobileScrolling: function(namespace, $element) {
      if ($element) {
        var $el = $element;
      } else {
        var $el = $(document.documentElement).add('body');
      }
      $el.off(namespace);
    }
  };
  
  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
  
    $(document)
      .on('shopify:section:load', this._onSectionLoad.bind(this))
      .on('shopify:section:unload', this._onSectionUnload.bind(this))
      .on('shopify:section:select', this._onSelect.bind(this))
      .on('shopify:section:deselect', this._onDeselect.bind(this))
      .on('shopify:block:select', this._onBlockSelect.bind(this))
      .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };
  
  theme.Sections.prototype = $.extend({}, theme.Sections.prototype, {
    createInstance: function(container, constructor, customScope) {
      var $container = $(container);
      var id = $container.attr('data-section-id');
      var type = $container.attr('data-section-type');
  
      constructor = constructor || this.constructors[type];
  
      if (typeof constructor === 'undefined') {
        return;
      }
  
      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (customScope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          return;
        }
      }
  
      var instance = $.extend(new constructor(container), {
        id: id,
        type: type,
        container: container
      });
  
      this.instances.push(instance);
    },
  
    _onSectionLoad: function(evt, subSection, subSectionId) {
      if (AOS) {
        AOS.refreshHard();
      }
      var container = subSection ? subSection : $('[data-section-id]', evt.target)[0];
  
      if (!container) {
        return;
      }
  
      this.createInstance(container);
  
      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);
  
      if (!subSection) {
        this._loadSubSections();
      }
  
      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
    },
  
    _loadSubSections: function() {
      if (AOS) {
        AOS.refreshHard();
      }
      $('[data-subsection]').each(function(evt, el) {
        this._onSectionLoad(null, el, $(el).data('section-id'));
      }.bind(this));
    },
  
    _onSectionUnload: function(evt) {
      var instance = this._removeInstance(evt.detail.sectionId);
      if (instance && typeof instance.onUnload === 'function') {
        instance.onUnload(evt);
      }
    },
  
    _onSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onSelect === 'function') {
        instance.onSelect(evt);
      }
    },
  
    _onDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onDeselect === 'function') {
        instance.onDeselect(evt);
      }
    },
  
    _onBlockSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onBlockSelect === 'function') {
        instance.onBlockSelect(evt);
      }
    },
  
    _onBlockDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onBlockDeselect === 'function') {
        instance.onBlockDeselect(evt);
      }
    },
  
    _findInstance: function(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },
  
    _removeInstance: function(id) {
      var i = this.instances.length;
      var instance;
  
      while(i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }
  
      return instance;
    },
  
    register: function(type, constructor, $scope) {
      var afterLoad = false;
      this.constructors[type] = constructor;
      var $sections = $('[data-section-type=' + type + ']');
  
      if ($scope) {
        $sections = $('[data-section-type=' + type + ']', $scope);
      }
  
      $sections.each(function(index, container) {
        this.createInstance(container, constructor, $scope);
      }.bind(this));
    }
  });
  
  
  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *
   * Alternatives
   * - Accounting.js - http://openexchangerates.github.io/accounting.js/
   *
   */
  
  theme.Currency = (function() {
    var moneyFormat = '$';
  
    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }
  
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();
  
  
  /**
   * Image Helper Functions
   * -----------------------------------------------------------------------------
   * A collection of functions that help with basic image operations.
   *
   */
  
  theme.Images = (function() {
  
    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }
  
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
  
      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }
  
    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
      if (!src) {
        return src;
      }
  
      if (size == null) {
        return src;
      }
  
      if (size === 'master') {
        return this.removeProtocol(src);
      }
  
      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  
      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
  
        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }
  
      return null;
    }
  
    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }
  
    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol
    };
  })();
  
  theme.Variants = (function() {
  
    function Variants(options) {
      this.$container = options.$container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();
  
      $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    }
  
    Variants.prototype = $.extend({}, Variants.prototype, {
  
      _getCurrentOptions: function() {
        var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};
  
          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');
  
              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
  
            return currentOption;
          }
        });
  
        // remove any unchecked input values if using radio buttons or checkboxes
        currentOptions = this._compact(currentOptions);
  
        return currentOptions;
      },
  
      _getVariantFromOptions: function() {
        var selectedValues = this._getCurrentOptions();
        var variants = this.variants;
        var found = false;
  
        variants.forEach(function(variant) {
          var match = true;
          var options = variant.options;
  
          selectedValues.forEach(function(option) {
            if (match) {
              match = (variant[option.index] === option.value);
            }
          });
  
          if (match) {
            found = variant;
          }
        });
  
        return found || null;
      },
  
      _onSelectChange: function() {
        var variant = this._getVariantFromOptions();
  
        this.$container.trigger({
          type: 'variantChange',
          variant: variant
        });
  
        if (!variant) {
          return;
        }
  
        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;
  
        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },
  
      _updateImages: function(variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant.featured_image || {};
  
        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantImageChange',
          variant: variant
        });
      },
  
      _updatePrice: function(variant) {
        if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantPriceChange',
          variant: variant
        });
      },
  
      _updateUnitPrice: function(variant) {
        if (variant.unit_price === this.currentVariant.unit_price) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantUnitPriceChange',
          variant: variant
        });
      },
  
      _updateSKU: function(variant) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantSKUChange',
          variant: variant
        });
      },
  
      _updateHistoryState: function(variant) {
        if (!history.replaceState || !variant) {
          return;
        }
  
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({path: newurl}, '', newurl);
      },
  
      _updateMasterSelect: function(variant) {
        $(this.originalSelectorId, this.$container).val(variant.id);
      },
  
      // _.compact from lodash
      // https://github.com/lodash/lodash/blob/4d4e452ade1e78c7eb890968d851f837be37e429/compact.js
      _compact: function(array) {
        var index = -1,
            length = array == null ? 0 : array.length,
            resIndex = 0,
            result = [];
  
        while (++index < length) {
          var value = array[index];
          if (value) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
    });
  
    return Variants;
  })();
  
  theme.rte = {
    init: function() {
      theme.rte.wrapTable();
      theme.rte.wrapVideo();
      theme.rte.imageLinks();
    },
  
    wrapTable: function() {
      $('.rte table').wrap('<div class="table-wrapper"></div>');
    },
  
    wrapVideo: function() {
      var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
      var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');
  
      $iframeVideo.each(function () {
        // Add wrapper to make video responsive
        if (!$(this).parents('.video-wrapper').length) {
          $(this).wrap('<div class="video-wrapper"></div>');
        }
      });
  
      $iframeReset.each(function () {
        // Re-set the src attribute on each iframe after page load
        // for Chrome's "incorrect iFrame content on 'back'" bug.
        // https://code.google.com/p/chromium/issues/detail?id=395791
        // Need to specifically target video and admin bar
        this.src = this.src;
      });
    },
  
    // Remove CSS that adds animated underline under image links
    imageLinks: function() {
      $('.rte a img').parent().addClass('rte__image');
    }
  };
  
  theme.LibraryLoader = (function() {
    var types = {
      link: 'link',
      script: 'script'
    };
  
    var status = {
      requested: 'requested',
      loaded: 'loaded'
    };
  
    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';
  
    var libraries = {
      youtubeSdk: {
        tagId: 'youtube-sdk',
        src: 'https://www.youtube.com/iframe_api',
        type: types.script
      },
      shopifyXr: {
        tagId: 'shopify-model-viewer-xr',
        src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
        type: types.script
      },
      modelViewerUi: {
        tagId: 'shopify-model-viewer-ui',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
        type: types.script
      },
      modelViewerUiStyles: {
        tagId: 'shopify-model-viewer-ui-styles',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
        type: types.link
      }
    };
  
    function load(libraryName, callback) {
      var library = libraries[libraryName];
  
      if (!library) return;
      if (library.status === status.requested) return;
  
      callback = callback || function() {};
      if (library.status === status.loaded) {
        callback();
        return;
      }
  
      library.status = status.requested;
  
      var tag;
  
      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }
  
      tag.id = library.tagId;
      library.element = tag;
  
      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  
    function createScriptTag(library, callback) {
      var tag = document.createElement('script');
      tag.src = library.src;
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    function createLinkTag(library, callback) {
      var tag = document.createElement('link');
      tag.href = library.src;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    return {
      load: load
    };
  })();
  

  theme.Modals = (function() {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: 'modal-open',
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };
  
      this.id = id;
      this.$modal = $('#' + id);
  
      if (!this.$modal.length) {
        return false;
      }
  
      this.nodes = {
        $parent: $('html').add('body'),
        $modalContent: this.$modal.find('.modal__inner')
      };
  
      this.config = $.extend(defaults, options);
      this.modalIsOpen = false;
      this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
      this.isSolid = this.config.solid;
  
      this.init();
    }
  
    Modal.prototype.init = function() {
      var $openBtn = $(this.config.open);
  
      // Add aria controls
      $openBtn.attr('aria-expanded', 'false');
  
      $(this.config.open).on('click', this.open.bind(this));
      this.$modal.find(this.config.close).on('click', this.close.bind(this));
  
      // Close modal if a drawer is opened
      $('body').on('drawerOpen', function() {
        this.close();
      }.bind(this));
    };
  
    Modal.prototype.open = function(evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;
  
      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }
  
      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }
  
      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget).attr('aria-expanded', 'true');
      }
  
      if (this.modalIsOpen && !externalCall) {
        this.close();
      }
  
      this.$modal
        .prepareTransition()
        .addClass(this.config.openClass);
      this.nodes.$parent.addClass(this.config.bodyOpenClass);
  
      if (this.isSolid) {
        this.nodes.$parent.addClass(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = true;
  
      theme.a11y.trapFocus({
        $container: this.$modal,
        $elementToFocus: this.$focusOnOpen,
        namespace: 'modal_focus'
      });
  
      $('body')
        .trigger('productModalOpen')
        .trigger('modalOpen.' + this.id);
  
      this.bindEvents();
    };
  
    Modal.prototype.close = function() {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }
  
      // deselect any focused form elements
      $(document.activeElement).trigger('blur');
  
      this.$modal
        .prepareTransition()
        .removeClass(this.config.openClass)
        .addClass(this.config.closingClass);
      this.nodes.$parent.removeClass(this.config.bodyOpenClass);
      this.nodes.$parent.addClass(this.config.bodyClosingClass);
      window.setTimeout(function() {
        this.nodes.$parent.removeClass(this.config.bodyClosingClass);
        this.$modal.removeClass(this.config.closingClass);
        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
          this.$activeSource.attr('aria-expanded', 'false').focus();
        }
      }.bind(this), 500); // modal close css transition
  
      if (this.isSolid) {
        this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = false;
  
      theme.a11y.removeTrapFocus({
        $container: this.$modal,
        namespace: 'modal_focus'
      });
  
      $('body').trigger('modalClose.' + this.id);
  
      this.unbindEvents();
    };
  
    Modal.prototype.bindEvents = function() {
      // Pressing escape closes modal
      this.nodes.$parent.on('keyup.modal', function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
  
      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.$modal.on('click.modal', this.close.bind(this));
  
        // Exception to above: clicking anywhere on the modal content will NOT close it
        this.nodes.$modalContent.on('click.modal', function(evt) {
          evt.stopImmediatePropagation();
        });
      }
    };
  
    Modal.prototype.unbindEvents = function() {
      this.nodes.$parent.off('.modal');
  
      if (this.config.closeOffContentClick) {
        this.$modal.off('.modal');
        this.nodes.$modalContent.off('.modal');
      }
    };
  
    return Modal;
  })();
  
  theme.Drawers = (function() {
    function Drawer(id, name) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };
  
      this.$nodes = {
        parent: $(document.documentElement).add('body'),
        page: $('#MainContent')
      };
  
      this.$drawer = $('#' + id);
  
      if (!this.$drawer.length) {
        return false;
      }
  
      this.isOpen = false;
      this.init();
    };
  
    Drawer.prototype = $.extend({}, Drawer.prototype, {
      init: function() {
        var $openBtn = $(this.config.open);
  
        // Add aria controls
        $openBtn.attr('aria-expanded', 'false');
  
        $openBtn.on('click', this.open.bind(this));
        this.$drawer.find(this.config.close).on('click', this.close.bind(this));
  
        // Close modal if a drawer is opened
        $('body').on('productModalOpen', function() {
          this.close();
        }.bind(this));
      },
  
      open: function(evt, returnFocusEl) {
        if (evt) {
          evt.preventDefault();
        }
  
        if (this.isOpen) {
          return;
        }
  
        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          this.$activeSource = $(evt.currentTarget).attr('aria-expanded', 'true');
        } else if (returnFocusEl) {
          var $el = $(returnFocusEl);
          this.$activeSource = $el.attr('aria-expanded', 'true');
        }
  
        this.$drawer.prepareTransition().addClass(this.config.activeDrawer);
  
        this.$nodes.parent.addClass(this.config.openClass);
        this.isOpen = true;
  
        theme.a11y.trapFocus({
          $container: this.$drawer,
          namespace: 'drawer_focus'
        });
  
        $('body')
          .trigger('drawerOpen')
          .trigger('drawerOpen.' + this.config.id);
  
        this.bindEvents();
      },
  
      close: function() {
        if (!this.isOpen) {
          return;
        }
  
        // deselect any focused form elements
        $(document.activeElement).trigger('blur');
  
        this.$drawer.prepareTransition().removeClass(this.config.activeDrawer);
  
        this.$nodes.parent.removeClass(this.config.openClass);
        this.$nodes.parent.addClass(this.config.closingClass);
        window.setTimeout(function() {
          this.$nodes.parent.removeClass(this.config.closingClass);
          if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
            this.$activeSource.attr('aria-expanded', 'false').focus();
          }
        }.bind(this), 500);
  
        this.isOpen = false;
  
        theme.a11y.removeTrapFocus({
          $container: this.$drawer,
          namespace: 'drawer_focus'
        });
  
        this.unbindEvents();
      },
  
      bindEvents: function() {
        theme.a11y.lockMobileScrolling(this.config.namespace, this.$nodes.page);
  
        // Clicking out of drawer closes it
        this.$nodes.page.on('click' + this.config.namespace, function () {
          this.close();
          return false;
        }.bind(this));
  
        // Pressing escape closes drawer
        this.$nodes.parent.on('keyup' + this.config.namespace, function(evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));
      },
  
      unbindEvents: function() {
        theme.a11y.unlockMobileScrolling(this.config.namespace, this.$nodes.page);
        this.$nodes.parent.off(this.config.namespace);
        this.$nodes.page.off(this.config.namespace);
      }
    });
  
    return Drawer;
  })();
  
  theme.cart = {
    getCart: function() {
      return $.getJSON(theme.routes.cart);
    },
  
    changeItem: function(key, qty) {
      return this._updateCart({
        type: 'POST',
        url: theme.routes.cartChange,
        data: 'quantity=' + qty + '&id=' + key,
        dataType: 'json'
      });
    },
  
    addItemFromForm: function(data) {
      return this._updateCart({
        type: 'POST',
        url: theme.routes.cartAdd,
        data: data,
        dataType: 'json'
      });
    },
  
    _updateCart: function(params) {
      return $.ajax(params)
        .then(function(cart) {
          return cart;
        }.bind(this))
    },
  
    updateNote: function(note) {
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'note=' + theme.cart.attributeToString(note),
        dataType: 'json',
        success: function(cart) {},
        error: function(XMLHttpRequest, textStatus) {}
      };
  
      $.ajax(params);
    },
  
    attributeToString: function(attribute) {
      if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return $.trim(attribute);
    }
  }
  
  $(function() {
    // Add a loading indicator on the cart checkout button (/cart and drawer)
    $('body').on('click', '.cart__checkout', function() {
      $(this).addClass('btn--loading');
    });
  
    $('body').on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();
      theme.cart.updateNote(newNote);
    });
  
  
    // Custom JS to prevent checkout without confirming terms and conditions
    $('body').on('click', '.cart__checkout--ajax', function(evt) {
      if ($('#CartAgree').is(':checked')) {
      } else {
        alert(theme.strings.cartTermsConfirmation);
        $(this).removeClass('btn--loading');
        return false;
      }
    });
  
    $('body').on('click', '.cart__checkout--page', function(evt) {
      if ($('#CartPageAgree').is(':checked')) {
      } else {
        alert(theme.strings.cartTermsConfirmation);
        $(this).removeClass('btn--loading');
        return false;
      }
    });
  });
  
  theme.QtySelector = (function() {
    var classes = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus'
    };
  
    function QtySelector($el, options) {
      this.$wrapper = $el;
      this.$input = $el.find(classes.input);
      this.$plus = $el.find(classes.plus);
      this.$minus = $el.find(classes.minus);
      this.minValue = this.$input.attr('min') || 1;
  
      var defaults = {
        namespace: null,
        key: this.$input.data('id')
      };
  
      this.options = $.extend(defaults, options);
  
      this.initEventListeners();
    };
  
    QtySelector.prototype = $.extend({}, QtySelector.prototype, {
      initEventListeners: function() {
        this.$plus.on('click', function() {
          var qty = this.validateQty(this.$input.val());
          this.addQty(qty);
        }.bind(this));
  
        this.$minus.on('click', function() {
          var qty = this.validateQty(this.$input.val());
          this.subtractQty(qty);
        }.bind(this));
  
        this.$input.on('change', function() {
          var qty = this.validateQty(this.$input.val());
          this.changeQty(qty);
        }.bind(this));
      },
  
      addQty: function(number) {
        var qty = number + 1;
        this.changeQty(qty);
      },
  
      subtractQty: function(number) {
        var qty = number - 1;
        if (qty <= this.minValue) {
          qty = this.minValue;
        }
        this.changeQty(qty);
      },
  
      changeQty: function(qty) {
        this.$input.val(qty);
        $('body').trigger('qty' + this.options.namespace, [this.options.key, qty]);
      },
  
      validateQty: function(number) {
        if((parseFloat(number) == parseInt(number)) && !isNaN(number)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          number = 1;
        }
        return parseInt(number);
      }
    });
  
    return QtySelector;
  })();
  
  theme.CartDrawer = (function() {
    var config = {
      namespace: '.ajaxcart'
    };
  
    var selectors = {
      drawer: '#CartDrawer',
      container: '#CartContainer',
      template: '#CartTemplate',
      cartBubble: '.cart-link__bubble'
    };
  
    function CartDrawer() {
      this.status = {
        loaded: false,
        loading: false
      };
  
      this.drawer = new theme.Drawers('CartDrawer', 'cart');
  
      // Prep handlebars template
      var source = $(selectors.template).html();
      this.template = Handlebars.compile(source);
  
      // Build cart on page load so it's ready in the drawer
      theme.cart.getCart().then(this.buildCart.bind(this));
  
      this.initEventListeners();
    };
  
    CartDrawer.prototype = $.extend({}, CartDrawer.prototype, {
      initEventListeners: function() {
        $('body').on('updateCart' + config.namespace, this.initQtySelectors.bind(this));
        $('body').on('updateCart' + config.namespace, this.updateCartNotification.bind(this));
  
        $('body').on('added.ajaxProduct', function(evt, returnFocusEl) {
          theme.cart.getCart().then(function(cart) {
            this.buildCart(cart, true, returnFocusEl);
          }.bind(this));
        }.bind(this));
      },
  
      buildCart: function(cart, openDrawer, returnFocusEl) {
        this.loading(true);
        this.emptyCart();
  
        if (cart.item_count === 0) {
          $(selectors.container).append('<div class="drawer__scrollable"><p class="appear-animation appear-delay-3">' + theme.strings.cartEmpty +'</p></div>');
        } else {
          var items = [];
          var item = {};
          var data = {};
          var animation_row = 1;
  
          $.each(cart.items, function(index, product) {
  
            var prodImg;
            if (product.image !== null) {
              prodImg = product.image.replace(/(\.[^.]*)$/, "_180x$1");
            } else {
              prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
            }
  
            if (product.properties !== null) {
              $.each(product.properties, function(key, value) {
                if (key.charAt(0) === '_' || !value) {
                   delete product.properties[key];
                 }
              });
            }
  
            // If we have line-item discount, add formattedAmount to discount object
            var amount = 0;
            if (product.line_level_discount_allocations.length !== 0) {
              for (var discount in product.line_level_discount_allocations) {
                amount = product.line_level_discount_allocations[discount].amount;
  
                product.line_level_discount_allocations[discount].formattedAmount = theme.Currency.formatMoney(amount, theme.settings.moneyFormat);
              }
            }
  
            animation_row+=2;
  
            item = {
              key: product.key,
              url: product.url,
              img: prodImg,
              animationRow: animation_row,
              name: product.product_title,
              variation: product.variant_title,
              properties: product.properties,
              itemQty: product.quantity,
              price: theme.Currency.formatMoney(product.price, theme.settings.moneyFormat),
              unitPrice: theme.Currency.formatMoney(product.unit_price, theme.settings.moneyFormat),
              unitBase: theme.Currency.getBaseUnit(product),
              discountedPrice: theme.Currency.formatMoney((product.price - (product.total_discount/product.quantity)), theme.settings.moneyFormat),
              discounts: product.line_level_discount_allocations,
              discountsApplied: product.line_level_discount_allocations.length === 0 ? false : true,
              vendor: product.vendor
            };
  
            items.push(item);
          });
  
          animation_row+=2;
  
          // If we have cart discount, add a formattedAmount to the discount object
          var cartAmount = 0;
          if (cart.cart_level_discount_applications.length !== 0) {
            for (var cartDiscount in cart.cart_level_discount_applications) {
              cartAmount = cart.cart_level_discount_applications[cartDiscount].total_allocated_amount;
  
              cart.cart_level_discount_applications[cartDiscount].formattedAmount = theme.Currency.formatMoney(cartAmount,theme.settings.moneyFormat);
            }
          }
  
          data = {
            items: items,
            note: cart.note,
            lastAnimationRow: animation_row,
            cartDiscounts: cart.cart_level_discount_applications,
            cartDiscountsApplied: cart.cart_level_discount_applications.length === 0 ? false : true,
            totalPrice: theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat)
          };
  
          $(selectors.container).append(this.template(data));
        }
  
        this.status.loaded = true;
        this.loading(false);
  
        $('body').trigger('updateCart' + config.namespace, cart);
  
        if (window.Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
  
        // If specifically asked, open the cart drawer (only happens after product added from form)
        if (openDrawer === true) {
          this.drawer.open(false, returnFocusEl);
        }
      },
  
      initQtySelectors: function() {
        $(selectors.container).find('.js-qty__wrapper').each(function(index, el) {
          var selector = new theme.QtySelector($(el), {
            namespace: '.cart-drawer'
          });
        }.bind(this));
  
        $('body').on('qty.cart-drawer', this.updateItem.bind(this));
      },
  
      updateItem: function(evt, key, qty) {
        if (this.status.loading) {
          return;
        }
  
        this.loading(true);
  
        theme.cart.changeItem(key, qty)
          .then(function(cart) {
            this.updateSuccess(cart);
          }.bind(this))
          .catch(function(XMLHttpRequest) {
            this.updateError(XMLHttpRequest)
          }.bind(this))
          .always(function() {
            this.loading(false);
          }.bind(this));
      },
  
      loading: function(state) {
        this.status.loading = state;
  
        if (state) {
          $(selectors.container).addClass('is-loading');
        } else {
          $(selectors.container).removeClass('is-loading');
        }
      },
  
      emptyCart: function() {
        $(selectors.container).empty();
      },
  
      updateSuccess: function(cart) {
        this.buildCart(cart)
      },
  
      updateError: function(XMLHttpRequest) {
        if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
          // console.warn(XMLHttpRequest.responseJSON.description);
        }
      },
  
      updateCartNotification: function(evt, cart) {
        if (cart.items.length > 0) {
          $(selectors.cartBubble).addClass('cart-link__bubble--visible');
        } else {
          $(selectors.cartBubble).removeClass('cart-link__bubble--visible');
        }
      }
    });
  
    return CartDrawer;
  })();
  
  theme.AjaxProduct = (function() {
    var status = {
      loading: false
    };
  
    function ProductForm($form) {
      this.$form = $form;
      this.$addToCart = this.$form.find('.add-to-cart');
  
      if (this.$form.length) {
        this.$form.on('submit', this.addItemFromForm.bind(this));
      }
    };
  
    ProductForm.prototype = $.extend({}, ProductForm.prototype, {
      addItemFromForm: function(evt, callback){
        evt.preventDefault();
  
        if (status.loading) {
          return;
        }
  
        // Loading indicator on add to cart button
        this.$addToCart.addClass('btn--loading');
  
        status.loading = true;
  
        var data = this.$form.serialize();
  
        theme.cart.addItemFromForm(data)
          .then(function(product) {
            this.success(product);
          }.bind(this))
          .catch(function(XMLHttpRequest) {
            this.error(XMLHttpRequest)
          }.bind(this))
          .always(function() {
            status.loading = false;
            this.$addToCart.removeClass('btn--loading');
          }.bind(this));
      },
  
      success: function(product) {
        this.$form.find('.errors').remove();
        $('body').trigger('added.ajaxProduct', this.$addToCart);
      },
  
      error: function(XMLHttpRequest) {
        this.$form.find('.errors').remove();
  
        if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
          this.$form.prepend('<div class="errors text-center">' + XMLHttpRequest.responseJSON.description + '</div>');
        }
      }
    });
  
    return ProductForm;
  })();
  
  theme.collapsibles = (function() {
  
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner'
    };
  
    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height'
    };
  
    var namespace = '.collapsible';
  
    var isTransitioning = false;
  
    function init() {
      $(selectors.trigger).each(function() {
        var $el = $(this);
        var state = $el.hasClass(classes.open);
        $el.attr('aria-expanded', state);
      });
  
      // Event listeners (hack for modals)
      $('body, .modal__inner')
        .off(namespace)
        .on('click' + namespace, selectors.trigger, function() {
        if (isTransitioning) {
          return;
        }
  
        isTransitioning = true;
  
        var $el = $(this);
        var isOpen = $el.hasClass(classes.open);
        var moduleId = $el.attr('aria-controls');
        var $module = $('#' + moduleId);
        var height = $module.find(selectors.moduleInner).outerHeight();
        var isAutoHeight = $el.hasClass(classes.autoHeight);
  
        // If isAutoHeight, set the height to 0 just after setting the actual height
        // so the closing animation works nicely
        if (isOpen && isAutoHeight) {
          setTimeout(function() {
            height = 0;
            setTransitionHeight($module, height, isOpen, isAutoHeight);
          }, 0);
        }
  
        if (isOpen && !isAutoHeight) {
          height = 0;
        }
  
        $el
          .attr('aria-expanded', !isOpen)
          .toggleClass(classes.open, !isOpen);
  
        setTransitionHeight($module, height, isOpen, isAutoHeight);
      });
    }
  
    function setTransitionHeight($module, height, isOpen, isAutoHeight) {
      $module
        .removeClass(classes.hide)
        .prepareTransition()
        .css('height', height)
        .toggleClass(classes.open, !isOpen);
  
      if (!isOpen && isAutoHeight) {
        var o = $module;
        window.setTimeout(function() {
          o.css('height','auto');
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }
  
    return {
      init: init
    };
  })();
  
  theme.headerNav = (function() {
  
    var $parent = $(document.documentElement).add('body');
    var $page = $('#MainContent');
    var selectors = {
      wrapper: '.header-wrapper',
      siteHeader: '.site-header',
      searchBtn: '.js-search-header',
      closeSearch: '.js-search-header-close',
      searchContainer: '.site-header__search-container',
      logoContainer: '.site-header__logo',
      logo: '.site-header__logo img',
      navigation: '.site-navigation',
      navContainerWithLogo: '.header-item--logo',
      navItems: '.site-nav__item',
      navLinks: '.site-nav__link',
      navLinksWithDropdown: '.site-nav__link--has-dropdown',
      navDropdownLinks: '.site-nav__dropdown-link--second-level'
    };
  
    var classes = {
      hasDropdownClass: 'site-nav--has-dropdown',
      hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
      dropdownActive: 'is-focused'
    };
  
    var config = {
      namespace: '.siteNav',
      wrapperOverlayed: false,
      overlayedClass: 'is-light',
      overlayEnabledClass: 'header-wrapper--overlay',
      stickyEnabled: false,
      stickyActive: false,
      stickyClass: 'site-header--stuck',
      openTransitionClass: 'site-header--opening',
      lastScroll: 0
    };
  
    // Elements used in resize functions, defined in init
    var $window;
    var $navContainerWithLogo;
    var $logoContainer;
    var $nav;
    var $wrapper;
    var $siteHeader;
  
    function init() {
      $window = $(window);
      $navContainerWithLogo = $(selectors.navContainerWithLogo);
      $logoContainer = $(selectors.logoContainer);
      $nav = $(selectors.navigation);
      $wrapper = $(selectors.wrapper);
      $siteHeader = $(selectors.siteHeader);
  
      config.stickyEnabled = $siteHeader.data('sticky');
      if (config.stickyEnabled) {
        config.wrapperOverlayed = $wrapper.hasClass(config.overlayedClass);
        stickyHeader();
      }
  
      theme.settings.overlayHeader = $siteHeader.data('overlay');
      // Disable overlay header if on collection template with no collection image
      if (theme.settings.overlayHeader && Shopify.designMode) {
        if ($('body').hasClass('template-collection') && !$('.collection-hero').length) {
          this.disableOverlayHeader();
        }
      }
  
      accessibleDropdowns();
      searchDrawer();
  
      $window.on('load' + config.namespace, resizeLogo);
      $window.on('resize' + config.namespace, $.debounce(150, resizeLogo));
    }
  
    function unload() {
      $(window).off(config.namespace);
      $(selectors.searchBtn).off(config.namespace);
      $(selectors.closeSearch).off(config.namespace);
      $parent.off(config.namespace);
      $(selectors.navLinks).off(config.namespace);
      $(selectors.navDropdownLinks).off(config.namespace);
    }
  
    function searchDrawer() {
      $(selectors.searchBtn).on('click' + config.namespace, function(evt) {
        evt.preventDefault();
        openSearchDrawer();
      });
  
      $(selectors.closeSearch).on('click' + config.namespace, function() {
        closeSearchDrawer();
      });
    }
  
    function openSearchDrawer() {
      $(selectors.searchContainer).addClass('is-active');
      $parent.addClass('js-drawer-open js-drawer-open--search');
  
      theme.a11y.trapFocus({
        $container: $(selectors.searchContainer),
        namespace: 'header_search',
        $elementToFocus: $(selectors.searchContainer).find('input')
      });
  
      // If sticky is enabled, scroll to top on mobile when close to it
      // so you don't get an invisible search box
      if (theme.config.bpSmall && config.stickyEnabled && config.lastScroll < 300) {
        window.scrollTo(0,0);
      }
  
      // Bind events
      theme.a11y.lockMobileScrolling(config.namespace);
  
      // Clicking out of container closes it
      $page.on('click' + config.namespace, function () {
        closeSearchDrawer();
        return false;
      });
  
      $parent.on('keyup' + config.namespace, function(evt) {
        if (evt.keyCode === 27) {
          closeSearchDrawer();
        }
      });
    }
  
    function closeSearchDrawer() {
      // deselect any focused form elements
      $(document.activeElement).trigger('blur');
  
      $parent.removeClass('js-drawer-open js-drawer-open--search').off(config.namespace);
      $(selectors.searchContainer).removeClass('is-active');
  
      theme.a11y.removeTrapFocus({
        $container: $(selectors.searchContainer),
        namespace: 'header_search'
      });
  
      theme.a11y.unlockMobileScrolling(config.namespace);
      $page.off('click' + config.namespace);
      $parent.off('keyup' + config.namespace);
    }
  
    function resizeLogo() {
      // Using .each() as there can be a reversed logo too
      $(selectors.logo).each(function() {
        var $el = $(this),
            logoWidthOnScreen = $el.width(),
            containerWidth = $el.closest('.grid__item').width();
        // If image exceeds container, let's make it smaller
        if (logoWidthOnScreen > containerWidth) {
          $el.css('maxWidth', containerWidth);
        }
        else {
          $el.removeAttr('style');
        }
      });
    }
  
    function accessibleDropdowns() {
      var hasActiveDropdown = false;
      var hasActiveSubDropdown = false;
      var closeOnClickActive = false;
  
      // Touch devices open dropdown on first click, navigate to link on second
      if (theme.config.isTouch) {
        $(selectors.navLinksWithDropdown).on('touchend' + config.namespace, function(evt) {
          var $el = $(this);
          var $parentItem = $el.parent();
          if (!$parentItem.hasClass(classes.dropdownActive)) {
            evt.preventDefault();
            closeDropdowns();
            openFirstLevelDropdown($el);
          } else {
            window.location.replace($el.attr('href'));
          }
        });
  
        $(selectors.navDropdownLinks).on('touchend' + config.namespace, function(evt) {
          var $el = $(this);
          var $parentItem = $el.parent();
  
          // Open third level menu or go to link based on active state
          if ($parentItem.hasClass(classes.hasSubDropdownClass)) {
            if (!$parentItem.hasClass(classes.dropdownActive)) {
              evt.preventDefault();
              closeThirdLevelDropdown();
              openSecondLevelDropdown($el);
            } else {
              window.location.replace($el.attr('href'));
            }
          } else {
            // No third level nav, go to link
            window.location.replace($el.attr('href'));
          }
        });
      }
  
      // Open/hide top level dropdowns
      $(selectors.navLinks).on('focusin mouseover' + config.namespace, function() {
        if (hasActiveDropdown) {
          closeSecondLevelDropdown();
        }
  
        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }
  
        openFirstLevelDropdown($(this));
      });
  
      // Force remove focus on sitenav links because focus sometimes gets stuck
      $(selectors.navLinks).on('mouseleave' + config.namespace, function() {
        closeDropdowns();
      });
  
      // Open/hide sub level dropdowns
      $(selectors.navDropdownLinks).on('focusin' + config.namespace, function() {
        closeThirdLevelDropdown();
        openSecondLevelDropdown($(this), true);
      });
  
      // Private dropdown methods
      function openFirstLevelDropdown($el) {
        var $parentItem = $el.parent();
        if ($parentItem.hasClass(classes.hasDropdownClass)) {
          $parentItem.addClass(classes.dropdownActive);
          hasActiveDropdown = true;
        }
  
        if (!theme.config.isTouch) {
          if (!closeOnClickActive) {
            var eventType = theme.config.isTouch ? 'touchend' : 'click';
            closeOnClickActive = true;
            $('body').on(eventType + config.namespace, function() {
              closeDropdowns();
              $('body').off(config.namespace);
              closeOnClickActive = false;
            });
          }
        }
      }
  
      function openSecondLevelDropdown($el, skipCheck) {
        var $parentItem = $el.parent();
        if ($parentItem.hasClass(classes.hasSubDropdownClass) || skipCheck) {
          $parentItem.addClass(classes.dropdownActive);
          hasActiveSubDropdown = true;
        }
      }
  
      function closeDropdowns() {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      }
  
      function closeSecondLevelDropdown() {
        $(selectors.navItems).removeClass(classes.dropdownActive);
      }
  
      function closeThirdLevelDropdown() {
        $(selectors.navDropdownLinks).parent().removeClass(classes.dropdownActive);
      }
    }
  
    function stickyHeader() {
      config.lastScroll = 0;
      $siteHeader.wrap('<div class="site-header-sticky"></div>');
  
      stickyHeaderHeight();
      $window.on('resize' + config.namespace, $.debounce(50, stickyHeaderHeight));
      $window.on('scroll' + config.namespace, $.throttle(15, stickyHeaderScroll));
  
      // This gets messed up in the editor, so here's a fix
      if (Shopify && Shopify.designMode) {
        setTimeout(function() {
          stickyHeaderHeight();
        }, 250);
      }
    }
  
    function stickyHeaderHeight() {
      var $stickyHeader = $('.site-header-sticky').css('height', $siteHeader.outerHeight(true));
    }
  
    function stickyHeaderScroll() {
      var scroll = $window.scrollTop();
      var threshold = 250;
  
      if (scroll > threshold) {
        if (config.stickyActive) {
          return;
        }
  
        config.stickyActive = true;
  
        $siteHeader.addClass(config.stickyClass);
        if (config.wrapperOverlayed) {
          $wrapper.removeClass(config.overlayedClass);
        }
  
        // Add open transition class after element is set to fixed
        // so CSS animation is applied correctly
        setTimeout(function() {
          $siteHeader.addClass(config.openTransitionClass);
        }, 100);
      } else {
        if (!config.stickyActive) {
          return;
        }
  
        config.stickyActive = false;
  
        $siteHeader.removeClass(config.openTransitionClass).removeClass(config.stickyClass);
        if (config.wrapperOverlayed) {
          $wrapper.addClass(config.overlayedClass);
        }
      }
  
      config.lastScroll = scroll;
    }
  
    // If the header setting to overlay the menu on the collection image
    // is enabled but the collection setting is disabled, we need to undo
    // the init of the sticky nav
    function disableOverlayHeader() {
      $(selectors.wrapper)
        .removeClass(config.overlayEnabledClass)
        .removeClass(config.overlayedClass);
      config.wrapperOverlayed = false;
    }
  
    return {
      init: init,
      disableOverlayHeader: disableOverlayHeader,
      unload: unload
    };
  })();
  
  theme.articleImages = (function() {
  
    var cache = {};
  
    function init() {
      cache.$rteImages = $('.rte--indented-images');
  
      if (!cache.$rteImages.length) {
        return;
      }
  
      $(window).on('load', setImages);
    }
  
    function setImages() {
      cache.$rteImages.find('img').each(function() {
        var $el = $(this);
        var attr = $el.attr('style');
  
        // Check if undefined or float: none
        if (!attr || attr == 'float: none;') {
          // Remove grid-breaking styles if image isn't wider than parent
          if ($el.width() < cache.$rteImages.width()) {
            $el.addClass('rte__no-indent');
          }
        }
      });
    }
  
    return {
      init: init
    };
  })();
  
  theme.Slideshow = (function() {
    this.$slideshow = null;
  
    var classes = {
      next: 'is-next',
      init: 'is-init',
      animateOut: 'animate-out',
      wrapper: 'slideshow-wrapper',
      slideshow: 'slideshow',
      allSlides: 'slick-slide',
      currentSlide: 'slick-current',
      pauseButton: 'slideshow__pause',
      isPaused: 'is-paused'
    };
  
    function slideshow(el, args) {
      this.$slideshow = $(el);
      this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
      this.$pause = this.$wrapper.find('.' + classes.pauseButton);
  
      this.settings = {
        accessibility: true,
        arrows: args.arrows ? true : false,
        dots: args.dots ? true : false,
        fade: args.fade ? true : false,
        speed: args.speed ? args.speed : 500,
        draggable: true,
        touchThreshold: 5,
        pauseOnHover: false,
        autoplay: this.$slideshow.data('autoplay'),
        autoplaySpeed: this.$slideshow.data('speed'),
        variableWidth: args.variableWidth ? true : false
      };
  
      this.$slideshow.on('init', this.init.bind(this));
      if (this.settings.fade) {
        this.$slideshow.on('beforeChange', this.beforeSlideChange.bind(this));
        this.$slideshow.on('afterChange', this.afterSlideChange.bind(this));
      }
  
      this.$slideshow.slick(this.settings);
  
      this.$pause.on('click', this._togglePause.bind(this));
    }
  
    slideshow.prototype = $.extend({}, slideshow.prototype, {
      init: function(event, obj) {
        this.$slideshowList = obj.$list;
        this.$slickDots = obj.$dots;
        this.$allSlides = obj.$slides;
        this.slideCount = obj.slideCount;
  
        this.$slideshow.addClass(classes.init);
        this._a11y();
        this._clonedLazyloading();
      },
      beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find('.' + classes.currentSlide).addClass(classes.animateOut);
      },
      afterSlideChange: function(event, slick, currentSlide) {
        var $slider = slick.$slider;
        var $allSlides = $slider.find('.' + classes.allSlides).removeClass(classes.animateOut);
      },
      destroy: function() {
        this.$slideshow.slick('unslick');
      },
  
      // Playback
      _play: function() {
        this.$slideshow.slick('slickPause');
        $(classes.pauseButton).addClass('is-paused');
      },
      _pause: function() {
        this.$slideshow.slick('slickPlay');
        $(classes.pauseButton).removeClass('is-paused');
      },
      _togglePause: function() {
        var slideshowSelector = this._getSlideshowId(this.$pause);
        if (this.$pause.hasClass(classes.isPaused)) {
          this.$pause.removeClass(classes.isPaused);
          $(slideshowSelector).slick('slickPlay');
        } else {
          this.$pause.addClass(classes.isPaused);
          $(slideshowSelector).slick('slickPause');
        }
      },
  
      // Helpers
      _getSlideshowId: function($el) {
        return '#Slideshow-' + $el.data('id');
      },
      _activeSlide: function() {
        return this.$slideshow.find('.slick-active');
      },
      _currentSlide: function() {
        return this.$slideshow.find('.slick-current');
      },
      _nextSlide: function(index) {
        return this.$slideshow.find('.slideshow__slide[data-slick-index="' + index + '"]');
      },
  
      // a11y fixes
      _a11y: function() {
        var $list = this.$slideshowList;
        var autoplay = this.settings.autoplay;
  
        if (!$list) {
          return;
        }
  
        // Remove default Slick aria-live attr until slider is focused
        $list.removeAttr('aria-live');
  
        // When an element in the slider is focused
        // pause slideshow and set aria-live
        $(classes.wrapper).on('focusin', function(evt) {
          if (!$(classes.wrapper).has(evt.target).length) {
            return;
          }
  
          $list.attr('aria-live', 'polite');
          if (autoplay) {
            this._pause();
          }
        }.bind(this));
  
        // Resume autoplay
        $(classes.wrapper).on('focusout', function(evt) {
          if (!$(classes.wrapper).has(evt.target).length) {
            return;
          }
  
          $list.removeAttr('aria-live');
          if (autoplay) {
            this._play();
          }
        }.bind(this));
      },
  
      // Make sure lazyloading works on cloned slides
      _clonedLazyloading: function() {
        var $slideshow = this.$slideshow;
  
        $slideshow.find('.slick-slide').each(function(index, el) {
          var $slide = $(el);
          if ($slide.hasClass('slick-cloned')) {
            var slideId = $slide.data('id');
            var $slideImg = $slide.find('.hero__image').removeClass('lazyloading').addClass('lazyloaded');
  
            // Get inline style attribute from non-cloned slide with arbitrary timeout
            // so the image is loaded
            setTimeout(function() {
              var loadedImageStyle = $slideshow.find('.slideshow__slide--' + slideId + ':not(.slick-cloned) .hero__image').attr('style');
  
              if (loadedImageStyle) {
                $slideImg.attr('style', loadedImageStyle);
              }
  
            }, this.settings.autoplaySpeed / 1.5);
  
          }
        }.bind(this));
      }
    });
  
    return slideshow;
  })();
  
  theme.announcementBar = (function() {
    var selectors = {
      bar: '.announcement',
      text: '.announcement__text',
      closeBtn: '.announcement__close'
    };
  
    var classes = {
      opening: 'announcement--opening',
      closed: 'announcement--closed'
    };
  
    var config = {
      namespace: '.announcementBar'
    };
  
    function init() {
      if (!$(selectors.closeBtn).length) {
        return;
      }
  
      if (theme.config.hasSessionStorage && sessionStorage[announcementBarText()] !== 'hidden') {
        window.setTimeout(function() {
          announcementBarShow();
        }, 2000);
      }
  
      // Probably in the editor, so show it anyway
      if (!theme.config.hasSessionStorage) {
        window.setTimeout(function() {
          announcementBarShow();
        }, 2000);
      }
  
      $(selectors.closeBtn).on('click', function(evt) {
        evt.preventDefault();
        announcementBarClose();
      });
  
      $(window).on('resize' + config.namespace, $.debounce(150, announcementBarHeight));
    }
  
    function unload() {
      $(window).off(config.namespace);
    }
  
    function announcementBarShow() {
      $(selectors.bar).removeClass(classes.closed);
      announcementBarHeight();
    }
  
    function announcementBarHeight() {
      var barHeight = $(selectors.text).outerHeight(true);
      $(selectors.bar).addClass(classes.opening).css({'max-height': barHeight});
    }
  
    function announcementBarClose() {
      if (theme.config.hasSessionStorage) {
        sessionStorage.setItem(announcementBarText(), 'hidden');
      }
  
      $(selectors.bar).addClass(classes.closed);
    }
  
    function announcementBarText() {
      return $(selectors.text).data('text');
    }
  
    return {
      init: init,
      unload: unload
    };
  })();
  
  theme.predictiveSearch = (function() {
    var currentString = '';
    var isLoading = false;
    var searchTimeout;
    var namespace = '.predictive';
  
    var selectors = {
      form: '#HeaderSearchForm',
      input: 'input[type="search"]',
      wrapper: '.predictive-results',
  
      searchButton: '[data-predictive-search-button]',
      searchTerm: '[data-predictive-search-term]',
  
      resultDiv: '#PredictiveResults',
      resultTemplate: '#PredictiveTemplate'
    };
  
    var classes = {
      isActive: 'predicitive-active'
    };
  
    var keys = {
      up_arrow: 38,
      down_arrow: 40,
      tab: 9
    };
  
    function init() {
      if (!theme.settings.predictiveSearch) {
        return;
      }
  
      // Only some languages support predictive search
      if (document.getElementById('shopify-features')) {
        var supportedShopifyFeatures = JSON.parse(document.getElementById('shopify-features').innerHTML);
        if (!supportedShopifyFeatures.predictiveSearch) {
          return;
        }
      }
  
      $(selectors.form).attr('autocomplete', 'off');
      $(selectors.form).on('submit' + namespace, submitSearch);
  
      $(selectors.input, selectors.form).on('keyup' + namespace, handleKeyup);
      $(selectors.searchButton, selectors.wrapper).on('click' + namespace, triggerSearch);
  
      // Prep handlebars template
      var source = $(selectors.resultTemplate).html();
      resultTemplate = Handlebars.compile(source);
    }
  
    function reset() {
      $(selectors.wrapper).addClass('hide');
      clearTimeout(searchTimeout);
    }
  
    function triggerSearch() {
      $(selectors.form).trigger('submit');
    }
  
    // Append * wildcard to search
    function submitSearch(evt) {
      var $form = $(this);
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
  
      var data = $form.serializeArray().reduce(function(obj, item) {
        obj[item.name] = item.value;
        return obj;
      }, {});
  
      if (data.q) {
        data.q += '*';
      }
  
      var query = $.param(data);
  
      window.location.href = '/search?' + query;
      return false;
    }
  
    function handleKeyup(evt) {
      if (evt.keyCode === keys.up_arrow) {
        navigationEvent(evt, 'up');
        return;
      }
  
      if (evt.keyCode === keys.down_arrow) {
        navigationEvent(evt, 'down');
        return;
      }
  
      if (evt.keyCode === keys.tab) {
        return;
      }
  
      search();
    }
  
    function search() {
      var keyword = $(selectors.input, selectors.form).val();
  
      if (keyword === '') {
        reset();
        return;
      }
  
      var q = _normalizeQuery(keyword);
  
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(
        function () {
          predictQuery(q);
        }.bind(this),
        500
      );
    }
  
    function predictQuery(q) {
      if (isLoading) {
        return;
      }
  
      // Do not re-search the same thing
      if (currentString === q) {
        return;
      }
  
      currentString = q;
      isLoading = true;
  
      jQuery.getJSON('/search/suggest.json', {
        "q": q,
        "resources": {
          "type": theme.settings.predictiveSearchType,
          "limit": 3,
          "options": {
            "unavailable_products": "last",
            "fields": "title,product_type,variants.title,vendor"
          }
        }
      }).done(function(response) {
        isLoading = false;
        var data = {};
        var resultCount = 0;
  
        $(selectors.wrapper).removeClass('hide');
  
        var resultTypes = Object.entries(response.resources.results);
  
        for (var i = resultTypes.length - 1; i >= 0; i--) {
          var obj = resultTypes[i];
          var type = obj[0];
          var results = obj[1];
          resultCount += results.length;
  
          switch(type) {
            case 'products':
              data[type] = buildProducts(results);
              break;
            default:
              data[type] = parseResultImages(results);
              break;
          }
        }
  
        if (resultCount === 0) {
          reset();
        }
        
        console.log(data);
  
        // Append result markup
        $(selectors.resultDiv).empty().append(resultTemplate(data));
  
        // Update 'search' term text
        $(selectors.searchTerm, selectors.wrapper).text(q);
      });
    }
  
    function buildProducts(results) {
      var products = [];
  
      for (var i = results.length - 1; i >= 0; i--) {
        var product = results[i];
  
        var new_product = {
          title: product.title,
          url: product.url,
          image: theme.Images.getSizedImageUrl(product.image, '200x200_crop_center'),
          vendor: product.vendor,
          price: theme.Currency.formatMoney(product.price),
          compare_price_max: theme.Currency.formatMoney(product.compare_at_price_max),
          on_sale: parseInt(product.compare_at_price_max) > parseInt(product.price),
          hide_price: product.tags.indexOf('Hide Price') !== -1,
          hide_balanced_body: product.vendor.indexOf('Balanced Body') !== -1
        };
  
        products.push(new_product);
      }
  
      return products;
    }
  
    // Overwrite full sized image returned form API
    // with lazyloading-friendly path
    function parseResultImages(results) {
      for (var i = results.length - 1; i >= 0; i--) {
        if (!results[i].image) {
          continue;
        }
  
        var image = theme.Images.getSizedImageUrl(results[i].image, '200x200_crop_center');
  
        results[i].image = image;
      }
  
      return results;
    }
  
    function _normalizeQuery(string) {
      if (typeof string !== 'string') {
        return null;
      }
  
      return string
        .trim()
        .replace(/\ /g, '-')
        .toLowerCase();
    }
  
    function navigationEvent(evt, direction) {
  
    }
  
    return {
      init: init
    };
  })();
  
  theme.initQuickShop = function(reinit) {
    var ids = [];
    var $buttons = $('.quick-product__btn');
  
    $buttons.each(function() {
      var id = $(this).data('product-id');
      var modalId = 'QuickShopModal-' + id;
      var name = 'quick-modal-' + id;
  
      // If another identical modal exists, remove duplicates
      if (ids.indexOf(id) > -1) {
        $('.modal--quick-shop[data-product-id="'+ id +'"]').each(function(i) {
          if (i > 0) {
            $(this).remove();
          }
        });
        return;
      }
  
      new theme.Modals(modalId, name);
      ids.push(id);
    });
  };
  
  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  theme.videoModal = function() {
    var youtubePlayer = null;
    var videoOptions = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        branding: 0,
        cc_load_policy: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      },
      events: {
        onReady: onPlayerReady
      }
    };
  
    var videoHolderId = 'VideoHolder';
    var activeVideo = false;
  
    var selectors = {
      videoHolder: '#' + videoHolderId,
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      mp4Trigger: '.product-video-trigger--mp4',
      mp4Player: '.product-video-mp4-sound'
    };
  
    if (!$(selectors.youtube).length && !$(selectors.mp4Trigger).length) {
      return;
    }
  
    var modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true,
      solid: true
    });
  
    $(selectors.youtube).on('click', triggerYouTubeModal);
    $(selectors.mp4Trigger).on('click', triggerMp4Modal);
  
    // Handle closing video modal
    $('body').on('modalClose.VideoModal', function() {
      // Slight timeout so YouTube player is destroyed after the modal closes
      if (youtubePlayer && activeVideo === 'youtube') {
        setTimeout(function() {
          youtubePlayer.destroy();
        }, 500); // modal close css transition
      } else {
        emptyVideoHolder();
      }
    });
  
    function triggerYouTubeModal(evt) {
      emptyVideoHolder();
  
      evt.preventDefault();
      theme.LibraryLoader.load('youtubeSdk');
  
      if (theme.config.youTubeReady) {
        startYoutubeOnClick(evt);
      } else {
        $('body').on('youTubeReady', function() {
          startYoutubeOnClick(evt);
        });
      }
    }
  
    function triggerMp4Modal(evt) {
      emptyVideoHolder();
  
      var $el = $(evt.currentTarget);
      var $mp4Player = $el.next(selectors.mp4Player);
  
      $mp4Player.clone().removeClass('hide').appendTo(selectors.videoHolder);
  
      modal.open(evt);
  
      // Play new video element
      $(selectors.videoHolder).find('video')[0].play();
  
      activeVideo = 'mp4';
    }
  
    function startYoutubeOnClick(evt) {
      var $el = $(evt.currentTarget);
      var videoId = getYoutubeVideoId($el.attr('href'));
  
      var args = $.extend({}, videoOptions, {
        videoId: videoId
      });
  
      // Disable plays inline on mobile
      args.playerVars.playsinline = theme.config.bpSmall ? 0 : 1;
  
      youtubePlayer = new YT.Player(videoHolderId, args);
      modal.open(evt);
  
      activeVideo = 'youtube';
    }
  
    function onPlayerReady(evt) {
      evt.target.playVideo();
    }
  
    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
    }
  
    function emptyVideoHolder() {
      $(selectors.videoHolder).empty();
    }
  };
  
  
  theme.parallaxSections = {};
  
  theme.Parallax = (function() {
    var speed = 7; // higher is slower
  
    function parallax(el, args) {
      this.$container = $(el);
      this.namespace = args.namespace;
  
      if (!this.$container.length) {
        return;
      }
  
      if (args.desktopOnly) {
        this.desktopInit();
      } else {
        this.init(this.$container, args)
      }
    }
  
    parallax.prototype = $.extend({}, parallax.prototype, {
      init: function(desktopOnly) {
        var $window = this.$window = $(window);
        var elTop = this.$container.offset().top;
  
        $window.on('scroll' + this.namespace, function(evt) {
          var scrolled = $window.scrollTop();
          var shiftDistance = (elTop - scrolled) / speed;
          this.$container.css({
            'transform': 'translate3d(0, ' + shiftDistance + 'px, 0)'
          });
        }.bind(this));
  
        // Reinit on resize
        $window.on('resize' + this.namespace, $.debounce(350, function() {
          $window.off(this.namespace);
  
          if (desktopOnly) {
            if (!theme.config.bpSmall) {
              this.init(true);
              return;
            }
          }
  
          this.init();
        }.bind(this)));
      },
  
      desktopInit: function() {
        if (!theme.config.bpSmall) {
          this.init(true);
        }
  
        $('body').on('matchSmall', function() {
          this.destroy();
        }.bind(this));
  
        $('body').on('matchLarge', function() {
          this.init(true);
        }.bind(this));
      },
  
      destroy: function() {
        this.$container.removeAttr('style');
        this.$window.off(this.namespace);
      }
    });
  
    return parallax;
  })();
  
  // Shopify-built select-like popovers for currency and language selection
  theme.Disclosure = (function() {
    var selectors = {
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]'
    };
  
    var classes = {
      listVisible: 'disclosure-list--visible'
    };
  
    function Disclosure($disclosure) {
      this.$container = $disclosure;
      this.cache = {};
      this._cacheSelectors();
      this._connectOptions();
      this._connectToggle();
      this._onFocusOut();
    }
  
    Disclosure.prototype = $.extend({}, Disclosure.prototype, {
      _cacheSelectors: function() {
        this.cache = {
          $disclosureList: this.$container.find(selectors.disclosureList),
          $disclosureToggle: this.$container.find(selectors.disclosureToggle),
          $disclosureInput: this.$container.find(selectors.disclosureInput),
          $disclosureOptions: this.$container.find(selectors.disclosureOptions)
        };
      },
  
      _connectToggle: function() {
        this.cache.$disclosureToggle.on(
          'click',
          function(evt) {
            var ariaExpanded =
              $(evt.currentTarget).attr('aria-expanded') === 'true';
            $(evt.currentTarget).attr('aria-expanded', !ariaExpanded);
  
            this.cache.$disclosureList.toggleClass(classes.listVisible);
          }.bind(this)
        );
      },
  
      _connectOptions: function() {
        this.cache.$disclosureOptions.on(
          'click',
          function(evt) {
            evt.preventDefault();
            this._submitForm($(evt.currentTarget).data('value'));
          }.bind(this)
        );
      },
  
      _onFocusOut: function() {
        this.cache.$disclosureToggle.on(
          'focusout',
          function(evt) {
            var disclosureLostFocus =
              this.$container.has(evt.relatedTarget).length === 0;
  
            if (disclosureLostFocus) {
              this._hideList();
            }
          }.bind(this)
        );
  
        this.cache.$disclosureList.on(
          'focusout',
          function(evt) {
            var childInFocus =
              $(evt.currentTarget).has(evt.relatedTarget).length > 0;
            var isVisible = this.cache.$disclosureList.hasClass(
              classes.listVisible
            );
  
            if (isVisible && !childInFocus) {
              this._hideList();
            }
          }.bind(this)
        );
  
        this.$container.on(
          'keyup',
          function(evt) {
            if (evt.which !== 27) return;
            this._hideList();
            this.cache.$disclosureToggle.focus();
          }.bind(this)
        );
  
        $('body').on(
          'click',
          function(evt) {
            var isOption = this.$container.has(evt.target).length > 0;
            var isVisible = this.cache.$disclosureList.hasClass(
              classes.listVisible
            );
  
            if (isVisible && !isOption) {
              this._hideList();
            }
          }.bind(this)
        );
      },
  
      _submitForm: function(value) {
        $('body').addClass('unloading');
        this.cache.$disclosureInput.val(value);
        this.$container.parents('form').submit();
      },
  
      _hideList: function() {
        this.cache.$disclosureList.removeClass(classes.listVisible);
        this.cache.$disclosureToggle.attr('aria-expanded', false);
      },
  
      unload: function() {
        this.cache.$disclosureOptions.off();
        this.cache.$disclosureToggle.off();
        this.cache.$disclosureList.off();
        this.$container.off();
      }
    });
  
    return Disclosure;
  })();
  
  theme.ProductMedia = (function() {
    var modelJsonSections = {};
    var models = {};
    var xrButtons = {};
  
    var selectors = {
      mediaGroup: '[data-product-single-media-group]',
      xrButton: '[data-shopify-xr]'
    };
  
    function init(modelViewerContainers, sectionId) {
      modelJsonSections[sectionId] = {
        loaded: false
      };
  
      modelViewerContainers.each(function(index) {
        var $modelViewerContainer = $(this);
        var mediaId = $modelViewerContainer.data('media-id');
        var $modelViewerElement = $(
          $modelViewerContainer.find('model-viewer')[0]
        );
        var modelId = $modelViewerElement.data('model-id');
  
        if (index === 0) {
          var $xrButton = $modelViewerContainer
            .closest(selectors.mediaGroup)
            .find(selectors.xrButton);
          xrButtons[sectionId] = {
            $element: $xrButton,
            defaultId: modelId
          };
        }
  
        models[mediaId] = {
          modelId: modelId,
          sectionId: sectionId,
          $container: $modelViewerContainer,
          $element: $modelViewerElement
        };
      });
  
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: setupShopifyXr
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: setupModelViewerUi
        }
      ]);
  
      theme.LibraryLoader.load('modelViewerUiStyles');
    }
  
    function setupShopifyXr(errors) {
      if (errors) return;
  
      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', function() {
          setupShopifyXr();
        });
        return;
      }
  
      for (var sectionId in modelJsonSections) {
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          var modelSection = modelJsonSections[sectionId];
  
          if (modelSection.loaded) continue;
          var $modelJson = $('#ModelJson-' + sectionId);
  
          window.ShopifyXR.addModels(JSON.parse($modelJson.html()));
          modelSection.loaded = true;
        }
      }
      window.ShopifyXR.setupXRElements();
    }
  
    function setupModelViewerUi(errors) {
      if (errors) return;
  
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (!model.modelViewerUi) {
            model.modelViewerUi = new Shopify.ModelViewerUI(model.$element);
          }
          setupModelViewerListeners(model);
        }
      }
    }
  
    function setupModelViewerListeners(model) {
      var xrButton = xrButtons[model.sectionId];
      model.$container.on('mediaVisible', function() {
        xrButton.$element.attr('data-shopify-model3d-id', model.modelId);
        if (theme.config.isTouch) return;
        model.modelViewerUi.play();
      });
  
      model.$container
        .on('mediaHidden', function() {
          xrButton.$element.attr('data-shopify-model3d-id', xrButton.defaultId);
          model.modelViewerUi.pause();
        })
        .on('xrLaunch', function() {
          model.modelViewerUi.pause();
        });
    }
  
    function removeSectionModels(sectionId) {
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (model.sectionId === sectionId) {
            delete models[key];
          }
        }
      }
      delete modelJsonSections[sectionId];
    }
  
    return {
      init: init,
      removeSectionModels: removeSectionModels
    };
  })();
  

  theme.customerTemplates = (function() {
  
    function initEventListeners() {
      // Show reset password form
      $('#RecoverPassword').on('click', function(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
  
      // Hide reset password form
      $('#HideRecoverPasswordLink').on('click', function(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
    }
  
    /**
     *
     *  Show/Hide recover password form
     *
     */
    function toggleRecoverPasswordForm() {
      $('#RecoverPasswordForm').toggleClass('hide');
      $('#CustomerLoginForm').toggleClass('hide');
    }
  
    /**
     *
     *  Show reset password success message
     *
     */
    function resetPasswordSuccess() {
      var $formState = $('.reset-password-success');
  
      // check if reset password form was successfully submitted
      if (!$formState.length) {
        return;
      }
  
      // show success message
      $('#ResetSuccess').removeClass('hide');
    }
  
    /**
     *
     *  Show/hide customer address forms
     *
     */
    function customerAddressForm() {
      var $newAddressForm = $('#AddressNewForm');
      var $addressForms = $('.js-address-form');
  
      if (!$newAddressForm.length || !$addressForms.length) {
        return;
      }
  
      if (Shopify) {
        $('.js-address-country').each(function() {
          var $container = $(this);
          var countryId = $container.data('country-id');
          var provinceId = $container.data('province-id');
          var provinceContainerId = $container.data('province-container-id');
  
          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }
  
      // Toggle new/edit address forms
      $('.address-new-toggle').on('click', function() {
        $newAddressForm.toggleClass('hide');
      });
  
      $('.address-edit-toggle').on('click', function() {
        var formId = $(this).data('form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
      });
  
      $('.address-delete').on('click', function() {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');
  
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
          Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
        }
      });
    }
  
    /**
     *
     *  Check URL for reset password hash
     *
     */
    function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
  
    return {
      init: function() {
        checkUrlHash();
        initEventListeners();
        resetPasswordSuccess();
        customerAddressForm();
      }
    };
  })();
  

  theme.Product = (function() {
  
    var classes = {
      onSale: 'sale-price',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      hidden: 'hide',
      interactable: 'video-interactable',
      visuallyHide: 'visually-invisible'
    };
  
    var selectors = {
      productVideo: '.product__video',
      videoParent: '.product__video-wrapper',
      currentSlide: '.slick-current',
      startingSlide: '.starting-slide'
    };
  
    var youtubeReady;
    var videos = {};
    var youtubePlayers = [];
    var youtubeVideoOptions = {
      height: '480',
      width: '850',
      playerVars :{
        autohide: 0,
        autoplay: 0,
        branding: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      }
    };
  
    function onVideoPlayerReady(evt, id) {
      var $player = $('#' + id);
      var playerId = $player.attr('id');
      youtubePlayers[playerId] = evt.target; // update stored player
      var player = youtubePlayers[playerId];
  
      setParentAsLoading($player);
  
      if (videos[playerId].style === 'muted') {
        youtubePlayers[playerId].mute();
      } else {
        setParentAsLoaded($player);
      }
  
      // If first slide or only photo, start video
      if ($player.closest(selectors.startingSlide).length || $player.data('image-count') === 1) {
        if (videos[playerId].style === 'muted') {
          youtubePlayers[playerId].playVideo();
          initCheckVisibility(playerId);
        }
      }
    }

    function onMobVideoPlayerReady(evt, id) {
      var $player = $('#' + id);
      var playerId = $player.attr('id');
      mob_youtubePlayers[playerId] = evt.target; // update stored player
      var player = mob_youtubePlayers[playerId];
  
      setParentAsLoading($player);
  
      if (mob_videos[playerId].style === 'muted') {
        mob_youtubePlayers[playerId].mute();
      } else {
        setParentAsLoaded($player);
      }
  
      // If first slide or only photo, start video
      if ($player.closest(selectors.startingSlide).length || $player.data('image-count') === 1) {
        if (mob_videos[playerId].style === 'muted') {
          mob_youtubePlayers[playerId].playVideo();
          initCheckVisibility(playerId);
        }
      }
    }
  
    function initCheckVisibility(playerId) {
      // Add out of view pausing
      videoVisibilityCheck(playerId);
      $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
    }
  
    function videoVisibilityCheck(id) {
      var playerId;
  
      if (typeof id === 'string') {
        playerId = id;
      } else {
        // Data comes in as part of the scroll event
        if (!id.data) {return}
        playerId = id.data.id;
      }
  
      if (theme.isElementVisible($('#' + playerId))) {
        if (videos[playerId] && videos[playerId].style === 'unmuted') {
          return;
        }
        playVisibleVideo(playerId);
      } else {
        pauseHiddenVideo(playerId);
      }
    }
  
    function playVisibleVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
        youtubePlayers[id].playVideo();
      }
    }
  
    function pauseHiddenVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
        youtubePlayers[id].pauseVideo();
      }
    }
  
    function onVideoStateChange(evt, id) {
      var $player = $('#' + id);
      var playerId = $player.attr('id');
      var player = youtubePlayers[playerId];
  
      switch (evt.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (videos[playerId].attemptedToPlay) {
            setParentAsLoaded($player);
            setVideoToBeInteractedWith($player);
          }
          break;
        case 0: // ended
          if (videos[playerId] && videos[playerId].loop) {
            player.playVideo();
          }
          break;
        case 1: // playing
          setParentAsLoaded($player);
          break;
        case 3: // buffering
          videos[playerId].attemptedToPlay = true;
          break;
      }
    }
  
    function setParentAsLoading($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.loading);
    }
  
    function setParentAsLoaded($el) {
      $el
        .closest(selectors.videoParent)
        .removeClass(classes.loading)
        .addClass(classes.loaded);
    }
  
    function setVideoToBeInteractedWith($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.interactable);
    }
  
    function Product(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
  
      this.inModal = $container.closest('.modal').length;
      this.$modal;
  
      this.settings = {
        enableHistoryState: $container.data('enable-history-state') || false,
        namespace: '.product-' + sectionId,
        inventory: $container.data('inventory') || false,
        incomingInventory: $container.data('incoming-inventory') || false,
        modalInit: false,
        slickMainInitialized: false,
        slickThumbInitialized: false,
        thumbArrows: false,
        thumbVertical: false,
        hasImages: true,
        hasMultipleImages: false,
        imageSize: '620x',
        currentSlideIndex: 0,
        videoLooping: $container.data('video-looping')
      };
  
      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = '.product-' + sectionId + '-modal';
        this.$modal = $('#QuickShopModal-' + sectionId);
      }
  
      this.selectors = {
        variantsJson: 'VariantsJson-' + sectionId,
        currentVariantJson: 'CurrentVariantJson-' + sectionId,
  
        media: '[data-product-media-type-model]',
        closeMedia: '.product-single__close-media',
        photoThumbs: '.product__thumb-' + sectionId,
        thumbSlider: '#ProductThumbs-' + sectionId,
        mainSlider: '#ProductPhotos-' + sectionId,
        imageContainer: '[data-product-images]',
        productImageMain: '.product-image-main--' + sectionId,
        dotsContainer: '.product__photo-dots--' + sectionId,
  
        priceWrapper: '.product__price-wrap-' + sectionId,
        price: '#ProductPrice-' + sectionId,
        comparePrice: '#ComparePrice-' + sectionId,
        priceA11y: '#PriceA11y-' + sectionId,
        comparePriceA11y: '#ComparePriceA11y-' + sectionId,
        unitWrapper: '.product__unit-price-wrapper--' + sectionId,
        unitPrice: '.product__unit-price--' + sectionId,
        unitPriceBaseUnit: '.product__unit-base--' + sectionId,
        sku: '#Sku-' + sectionId,
        inventory: '#ProductInventory-' + sectionId,
        incomingInventory: '#ProductIncomingInventory-' + sectionId,
  
        addToCart: '#AddToCart-' + sectionId,
        addToCartText: '#AddToCartText-' + sectionId,
  
        originalSelectorId: '#ProductSelect-' + sectionId,
        singleOptionSelector: '.variant__input-' + sectionId,
        variantColorSwatch: '.variant__input--color-swatch-' + sectionId,
  
        modalFormHolder: '#ProductFormHolder-' + sectionId,
        formContainer: '#AddToCartForm-' + sectionId
      };
  
      this.$mainSlider = $(this.selectors.mainSlider);
      this.$thumbSlider = $(this.selectors.thumbSlider);
      this.$firstProductImage = this.$mainSlider.find('img').first();
  
      if (!this.$firstProductImage.length) {
        this.settings.hasImages = false;
      }
  
      this.init();
    }
  
    Product.prototype = $.extend({}, Product.prototype, {
      init: function() {
        if (this.inModal) {
          this.$container.addClass(classes.isModal);
          $('body')
            .off('modalOpen.QuickShopModal-' + this.sectionId)
            .off('modalClose.QuickShopModal-' + this.sectionId);
          $('body').on('modalOpen.QuickShopModal-' + this.sectionId, this.openModalProduct.bind(this));
          $('body').on('modalClose.QuickShopModal-' + this.sectionId, this.closeModalProduct.bind(this));
        }
  
        if (!this.inModal) {
          this.stringOverrides();
          this.formSetup();
          this.productSetup();
  
          this.checkIfVideos();
          this.createImageCarousels();
          this.customMediaListners();
        }
      },
  
      formSetup: function() {
        // Determine how to handle variant availability selectors
        if (theme.settings.dynamicVariantsEnable) {
          this.$variantSelectors = $(this.selectors.formContainer).find(this.selectors.singleOptionSelector);
        }
  
        this.initQtySelector();
        this.initAjaxProductForm();
        this.initVariants();
      },
  
      productSetup: function() {
        this.setImageSizes();
        this.initImageSwitch();
        this.initImageZoom();
        this.initModelViewerLibraries();
        this.initShopifyXrLaunch();
      },
  
      stringOverrides: function() {
        theme.productStrings = theme.productStrings || {};
        $.extend(theme.strings, theme.productStrings);
      },
  
      setImageSizes: function() {
        if (!this.settings.hasImages) {
          return;
        }
  
        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.$firstProductImage[0].currentSrc;
  
        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
      },
  
      initVariants: function() {
        if (!document.getElementById(this.selectors.variantsJson)) {
          return;
        }
  
        this.variantsObject = JSON.parse(document.getElementById(this.selectors.variantsJson).innerHTML);
  
        var options = {
          $container: this.$container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject
        };
  
        if ($(this.selectors.variantColorSwatch).length) {
          $(this.selectors.variantColorSwatch).on('change', function(evt) {
            var $el = $(evt.currentTarget);
            var color = $el.data('color-name');
            var index = $el.data('color-index');
            this.updateColorName(color, index);
          }.bind(this));
        }
  
        this.variants = new theme.Variants(options);
  
        this.$container
          .on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this))
          .on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this))
          .on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this))
          .on('variantUnitPriceChange' + this.settings.namespace, this.updateUnitPrice.bind(this));
  
        if ($(this.selectors.sku).length) {
          this.$container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
        }
        if (this.settings.inventory || this.settings.incomingInventory) {
          this.$container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
        }
  
        // Update individual variant availability on each selection
        if (theme.settings.dynamicVariantsEnable && document.getElementById(this.selectors.currentVariantJson)) {
          this.currentVariantObject = JSON.parse(document.getElementById(this.selectors.currentVariantJson).innerHTML);
  
          this.$variantSelectors.on('change' + this.settings.namespace, this.updateVariantAvailability.bind(this));
  
          // Set default state based on current selected variant
          this.setCurrentVariantAvailability(this.currentVariantObject, true);
        }
      },
  
      /*============================================================================
        Variant change methods
      ==============================================================================*/
      updateColorName: function(color, index) {
        // Updates on radio button change, not variant.js
        $('#VariantColorLabel-' + this.sectionId + '-' + index).text(color);
      },
  
      initQtySelector: function() {
        this.$container.find('.js-qty__wrapper').each(function() {
          new theme.QtySelector($(this), {
            namespace: '.product'
          });
        });
      },
  
      initAjaxProductForm: function() {
        if (theme.settings.cartType === 'drawer') {
          new theme.AjaxProduct($(this.selectors.formContainer));
        }
      },
  
      /*============================================================================
        Dynamic variant availability
          - To disable, set dynamicVariantsEnable to false in theme.liquid
      ==============================================================================*/
      setCurrentVariantAvailability: function(variant) {
        var valuesToEnable = {
          option1: [],
          option2: [],
          option3: []
        };
  
        // Disable all options to start
        this.disableVariantGroup($(this.selectors.formContainer).find('.variant-input-wrap'));
  
        // Combine all available variants
        var availableVariants = this.variantsObject.filter(function(el) {
          if (variant.id === el.id) {
            return false;
          }
  
          // Option 1
          if (variant.option2 === el.option2 && variant.option3 === el.option3) {
            return true;
          }
  
          // Option 2
          if (variant.option1 === el.option1 && variant.option3 === el.option3) {
            return true;
          }
  
          // Option 3
          if (variant.option1 === el.option1 && variant.option2 === el.option2) {
            return true;
          }
        });
  
  
        // IE11 can't handle shortform of {variant} so extra step is needed
        var variantObject = {
          variant: variant
        };
  
        availableVariants = Object.assign({}, variantObject, availableVariants);
  
        // Loop through each available variant to gather variant values
        for (var property in availableVariants) {
          if (availableVariants.hasOwnProperty(property)) {
            var item = availableVariants[property];
            var option1 = item.option1;
            var option2 = item.option2;
            var option3 = item.option3;
  
            if (option1) {
              if (valuesToEnable.option1.indexOf(option1) === -1) {
                valuesToEnable.option1.push(option1);
              }
            }
            if (option2) {
              if (valuesToEnable.option2.indexOf(option2) === -1) {
                valuesToEnable.option2.push(option2);
              }
            }
            if (option3) {
              if (valuesToEnable.option3.indexOf(option3) === -1) {
                valuesToEnable.option3.push(option3);
              }
            }
          }
        }
  
        // Have values to enable, separated by option index
        if (valuesToEnable.option1.length) {
          this.enableVariantOptionByValue(valuesToEnable.option1, 'option1');
        }
        if (valuesToEnable.option2.length) {
          this.enableVariantOptionByValue(valuesToEnable.option2, 'option2');
        }
        if (valuesToEnable.option3.length) {
          this.enableVariantOptionByValue(valuesToEnable.option3, 'option3');
        }
      },
  
      updateVariantAvailability: function(evt, value, index) {
        if (value && index) {
          var newVal = value;
          var optionIndex = index;
        } else {
          var $el = $(evt.currentTarget);
          var newVal = $el.val() ? $el.val() : evt.currentTarget.value;
          var optionIndex = $el.data('index');
        }
  
        var variants = this.variantsObject.filter(function(el) {
          return el[optionIndex] === newVal;
        });
  
        // Disable all buttons/dropdown options that aren't the current index
        $(this.selectors.formContainer).find('.variant-input-wrap').each(function(index, el) {
          var $group = $(el);
          var currentOptionIndex = $group.data('index');
  
          if (currentOptionIndex !== optionIndex) {
            // Disable all options as a starting point
            this.disableVariantGroup($group);
  
            // Loop through legit available options and enable
            for (var i = 0; i < variants.length; i++) {
              this.enableVariantOption($group, variants[i][currentOptionIndex]);
            }
          }
        }.bind(this));
      },
  
      disableVariantGroup: function($group) {
        if (theme.settings.dynamicVariantType === 'dropdown') {
          $group.find('option').prop('disabled', true)
        } else {
          $group.find('input').prop('disabled', true);
          $group.find('label').toggleClass('disabled', true);
        }
      },
  
      enableVariantOptionByValue: function(array, index) {
        var $group = $(this.selectors.formContainer).find('.variant-input-wrap[data-index="'+ index +'"]');
  
        for (var i = 0; i < array.length; i++) {
          this.enableVariantOption($group, array[i]);
        }
      },
  
      enableVariantOption: function($group, value) {
        // Selecting by value so escape it
        value = value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
  
        if (theme.settings.dynamicVariantType === 'dropdown') {
          $group.find('option[value="'+ value +'"]').prop('disabled', false);
        } else {
          var $buttonGroup = $group.find('.variant-input[data-value="'+ value +'"]');
          $buttonGroup.find('input').prop('disabled', false);
          $buttonGroup.find('label').toggleClass('disabled', false);
        }
      },
  
      updateCartButton: function(evt) {
        var variant = evt.variant;
  
        if (variant) {
          if (variant.available) {
            // Available, enable the submit button and change text
            $(this.selectors.addToCart).removeClass(classes.disabled).prop('disabled', false);
            $(this.selectors.addToCartText).html(theme.strings.addToCart);
          } else {
            // Sold out, disable the submit button and change text
            $(this.selectors.addToCart).addClass(classes.disabled).prop('disabled', true);
            $(this.selectors.addToCartText).html(theme.strings.soldOut);
          }
        } else {
          // The variant doesn't exist, disable submit button
          $(this.selectors.addToCart).addClass(classes.disabled).prop('disabled', true);
          $(this.selectors.addToCartText).html(theme.strings.unavailable);
        }
      },
  
      updatePrice: function(evt) {
        var variant = evt.variant;
  
        if (variant) {
          // Regular price
          $(this.selectors.price).html(theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat)).show();
  
          // Sale price, if necessary
          if (variant.compare_at_price > variant.price) {
            $(this.selectors.comparePrice).html(theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat));
            $(this.selectors.priceWrapper).removeClass(classes.hidden);
            $(this.selectors.price).addClass(classes.onSale);
            $(this.selectors.comparePriceA11y).attr('aria-hidden', 'false');
            $(this.selectors.priceA11y).attr('aria-hidden', 'false');
          } else {
            $(this.selectors.priceWrapper).addClass(classes.hidden);
            $(this.selectors.price).removeClass(classes.onSale);
            $(this.selectors.comparePriceA11y).attr('aria-hidden', 'true');
            $(this.selectors.priceA11y).attr('aria-hidden', 'true');
          }
        }
      },
  
      updateUnitPrice: function(evt) {
        var variant = evt.variant;
  
        if (variant && variant.unit_price) {
          $(this.selectors.unitPrice).html(theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat));
          $(this.selectors.unitPriceBaseUnit).text(theme.Currency.getBaseUnit(variant));
          $(this.selectors.unitWrapper).removeClass(classes.hidden).removeClass(classes.visuallyHide);
        } else {
          $(this.selectors.unitWrapper).addClass(classes.visuallyHide);
        }
      },
  
      updateSku: function(evt) {
        var variant = evt.variant;
        var newSku = '';
  
        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }
  
          $(this.selectors.sku).html(newSku);
        }
      },
  
      updateInventory: function(evt) {
        var variant = evt.variant;
  
        // If we don't track variant inventory, hide stock
        if (!variant || !variant.inventory_management) {
          this.toggleInventoryQuantity(false);
          this.toggleIncomingInventory(false);
          return;
        }
  
        if (variant.inventory_management === 'shopify' && window.inventories && window.inventories[this.sectionId]) {
          variantInventoryObject = window.inventories[this.sectionId][variant.id];
          var quantity = variantInventoryObject.quantity;
          var showInventory = true;
          var showIncomingInventory = false;
  
          if (quantity <= 0 || quantity > theme.settings.inventoryThreshold) {
            showInventory = false;
          }
  
          this.toggleInventoryQuantity(showInventory, quantity);
  
          if (!showInventory && variantInventoryObject.incoming) {
            showIncomingInventory = true;
          }
  
          this.toggleIncomingInventory(showIncomingInventory, variant.available, variantInventoryObject.next_incoming_date);
        }
      },
  
      toggleInventoryQuantity: function(show, qty) {
        if (!this.settings.inventory) {
          show = false;
        }
  
        if (show) {
          $(this.selectors.inventory)
            .removeClass(classes.hidden)
            .text(theme.strings.stockLabel.replace('[count]', qty));
        } else {
          $(this.selectors.inventory).addClass(classes.hidden);
        }
      },
  
      toggleIncomingInventory: function(show, available, date) {
        if (!this.settings.incomingInventory) {
          show = false;
        }
  
        if (show) {
          var string = available ?
                       theme.strings.willNotShipUntil.replace('[date]', date) :
                       theme.strings.willBeInStockAfter.replace('[date]', date);
  
          if (!date) {
            string = theme.strings.waitingForStock;
          }
  
          $(this.selectors.incomingInventory)
            .removeClass(classes.hidden)
            .text(string);
        } else {
          $(this.selectors.incomingInventory).addClass(classes.hidden);
        }
      },
  
      /*============================================================================
        Product videos
      ==============================================================================*/
      checkIfVideos: function() {
        var $productVideos = this.$mainSlider.find(selectors.productVideo);
  
        // Stop if there are 0 videos
        if (!$productVideos.length) {
          return false;
        }
  
        var videoTypes = [];
  
        $productVideos.each(function() {
          var type = $(this).data('video-type');
  
          if (videoTypes.indexOf(type) < 0) {
            videoTypes.push(type);
          }
        });
  
        // Load YouTube API if not already loaded
        if (videoTypes.indexOf('youtube') > -1) {
          if (!theme.config.youTubeReady) {
            theme.LibraryLoader.load('youtubeSdk');
            $('body').on('youTubeReady' + this.settings.namespace, function() {
              this.loadYoutubeVideos($productVideos);
            }.bind(this));
          } else {
            this.loadYoutubeVideos($productVideos);
          }
        }
  
        // Add mp4 video players
        if (videoTypes.indexOf('mp4') > -1) {
          this.loadMp4Videos($productVideos);
        }
  
        return videoTypes;
      },
  
      loadMp4Videos: function($videos) {
        $videos.each(function() {
          var $el = $(this);
          if ($el.data('video-type') != 'mp4') {
            return;
          }
  
          var id = $el.attr('id');
          var videoId = $el.data('video-id');
  
          videos[id] = {
            type: 'mp4',
            divId: id,
            style: $el.data('video-style')
          };
        });
      },
  
      loadYoutubeVideos: function($videos) {
        $videos.each(function() {
          var $el = $(this);
          if ($el.data('video-type') != 'youtube') {
            return;
          }
  
          var id = $el.attr('id');
          var videoId = $el.data('youtube-id');
  
          videos[id] = {
            type: 'youtube',
            id: id,
            videoId: videoId,
            style: $el.data('video-style'),
            loop: $el.data('video-loop'),
            attemptedToPlay: false,
            events: {
              onReady: function(evt) {
                onVideoPlayerReady(evt, id);
              },
              onStateChange: function(evt) {
                onVideoStateChange(evt, id);
              }
            }
          };
        });
  
        // Create a player for each YouTube video
        for (var key in videos) {
          if (videos[key].type === 'youtube') {
            if (videos.hasOwnProperty(key)) {
              var args = $.extend({}, youtubeVideoOptions, videos[key]);
  
              if (args.style === 'muted') {
                // default youtubeVideoOptions, no need to change anything
              } else {
                args.playerVars.controls = 1;
                args.playerVars.autoplay = 0;
              }
  
              youtubePlayers[key] = new YT.Player(key, args);
            }
          }
        }
  
        youtubeReady = true;
      },
  
      initVideo: function($video) {
        var videoType = $video.data('video-type');
        var divId = $video.attr('id');
  
        if (videoType === 'mp4' && videos[divId].style === 'muted') {
          this.playMp4Video(divId);
        }
  
        if (videoType === 'youtube') {
          if (youtubeReady && videos[divId].style === 'muted') {
            this.requestToPlayYoutubeVideo(divId);
          }
        }
  
        // Hacky way to trigger resetting the slider layout in modals
        if (this.inModal) {
          this.resizeSlides();
        }
      },
  
      stopVideo: function(id, type) {
        if (!id) {
          this.stopYoutubeVideo();
          this.stopMp4Video();
        }
  
        if (type === 'youtube') {
          this.stopYoutubeVideo(id);
        }
  
        if (type === 'mp4') {
          this.stopMp4Video(id);
        }
      },
  
      getVideoType: function($video) {
        return $video.data('video-type');
      },
  
      getVideoId: function($video) {
        return $video.attr('id');
      },
  
      // Sub video functions (MP4 and YouTube)
      requestToPlayYoutubeVideo: function(id, forcePlay) {
        if (!theme.config.youTubeReady) {
          return;
        }
  
        var $player = $('#' + id);
        setParentAsLoading($player);
  
        // If video is requested too soon, player might not be ready.
        // Set arbitrary timeout to request it again in a second
        if (typeof youtubePlayers[id].playVideo != 'function') {
          setTimeout(function() {
            this.playYoutubeVideo(id, forcePlay);
          }.bind(this), 1000);
          return;
        }
  
        this.playYoutubeVideo(id, forcePlay);
      },
  
      playYoutubeVideo: function (id, forcePlay) {
        var $player = $('#' + id);
        setParentAsLoaded($player);
        if (typeof youtubePlayers[id].playVideo === 'function') {
          youtubePlayers[id].playVideo();
        }
  
        // forcePlay is sent as true from beforeSlideChange so the visibility
        // check isn't fooled by the next slide positioning
        if (!forcePlay) {
          initCheckVisibility(id);
        }
      },
  
      stopYoutubeVideo: function(id) {
        if (!theme.config.youTubeReady) {
          return;
        }
  
        if (id && youtubePlayers[id]) {
          if (typeof youtubePlayers[id].pauseVideo === 'function') {
            youtubePlayers[id].pauseVideo();
          }
          $(window).off('scroll.' + id);
        } else {
          for (key in youtubePlayers) {
            var childVideo = this.$container.find('#' + key);
            if (childVideo.length && typeof youtubePlayers[key].pauseVideo === 'function') {
              youtubePlayers[key].pauseVideo();
              $(window).off('scroll.' + key);
            }
          }
        }
      },
  
      playMp4Video: function(id) {
        var $player = $('#' + id);
        setParentAsLoaded($player);
  
        var playPromise = $player[0].play();
  
        if (playPromise !== undefined) {
          playPromise.then(function() {})
          .catch(function(error) {
            // Likely low power mode on iOS, show controls
            $player[0].setAttribute('controls', '');
            $player.closest(selectors.videoParent).attr('data-video-style', 'unmuted');
          });
        }
      },
  
      stopMp4Video: function(id) {
        if (id) {
          $('#' + id)[0].pause();
        } else {
          // loop through all mp4 videos to stop them
          for (var key in videos) {
            var childVideo = this.$container.find('#' + key);
            if (childVideo.length && videos[key].type === 'mp4') {
              var player = $('#' + videos[key].divId)[0];
              if (player && typeof player.pause === 'function') {
                player.pause();
              }
            }
          }
        }
      },
  
      /*============================================================================
        Product images
      ==============================================================================*/
      initImageSwitch: function() {
        if (!$(this.selectors.photoThumbs).length) {
          return;
        }
  
        var self = this;
  
        $(this.selectors.photoThumbs)
          .on('click', function(evt) {
            evt.preventDefault();
          })
          .on('focus', function(evt) {
            if (!this.settings.slickThumbInitialized) { return }
            var index = $(evt.currentTarget).data('index');
            if (index !== undefined) {
              this.$thumbSlider.slick('slickGoTo', index);
            }
          }.bind(this))
          .on('keydown', function(evt) {
            if (evt.keyCode === 13) {
              this.$container.find(selectors.currentSlide).focus();
            }
          }.bind(this));
      },
  
      initImageZoom: function() {
        var $container = $(this.selectors.imageContainer, this.$container);
        var imageZoom = new theme.Photoswipe($container[0], this.sectionId);
      },
  
      updateVariantImage: function(evt) {
        var variant = evt.variant;
        var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_media.preview_image.src, this.settings.imageSize);
  
        var $newImage = $('.product__thumb[data-id="' + variant.featured_media.id + '"]');
        var imageIndex = this._slideIndex($newImage.closest('.product__thumb-item'));
  
        // If there is no index, slider is not initalized
        if (typeof imageIndex === 'undefined') {
          return;
        }
  
        this.$mainSlider.slick('slickGoTo', imageIndex);
      },
  
      createImageCarousels: function() {
        if (!this.$thumbSlider.length || $(this.selectors.photoThumbs).length < 2) {
          // Single product image. Init video if it exists
          var $video = $(this.selectors.productImageMain).find(selectors.productVideo);
          if ($video.length) {
            this.initVideo($video);
          }
  
          return;
        }
  
        this.settings.hasMultipleImages = true;
  
        // Set starting slide (for both sliders)
        var $activeSlide = this.$mainSlider.find('.starting-slide');
        var startIndex = this._slideIndex($activeSlide);
  
        // Lame way to prevent duplicate event listeners
        this.$mainSlider.off('init');
        this.$mainSlider.off('beforeChange');
        this.$mainSlider.on('init', this.mainSlideInit.bind(this));
        this.$mainSlider.on('beforeChange', this.beforeSlideChange.bind(this));
        this.$thumbSlider.on('init', this.thumbSlideInit.bind(this));
  
        var thumbnailsVertical = this.settings.thumbVertical = this.$thumbSlider.data('position') === 'beside' ? true : false;
        var thumbArrows = this.settings.thumbArrows = this.$thumbSlider.data('arrows');
  
        this.$mainSlider.slick({
          accessibility: false,
          adaptiveHeight: true,
          asNavFor: this.selectors.thumbSlider,
          infinite: false,
          arrows: false,
          dots: false,
          initialSlide: startIndex,
          appendDots: this.selectors.dotsContainer
        });
  
        this.$thumbSlider.slick({
          accessibility: false,
          asNavFor: this.selectors.mainSlider,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: thumbArrows,
          dots: false,
          vertical: thumbnailsVertical,
          verticalSwiping: thumbnailsVertical,
          focusOnSelect: true,
          infinite: false,
          customHeightMatching: thumbArrows ? false : thumbnailsVertical,
          customSlideAdvancement: true,
          initialSlide: startIndex
        });
  
        // Too many thumbnails can cause the AOS calculations to be off
        // so refresh that when the slider is ready
        if (AOS) {
          AOS.refresh();
        }
      },
  
      destroyImageCarousels: function() {
        if (this.$mainSlider && this.settings.slickMainInitialized) {
          this.$mainSlider.slick('unslick');
          this.settings.slickMainInitialized = false;
        }
  
        if (this.$thumbSlider && this.settings.slickThumbInitialized) {
          this.$thumbSlider.slick('unslick');
          this.settings.slickThumbInitialized = false;
        }
  
        this.settings.slickMainInitialized = false;
        this.settings.slickThumbInitialized = false;
      },
  
      mainSlideInit: function(event, slick) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find(selectors.currentSlide);
        var $video = $currentSlide.find(selectors.productVideo);
  
        this.settings.slickMainInitialized = true;
        this.settings.currentSlideIndex = $currentSlide.data('slick-index');
  
        if ($video.length) {
          this.initVideo($video);
        }
      },
  
      thumbSlideInit: function(event, slick) {
        this.settings.slickThumbInitialized = true;
  
        // Check if we need to hide the arrows
        if (this.settings.thumbArrows) {
          this.$thumbSlider.on('setPosition', this.thumbSlideArrowVisibility.bind(this));
        }
      },
  
      thumbSlideArrowVisibility: function(event, slick) {
        var $slider = slick.$slider;
        var $arrows = $slider.find('.slick-arrow');
        var showArrows = false;
  
        if (this.settings.thumbVertical) {
          var $trackHeight = $slider.find('.slick-track').height();
          if ($trackHeight >= $slider.height()) {
            showArrows = true;
          }
        } else {
          var $trackWidth = $slider.find('.slick-track').width();
          if ($trackWidth >= $slider.width()) {
            showArrows = true;
          }
        }
  
        if (showArrows) {
          $arrows.removeClass(classes.hidden);
        } else {
          $arrows.addClass(classes.hidden);
        }
      },
  
      beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
        if (this.settings.currentSlideIndex === nextSlide) {
          return;
        } else {
          this.settings.currentSlideIndex = nextSlide;
        }
  
        var $slider = slick.$slider;
        var $currentSlide = $slider.find(selectors.currentSlide);
        var $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');
  
        $currentSlide.attr('tabindex', '-1');
        $nextSlide.attr('tabindex', 0);
  
        // Pause any existing slide video
        var $prevVideo = $currentSlide.find('.product__video');
        if (currentSlide !== nextSlide && $prevVideo.length) {
          var prevVideoType = this.getVideoType($prevVideo);
          var prevVideoId = this.getVideoId($prevVideo);
  
          if (prevVideoId) {
            this.stopVideo(prevVideoId, prevVideoType);
          }
        }
  
        // Prep next slide video
        var $nextVideo = $nextSlide.find('.product__video');
        if ($nextVideo.length) {
          var nextVideoType = this.getVideoType($nextVideo);
          var nextVideoId = this.getVideoId($nextVideo);
  
          // Prep YouTube with a backup in case API isn't ready
          if (nextVideoId && nextVideoType === 'youtube') {
            if (youtubeReady) {
              if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                this.requestToPlayYoutubeVideo(nextVideoId, true);
              }
            } else {
              $('body').on('youTubeReady' + this.settings.namespace, function() {
                if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                  this.requestToPlayYoutubeVideo(nextVideoId, true);
                }
              }.bind(this))
            }
          }
  
          // Autoplay muted MP4 videos
          if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
            if (nextVideoType === 'mp4') {
              this.playMp4Video(nextVideoId);
            }
          }
  
          // Set unmuted videos to loaded state
          if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style != 'muted') {
            setParentAsLoaded($('#' + nextVideoId));
          }
        }
  
        // Pause any existing media
        var $currentMedia = $currentSlide.find(this.selectors.media);
        if ($currentMedia.length) {
          $currentMedia.trigger('mediaHidden');
        }
  
        // Prep next slide media
        var $nextMedia = $nextSlide.find(this.selectors.media);
        if ($nextMedia.length) {
          $nextMedia.trigger('mediaVisible');
          $nextSlide.find('.shopify-model-viewer-ui__button').attr('tabindex', 0);
          $nextSlide.find('.product-single__close-media').attr('tabindex', 0);
        }
      },
  
      resizeSlides: function() {
        if (!this.settings.hasMultipleImages) {
          return;
        }
  
        $(window).trigger('resize.slick');
        setTimeout(function() {
          if (this.$mainSlider && this.settings.slickMainInitialized) {
            this.$mainSlider.slick('setPosition');
          }
          if (this.$thumbSlider && this.settings.slickThumbInitialized) {
            this.$thumbSlider.slick('setPosition');
          }
        }.bind(this), 500); // same timing as modal open transition
      },
  
      _slideIndex: function($el) {
        return $el.data('index');
      },
  
      /*============================================================================
        Products when in quick view modal
      ==============================================================================*/
      openModalProduct: function() {
        if (!this.settings.modalInit) {
          var $formHolder = $(this.selectors.modalFormHolder);
          var url = $formHolder.data('url');
          var template = $formHolder.data('template');
  
          // If no alt template, use stripped down ajax version
          if (!template) {
            url = url + '?view=ajax';
          }
  
          $formHolder.load(url + ' #AddToCartForm-' + this.sectionId, function() {
            this.formSetup();
            if (Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
          }.bind(this));
  
          this.productSetup();
          this.loadModalContent();
          this.createImageCarousels();
          this.customMediaListners();
          this.settings.modalInit = true;
        }
  
        this.resizeSlides();
      },
  
      closeModalProduct: function() {
        this.stopVideo();
        $('body').off(this.settings.namespace);
        $(window).off(this.settings.namespace);
      },
  
      loadModalContent: function() {
        // Load videos if they exist
        var videoTypes = this.checkIfVideos();
  
        // Lazyload mp4 videos
        if (videoTypes && videoTypes.indexOf('mp4') > -1) {
          this.$modal
            .find('.product__video[data-video-type="mp4"]')
            .find('.product__video-src')
            .each(function(i, video) {
              var $el = $(video);
              var src = $el.attr('src');
              var type = $el.attr('type')
              var newEl = document.createElement('source');
              newEl.src = src;
              newEl.type = type;
              $el.after(newEl);
            }.bind(this));
        }
      },
  
      /*============================================================================
        Product media (3D)
      ==============================================================================*/
      initModelViewerLibraries: function() {
        var $modelViewerElements = $(
          this.selectors.media,
          this.$container
        );
  
        if ($modelViewerElements.length < 1) return;
  
        theme.ProductMedia.init($modelViewerElements, this.sectionId);
      },
  
      initShopifyXrLaunch: function() {
        var self = this;
        $(document).on('shopify_xr_launch', function() {
          var $currentMedia = $(
            self.selectors.productMediaWrapper +
              ':not(.' +
              classes.hidden +
              ')',
            self.$container
          );
          $currentMedia.trigger('xrLaunch');
        });
      },
  
      customMediaListners: function() {
        $('body').on('click', this.selectors.closeMedia, function() {
          this.$mainSlider
            .find(selectors.currentSlide)
            .find(this.selectors.media)
            .trigger('mediaHidden');
        }.bind(this));
  
        this.$container.find('model-viewer')
          .on('shopify_model_viewer_ui_toggle_play', function(evt) {
            this.mediaLoaded(evt);
          }.bind(this))
          .on('shopify_model_viewer_ui_toggle_pause', function(evt) {
            this.mediaUnloaded(evt);
          }.bind(this));
      },
  
      mediaLoaded: function(evt) {
        this.$container.find(this.selectors.closeMedia).removeClass(classes.hidden);
        this.toggleSliderSwiping(false);
      },
  
      mediaUnloaded: function(evt) {
        this.$container.find(this.selectors.closeMedia).addClass(classes.hidden);
        this.toggleSliderSwiping(true);
      },
  
      toggleSliderSwiping: function(enable) {
        if (this.$mainSlider && this.settings.slickMainInitialized) {
          this.$mainSlider.slick('slickSetOption', 'swipe', enable);
          this.$mainSlider.slick('slickSetOption', 'draggable', enable);
          this.$mainSlider.slick('slickSetOption', 'touchMove', enable);
          this.$mainSlider.slick('slickSetOption', 'accessibility', enable);
        }
      },
  
      onUnload: function() {
        this.$container.off(this.settings.namespace);
        $('body').off(this.settings.namespace);
        this.destroyImageCarousels();
        theme.ProductMedia.removeSectionModels(this.sectionId);
      }
    });
  
    return Product;
  })();
  
  theme.Recommendations = (function() {
  
    function Recommendations(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
      this.url = $container.data('url');
  
      this.selectors = {
        recommendations: '#Recommendations-' + sectionId,
        placeholder: '.product-recommendations-placeholder',
        sectionClass: ' .product-recommendations',
        productResults: '.grid-product'
      };
  
      this.init();
    }
  
    Recommendations.prototype = $.extend({}, Recommendations.prototype, {
      init: function() {
        var $section = $(this.selectors.recommendations);
  
        if (!$section.length || $section.data('enable') === false) {
          return;
        }
  
        var $placeholder = $section.find(this.selectors.placeholder);
        var id = $section.data('product-id');
        var limit = $section.data('limit');
  
        var url = this.url + '?section_id=product-recommendations&limit='+ limit +'&product_id=' + id;
  
        $placeholder.load(url + this.selectors.sectionClass, function(data) {
          theme.reinitProductGridItem($section);
          this.updateVariantInventory($section);
  
          // If no results, hide the entire section
          if ($(data).find(this.selectors.sectionClass).find(this.selectors.productResults).length === 0) {
            $section.addClass('hide');
          }
        }.bind(this));
      },
  
      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateVariantInventory: function($section) {
        window.inventories = window.inventories || {};
  
        $section.find('.js-product-inventory-data').each(function() {
          var $el = $(this);
          var sectionId = $el.data('section-id');
          window.inventories[sectionId] = {};
          $('.js-variant-inventory-data', $el).each(function() {
            var $child = $(this);
            window.inventories[sectionId][$child.data('id')] = {
              'quantity': $child.data('quantity'),
              'incoming': $child.data('incoming'),
              'next_incoming_date': $child.data('date')
            }
          });
        });
      }
    });
  
    return Recommendations;
  })();
  
  theme.Collection = (function() {
    var isAnimating = false;
  
    var selectors = {
      sortSelect: '#SortBy',
      tags: '.tags',
      hero: '.collection-hero',
      title: '.collection-title',
      parallaxContainer: '.parallax-container'
    };
  
    var data = {
      sortBy: 'data-default-sortby'
    };
  
    var classes = {
      activeTag: 'tag--active'
    };
  
    function Collection(container) {
      this.container = container;
      this.sectionId = $(container).attr('data-section-id');
      this.namespace = '.collection-' + this.sectionId;
  
      var $heroImageContainer = this.$heroContainer = $(container).find('.collection-hero');
      if ($heroImageContainer.length) {
        this.checkIfNeedReload();
        theme.loadImageSection($heroImageContainer);
  
        if ($(container).data('parallax')) {
          var $parallaxContainer = $(container).find(selectors.parallaxContainer);
          var args = {
            namespace: this.namespace
          };
          theme.parallaxSections[this.namespace] = new theme.Parallax($parallaxContainer, args);
        }
      } else if (theme.settings.overlayHeader) {
        theme.headerNav.disableOverlayHeader();
      }
  
      // Ajax pagination
      $(window).on('popstate', function(state) {
        if (state) {
          this.getNewCollectionContent(location.href);
        }
      }.bind(this));
  
      this.init();
    }
  
    Collection.prototype = $.extend({}, Collection.prototype, {
      init: function() {
        // init is called on load and when tags are selected
        this.$container = $(this.container);
        this.sectionId = this.$container.attr('data-section-id');
  
        this.$sortSelect = $(selectors.sortSelect);
        this.$sortSelect.on('change', this.onSortChange.bind(this));
        this.defaultSort = this.getDefaultSortValue();
  
        this.initParams();
        this.sortTags();
        this.initTagAjax();
      },
  
      initTagAjax: function() {
        this.$container.on('click' + this.namespace, '.tags a', function(evt) {
          var $el = $(evt.currentTarget);
          if ($el.hasClass('no-ajax')) {
            return;
          }
  
          evt.preventDefault();
  
          if (isAnimating) {
            return;
          }
  
          isAnimating = true;
  
          var newUrl = $el.attr('href');
          $(selectors.tags).find('.' + classes.activeTag).removeClass(classes.activeTag);
          $el.parent().addClass(classes.activeTag);
          history.pushState({}, '', newUrl);
          $('.grid-product').addClass('unload');
          this.getNewCollectionContent(newUrl);
        }.bind(this));
      },
  
      getNewCollectionContent: function(url) {
        url = url + '?view=ajax';
        $('#CollectionAjaxResult').load(url + ' #CollectionAjaxContent', function(data) {
          isAnimating = false;
          this.reInit(data);
        }.bind(this));
      },
  
      initParams: function() {
        this.queryParams = {};
  
        if (location.search.length) {
          var aKeyValue;
          var aCouples = location.search.substr(1).split('&');
          for (var i = 0; i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
              this.queryParams[
                decodeURIComponent(aKeyValue[0])
              ] = decodeURIComponent(aKeyValue[1]);
            }
          }
        }
      },
  
      getSortValue: function() {
        return this.$sortSelect.val() || this.defaultSort;
      },
  
      getDefaultSortValue: function() {
        return this.$sortSelect.attr(data.sortBy);
      },
  
      onSortChange: function() {
        this.queryParams.sort_by = this.getSortValue();
  
        if (this.queryParams.page) {
          delete this.queryParams.page;
        }
  
        window.location.search = $.param(this.queryParams);
      },
  
      sortTags: function() {
        var $sortTags = $('#SortTags');
  
        if (!$sortTags.length) {
          return;
        }
  
        $sortTags.on('change', function() {
          location.href = $(this).val();
        });
      },
  
      reInit: function(data) {
        // Reload collection template (it can be anywhere in the sections.instance array)
        for (var i = 0; i < sections.instances.length; i++) {
          var instance = sections.instances[i];
          if (instance['type'] === 'collection-template') {
            instance.forceReload();
          }
        }
  
        // Update collection title
        if (data) {
          var title = $(data).find(selectors.title).text();
          $(selectors.title).text(title);
        }
  
        theme.reinitProductGridItem();
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      // A liquid variable in the header needs a full page refresh
      // if the collection header hero image setting is enabled
      // and the header is set to sticky. Only necessary in the editor.
      checkIfNeedReload: function() {
        if (!Shopify.designMode) {
          return;
        }
  
        if (theme.settings.overlayHeader) {
          if (!$('.header-wrapper').hasClass('header-wrapper--overlay')) {
            location.reload();
          }
        }
      },
  
      onUnload: function() {
        $(window).off(this.namespace);
        this.$container.off(this.namespace);
  
        if (theme.parallaxSections[this.namespace]) {
          theme.parallaxSections[this.namespace].destroy();
          delete theme.parallaxSections[this.namespace];
        }
      }
  
    });
  
    return Collection;
  })();
  
  theme.CollectionSwitcher = (function() {
    var selectors = {
      trigger: '.collection-switcher__trigger',
      collection: '.collection-switcher__collection',
      slider: '.collection-switcher__collection-grid'
    };
  
    function CollectionSwitcher(container) {
      this.$container = $(container);
      this.sectionId = this.$container.attr('data-section-id');
  
      this.config = {
        perRow: this.$container.attr('data-per-row'),
        perRowMobile: 2 // fixed always
      };
  
      this.sliderArgs = {
        arrows: true,
        infinite: false,
        slidesToShow: this.config.perRow,
        slidesToScroll: this.config.perRow
      };
  
      this.$activeSlider = null;
  
      this.init();
    }
  
    CollectionSwitcher.prototype = $.extend({}, CollectionSwitcher.prototype, {
      init: function() {
        this.$triggers = this.$container.find(selectors.trigger);
        this.$collections = this.$container.find(selectors.collection);
  
        var $firstSlider = this.$container.find(selectors.slider).first();
        if ($firstSlider.length) {
          this.initSlider($firstSlider);
  
          $('body').on('matchSmall unmatchSmall', function() {
            this.initSlider();
          }.bind(this));
        }
  
        this.$triggers.on('click', this.switch.bind(this));
      },
  
      initSlider: function($slider) {
        if (this.$activeSlider) {
          this.$activeSlider
            .off('afterChange')
            .slick('unslick');
        }
  
        if (!$slider) {
          $slider = this.$activeSlider;
        }
  
        if (!$slider.length) {
          return;
        }
  
        // Mobile-specific per-row setting
        if (theme.config.bpSmall) {
          this.sliderArgs.slidesToShow = this.config.perRowMobile;
          this.sliderArgs.slidesToScroll = this.config.perRowMobile;
        } else {
          this.sliderArgs.slidesToShow = parseInt(this.config.perRow);
          this.sliderArgs.slidesToScroll = parseInt(this.config.perRow);
        }
  
        this.$activeSlider = $slider.slick(this.sliderArgs);
  
        if (AOS) {
          AOS.refresh();
        }
      },
  
      switch: function(evt) {
        evt.preventDefault();
  
        this.$triggers.removeClass('is-active');
  
        var containerId = $(evt.currentTarget).addClass('is-active').attr('aria-controls');
        var $container = $('#' + containerId);
        var $newSlider = $container.find(selectors.slider);
  
        // Hide collections, show new one
        this.$collections.addClass('hide');
        $container.removeClass('hide');
  
        this.initSlider($newSlider);
      },
  
      onUnload: function() {
  
      }
  
    });
  
    return CollectionSwitcher;
  })();
  
  theme.HeaderSection = (function() {
  
    var selectors = {
      drawer: '#NavDrawer',
      mobileSubNavToggle: '.mobile-nav__toggle-btn',
      hasSublist: '.mobile-nav__has-sublist'
    };
  
    var classes = {
      navExpanded: 'mobile-nav--expanded'
    };
  
    function Header(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
  
      // Reload any slideshow if when the header is reloaded to make sure the
      // sticky header works as expected (it can be anywhere in the sections.instance array)
      for (var i = 0; i < sections.instances.length; i++) {
        var instance = sections.instances[i];
        if (instance['type'] === 'slideshow-section') {
          instance.forceReload();
        }
      }
  
      this.initDrawers();
      theme.headerNav.init();
      theme.announcementBar.init();
    }
  
    Header.prototype = $.extend({}, Header.prototype, {
      initDrawers: function() {
        theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
        if (theme.settings.cartType === 'drawer') {
          new theme.CartDrawer();
        }
  
        this.drawerMenuButtons();
      },
  
      drawerMenuButtons: function() {
        $(selectors.drawer).find('.js-drawer-close').on('click', function(evt){
          evt.preventDefault();
          theme.NavDrawer.close();
        });
  
        var $mobileSubNavToggle = $(selectors.mobileSubNavToggle);
  
        $mobileSubNavToggle.attr('aria-expanded', 'false');
        $mobileSubNavToggle.each(function (i, el) {
          var $el = $(el);
          $el.attr('aria-controls', $el.attr('data-aria-controls'));
        });
  
        $mobileSubNavToggle.on('click', function() {
          var $el = $(this);
          var currentlyExpanded = $el.attr('aria-expanded');
          var toggleState = false;
  
          // Updated aria-expanded value based on state pre-click
          if (currentlyExpanded === 'true') {
            $el.attr('aria-expanded', 'false');
          } else {
            $el.attr('aria-expanded', 'true');
            toggleState = true;
          }
  
          // Toggle class that expands/collapses sublist
          $el.closest(selectors.hasSublist).toggleClass(classes.navExpanded, toggleState);
        });
      },
  
      onUnload: function() {
        theme.NavDrawer.close();
        theme.headerNav.unload();
        theme.announcementBar.unload();
      }
    });
  
    return Header;
  
  })();
  
  theme.FooterSection = (function() {
  
    var selectors = {
      disclosureLocale: '[data-disclosure-locale]',
      disclosureCurrency: '[data-disclosure-currency]'
    };
  
    function Footer(container) {
      var $container = this.$container = $(container);
  
      this.cache = {};
      this.cacheSelectors();
  
      if (this.cache.$localeDisclosure.length) {
        this.localeDisclosure = new theme.Disclosure(
          this.cache.$localeDisclosure
        );
      }
  
      if (this.cache.$currencyDisclosure.length) {
        this.currencyDisclosure = new theme.Disclosure(
          this.cache.$currencyDisclosure
        );
      }
    }
  
    Footer.prototype = $.extend({}, Footer.prototype, {
      cacheSelectors: function() {
        this.cache = {
          $localeDisclosure: this.$container.find(selectors.disclosureLocale),
          $currencyDisclosure: this.$container.find(selectors.disclosureCurrency)
        };
      },
  
      onUnload: function() {
        if (this.cache.$localeDisclosure.length) {
          this.localeDisclosure.unload();
        }
  
        if (this.cache.$currencyDisclosure.length) {
          this.currencyDisclosure.unload();
        }
      }
    });
  
    return Footer;
  })();
  
  theme.FeaturedContentSection = (function() {
  
    function FeaturedContent() {
      $('.rte').find('a:not(:has(img))').addClass('text-link');
    }
  
    return FeaturedContent;
  })();
  
  theme.slideshows = {};
  
  theme.SlideshowSection = (function() {
  
    var selectors = {
      parallaxContainer: '.parallax-container'
    };
  
    function SlideshowSection(container) {
      var $container = this.$container = $(container);
      var $section = $container.parent();
      var sectionId = $container.attr('data-section-id');
      var slideshow = this.slideshow = '#Slideshow-' + sectionId;
      this.namespace = '.' + sectionId;
  
      var $imageContainer = $(container).find('.hero');
      if ($imageContainer.length) {
        theme.loadImageSection($imageContainer);
      }
  
      this.init();
  
      if ($container.data('parallax')) {
        var args = {
          namespace: this.namespace
        };
  
        theme.parallaxSections[this.namespace] = new theme.Parallax($container.find(selectors.parallaxContainer), args);
      }
    }
  
    SlideshowSection.prototype = $.extend({}, SlideshowSection.prototype, {
      init: function() {
        var args = {
          arrows: $(this.slideshow).data('arrows'),
          dots: $(this.slideshow).data('dots'),
          fade: this.$container.data('parallax') ? true : false,
          variableWidth: $(this.slideshow).data('variableWidth'),
          speed: 500 // same as $slideshowImageAnimationSpeed in CSS
        };
  
        theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow, args);
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (theme.parallaxSections[this.namespace]) {
          theme.parallaxSections[this.namespace].destroy();
          delete theme.parallaxSections[this.namespace];
        }
  
        if (theme.slideshows[this.slideshow]) {
          theme.slideshows[this.slideshow].destroy();
          delete theme.slideshows[this.slideshow];
        }
      },
  
      onSelect: function() {
        $(this.slideshow).slick('slickPause');
      },
  
      onDeselect: function() {
        $(this.slideshow).slick('slickPlay');
      },
  
      onBlockSelect: function(evt) {
        var $slideshow = $(this.slideshow);
  
        // Ignore the cloned version
        var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');
  
        // Go to selected slide, pause autoplay
        $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
      },
  
      onBlockDeselect: function() {
        $(this.slideshow).slick('slickPlay');
      }
    });
  
    return SlideshowSection;
  })();
  
  theme.VideoSection = (function() {
    var youtubeReady;
    var videos = [];
    var youtubePlayers = [];
    var mob_videos = [];
    var mob_youtubePlayers = [];
    var youtubeVideoOptions = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        branding: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      }
    };
  
    var vimeoReady = false;
    var vimeoVideoOptions = {
      byline: false,
      title: false,
      portrait: false,
      loop: true
    };
  
    var selectors = {
      videoParent: '.video-parent-section'
    };
  
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    };

    function videoSection(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
      
      var youtubePlayerId = this.youtubePlayerId = 'YouTubeVideo-' + this.sectionId;
      this.namespace = '.' + youtubePlayerId;
      var vimeoPlayerId = this.vimeoPlayerId = 'Vimeo-' + this.sectionId;
      var $vimeoTrigger = this.$vimeoTrigger = $('#VimeoTrigger-' + this.sectionId);
      var mp4Video = 'Mp4Video-' + this.sectionId;
  
      var $youtubeDiv = $('#' + youtubePlayerId);
      var $vimeoDiv = $('#' + vimeoPlayerId);
      var $mp4Div = $('#' + mp4Video);
  
      this.vimeoPlayer = [];
  
      if ($youtubeDiv.length) {
        this.youtubeVideoId = $youtubeDiv.data('video-id');
        this.initYoutubeVideo();
      }
  
      if ($vimeoDiv.length) {
        this.vimeoVideoId = $vimeoDiv.data('video-id');
        this.initVimeoVideo();
      }
  
      if ($mp4Div.length) {
        setParentAsLoaded($mp4Div);
  
        startMp4Playback(mp4Video).then(function() {
          // Video played as expected, don't do anything
        }).catch(function(error) {
          // Video cannot be played with autoplay, so let
          // user interact with video element itself
          $mp4Div.attr('controls', '');
          setVideoToBeInteractedWith($mp4Div);
        })
      }

      // Mobile

      var mob_youtubePlayerId = this.mob_youtubePlayerId = 'mob_YouTubeVideo-' + this.sectionId;
      this.namespace = '.' + mob_youtubePlayerId;
      var mob_vimeoPlayerId = this.mob_vimeoPlayerId = 'mob_Vimeo-' + this.sectionId;
      var $mob_vimeoTrigger = this.$mob_vimeoTrigger = $('#VimeoTrigger-' + this.sectionId);
      var mob_mp4Video = 'mob_Mp4Video-' + this.sectionId;
  
      var $mob_youtubeDiv = $('#' + mob_youtubePlayerId);
      var $mob_vimeoDiv = $('#' + mob_vimeoPlayerId);
      var $mob_mp4Div = $('#' + mob_mp4Video);
  
      this.mob_vimeoPlayer = [];
  
      if ($mob_youtubeDiv.length) {
        this.mob_youtubeVideoId = $mob_youtubeDiv.data('video-id');
        this.initMobYoutubeVideo();
      }
  
      if ($mob_vimeoDiv.length) {
        this.mob_vimeoVideoId = $mob_vimeoDiv.data('video-id');
        this.initMobVimeoVideo();
      }
  
      if ($mob_mp4Div.length) {
        setParentAsLoaded($mob_mp4Div);
  
        startMp4Playback(mp4Video).then(function() {
          // Video played as expected, don't do anything
        }).catch(function(error) {
          // Video cannot be played with autoplay, so let
          // user interact with video element itself
          $mob_mp4Div.attr('controls', '');
          setVideoToBeInteractedWith($mob_mp4Div);
        })
      }
    }
  
    function startMp4Playback(mp4Video) {
      return document.querySelector('#' + mp4Video).play();
    }
  
    function onVideoPlayerReady(evt, id) {
      var $player = $('#' + id);
      var playerId = $player.attr('id');
      youtubePlayers[playerId] = evt.target; // update stored player
      var player = youtubePlayers[playerId];
  
      setParentAsLoading($player);
  
      youtubePlayers[playerId].mute();
  
      // Remove from tabindex because YouTube iframes are annoying and you can focus
      // on the YouTube logo and it breaks
      $player.attr('tabindex', '-1');
  
      // Add out of view pausing
      videoVisibilityCheck(playerId);
      $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
    }

    function onMobVideoPlayerReady(evt, id) {
      var $player = $('#' + id);
      var playerId = $player.attr('id');
      mob_youtubePlayers[playerId] = evt.target; // update stored player
      var player =  mob_youtubePlayers[playerId];
  
      setParentAsLoading($player);
  
       mob_youtubePlayers[playerId].mute();
  
      // Remove from tabindex because YouTube iframes are annoying and you can focus
      // on the YouTube logo and it breaks
      $player.attr('tabindex', '-1');
  
      // Add out of view pausing
      videoMobVisibilityCheck(playerId);
      $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoMobVisibilityCheck));
    }
  
    function videoVisibilityCheck(id) {
      var playerId;
  
      if (typeof id === 'string') {
        playerId = id;
      } else {
        // Data comes in as part of the scroll event
        playerId = id.data.id;
      }
  
      if (theme.isElementVisible($('#' + playerId))) {
        playVisibleVideo(playerId);
      } else {
        pauseHiddenVideo(playerId);
      }
    }

    function videoMobVisibilityCheck(id) {
      var playerId;
  
      if (typeof id === 'string') {
        playerId = id;
      } else {
        // Data comes in as part of the scroll event
        playerId = id.data.id;
      }
  
      if (theme.isElementVisible($('#' + playerId))) {
        playMobVisibleVideo(playerId);
      } else {
        pauseMobHiddenVideo(playerId);
      }
    }
  
    function playVisibleVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
        youtubePlayers[id].playVideo();
      }
    }

    function playMobVisibleVideo(id) {
      if (mob_youtubePlayers[id] && typeof mob_youtubePlayers[id].playVideo === 'function') {
        mob_youtubePlayers[id].playVideo();
      }
    }
  
    function pauseHiddenVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
        youtubePlayers[id].pauseVideo();
      }
    }

    function pauseMobHiddenVideo(id) {
      if (mob_youtubePlayers[id] && typeof mob_youtubePlayers[id].pauseVideo === 'function') {
        mob_youtubePlayers[id].pauseVideo();
      }
    }
  
    function onVideoStateChange(evt, id) {
      var $player = $('#' + id);
      var playerId = $player.attr('id');
      var player = youtubePlayers[playerId];
  
      switch (evt.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (videos[playerId].attemptedToPlay) {
            setParentAsLoaded($player);
            setVideoToBeInteractedWith($player);
          }
          break;
        case 0: // ended
          player.playVideo();
          break;
        case 1: // playing
          setParentAsLoaded($player);
          break;
        case 3: // buffering
          videos[playerId].attemptedToPlay = true;
          break;
      }
    }

    function onMobVideoStateChange(evt, id) {
      var $player = $('#' + id);
      var playerId = $player.attr('id');
      var player = mob_youtubePlayers[playerId];
  
      switch (evt.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (mob_videos[playerId].attemptedToPlay) {
            setParentAsLoaded($player);
            setVideoToBeInteractedWith($player);
          }
          break;
        case 0: // ended
          player.playVideo();
          break;
        case 1: // playing
          setParentAsLoaded($player);
          break;
        case 3: // buffering
          mob_videos[playerId].attemptedToPlay = true;
          break;
      }
    }
  
    function setParentAsLoading($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.loading);
    }
  
    function setParentAsLoaded($el) {
      $el
        .closest(selectors.videoParent)
        .removeClass(classes.loading)
        .addClass(classes.loaded);
    }
  
    function setVideoToBeInteractedWith($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.interactable);
    }
  
    videoSection.prototype = $.extend({}, videoSection.prototype, {
      initMobYoutubeVideo: function() {
        mob_videos[this.mob_youtubePlayerId] = {
          id: this.mob_youtubePlayerId,
          videoId: this.mob_youtubeVideoId,
          type: 'youtube',
          attemptedToPlay: false,
          events: {
            onReady: function(evt) {
              onMobVideoPlayerReady(evt, this.mob_youtubePlayerId);
            }.bind(this),
            onStateChange: function(evt) {
              onMobVideoStateChange(evt, this.mob_youtubePlayerId);
            }.bind(this)
          }
        };
  
        if (!youtubeReady) {
          theme.LibraryLoader.load('youtubeSdk');
          $('body').on('youTubeReady' + this.namespace, this.loadMobYoutubeVideo.bind(this));
        } else {
          this.loadMobYoutubeVideo();
        }
      },

      initYoutubeVideo: function() {
        videos[this.youtubePlayerId] = {
          id: this.youtubePlayerId,
          videoId: this.youtubeVideoId,
          type: 'youtube',
          attemptedToPlay: false,
          events: {
            onReady: function(evt) {
              onVideoPlayerReady(evt, this.youtubePlayerId);
            }.bind(this),
            onStateChange: function(evt) {
              onVideoStateChange(evt, this.youtubePlayerId);
            }.bind(this)
          }
        };

        if (!youtubeReady) {
          theme.LibraryLoader.load('youtubeSdk');
          $('body').on('youTubeReady' + this.namespace, this.loadYoutubeVideo.bind(this));
        } else {
          this.loadYoutubeVideo();
        }
      },
  
      loadYoutubeVideo: function() {
        var args = $.extend({}, youtubeVideoOptions, videos[this.youtubePlayerId]);
        args.playerVars.controls = 0;
        youtubePlayers[this.youtubePlayerId] = new YT.Player(this.youtubePlayerId, args);
  
        youtubeReady = true;
      },

      loadMobYoutubeVideo: function() {
        var args = $.extend({}, youtubeVideoOptions, mob_videos[this.mob_youtubePlayerId]);
        args.playerVars.controls = 0;
        mob_youtubePlayers[this.mob_youtubePlayerId] = new YT.Player(this.mob_youtubePlayerId, args);
  
        youtubeReady = true;
      },
  
      initVimeoVideo: function() {
        videos[this.vimeoPlayerId] = {
          divId: this.vimeoPlayerId,
          id: this.vimeoVideoId,
          type: 'vimeo'
        };
  
        var $player = $('#' + this.vimeoPlayerId);
        setParentAsLoading($player);
  
        // Button to play video on mobile
        this.$vimeoTrigger.on('click', + this.namespace, function(evt) {
          // $(evt.currentTarget).addClass('hide');
          this.requestToPlayVimeoVideo(this.vimeoPlayerId);
        }.bind(this));
  
        if (!vimeoReady) {
          window.loadVimeo();
          $('body').on('vimeoReady' + this.namespace, this.loadVimeoVideo.bind(this));
        } else {
          this.loadVimeoVideo();
        }
      },

      initMobVimeoVideo: function() {
        mob_videos[this.vimeoPlayerId] = {
          divId: this.mob_vimeoPlayerId,
          id: this.mob_vimeoVideoId,
          type: 'vimeo'
        };
  
        var $player = $('#' + this.mob_vimeoPlayerId);
        setParentAsLoading($player);
  
        // Button to play video on mobile
        this.$vimeoTrigger.on('click', + this.namespace, function(evt) {
          // $(evt.currentTarget).addClass('hide');
          this.requestToPlayVimeoVideo(this.mob_vimeoPlayerId);
        }.bind(this));
  
        if (!vimeoReady) {
          window.loadVimeo();
          $('body').on('vimeoReady' + this.namespace, this.loadMobVimeoVideo.bind(this));
        } else {
          this.loadMobVimeoVideo();
        }
      },
  
      loadVimeoVideo: function() {
        var args = $.extend({}, vimeoVideoOptions, videos[this.vimeoPlayerId]);
        this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(videos[this.vimeoPlayerId].divId, args);
  
        vimeoReady = true;
  
        // Only autoplay on larger screens
        if (!theme.config.bpSmall) {
          this.requestToPlayVimeoVideo(this.vimeoPlayerId);
        } else {
          var $player = $('#' + this.vimeoPlayerId);
          setParentAsLoaded($player);
        }
      },

      loadMobVimeoVideo: function() {
        var args = $.extend({}, vimeoVideoOptions, mob_videos[this.mob_vimeoPlayerId]);
        this.mob_vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(videos[this.vimeoPlayerId].divId, args);
  
        vimeoReady = true;
  
        // Only autoplay on larger screens
        if (!theme.config.bpSmall) {
          this.requestToPlayVimeoVideo(this.mob_vimeoPlayerId);
        } else {
          var $player = $('#' + this.mob_vimeoPlayerId);
          setParentAsLoaded($player);
        }
      },
  
      requestToPlayVimeoVideo: function(id) {
        // The slider may initialize and attempt to play the video before
        // the API is even ready, because it sucks.
  
        if (!vimeoReady) {
          // Wait for the trigger, then play it
          $('body').on('vimeoReady' + this.namespace, function() {
            this.playVimeoVideo(id);
          }.bind(this))
          return;
        }
  
        this.playVimeoVideo(id);
      },

      requestToPlayVimeoVideo: function(id) {
        // The slider may initialize and attempt to play the video before
        // the API is even ready, because it sucks.
  
        if (!vimeoReady) {
          // Wait for the trigger, then play it
          $('body').on('vimeoReady' + this.namespace, function() {
            this.playMobVimeoVideo(id);
          }.bind(this))
          return;
        }
  
        this.playMobVimeoVideo(id);
      },
  
      playVimeoVideo: function(id) {
        this.vimeoPlayer[id].play();
        this.vimeoPlayer[id].setVolume(0);
  
        var $player = $('#' + id);
        setParentAsLoaded($player);
      },

      playMobVimeoVideo: function(id) {
        this.mob_vimeoPlayer[id].play();
        this.mob_vimeoPlayer[id].setVolume(0);
  
        var $player = $('#' + id);
        setParentAsLoaded($player);
      },
  
      onUnload: function(evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        var playerId = 'YouTubeVideo-' + sectionId;
        youtubePlayers[playerId].destroy();
        $(window).off('scroll' + this.namespace);
        $('body').off('vimeoReady' + this.namespace);
      }
    });
  
    return videoSection;
  })();
  
  theme.BackgroundImage = (function() {
  
    var selectors = {
      parallaxContainer: '.parallax-container'
    };
  
    function backgroundImage(container) {
      var $container = $(container);
      var sectionId = $container.attr('data-section-id');
      this.namespace = '.' + sectionId;
  
      if (!$container.length) {
        return;
      }
  
      if ($container.data('parallax')) {
        var $parallaxContainer = $container.find(selectors.parallaxContainer);
        var args = {
          namespace: this.namespace,
          desktopOnly: true
        };
  
        theme.parallaxSections[this.namespace] = new theme.Parallax($parallaxContainer, args);
      }
    }
  
    backgroundImage.prototype = $.extend({}, backgroundImage.prototype, {
      onUnload: function(evt) {
        theme.parallaxSections[this.namespace].destroy();
        delete theme.parallaxSections[this.namespace];
      }
    });
  
    return backgroundImage;
  })();
  
  theme.Testimonials = (function() {
    var slideCount = 0;
    var defaults = {
      accessibility: true,
      arrows: false,
      dots: true,
      autoplay: false,
      touchThreshold: 20,
      slidesToShow: 3,
      slidesToScroll: 3
    };
  
    function Testimonials(container) {
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      var wrapper = this.wrapper = '.testimonials-wrapper';
      var slider = this.slider = '#Testimonials-' + sectionId;
      var $slider = $(slider);
  
      this.sliderActive = false;
      var mobileOptions = $.extend({}, defaults, {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true
      });
  
      slideCount = $slider.data('count');
  
      // Override slidesToShow/Scroll if there are not enough blocks
      if (slideCount < defaults.slidesToShow) {
        defaults.slidesToShow = slideCount;
        defaults.slidesToScroll = slideCount;
      }
  
      $slider.on('init', this.a11y.bind(this));
  
      if (theme.config.bpSmall) {
        this.init($slider, mobileOptions);
      } else {
        this.init($slider, defaults);
      }
  
      $('body').on('matchSmall', function() {
        this.init($slider, mobileOptions);
      }.bind(this));
  
      $('body').on('unmatchSmall', function() {
        this.init($slider, defaults);
      }.bind(this));
    }
  
    Testimonials.prototype = $.extend({}, Testimonials.prototype, {
      onUnload: function() {
        $(this.slider, this.wrapper).slick('unslick');
      },
  
      onBlockSelect: function(evt) {
        // Ignore the cloned version
        var $slide = $('.testimonials-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');
  
        // Go to selected slide, pause autoplay
        $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
      },
  
      init: function(obj, args) {
        if (this.sliderActive) {
          obj.slick('unslick');
          this.sliderActive = false;
        }
  
        obj.slick(args);
        this.sliderActive = true;
  
        if (AOS) {
          AOS.refresh();
        }
      },
  
      a11y: function(event, obj) {
        var $list = obj.$list;
        var $wrapper = $(this.wrapper, this.$container);
  
        // Remove default Slick aria-live attr until slider is focused
        $list.removeAttr('aria-live');
  
        // When an element in the slider is focused set aria-live
        $wrapper.on('focusin', function(evt) {
          if ($wrapper.has(evt.target).length) {
            $list.attr('aria-live', 'polite');
          }
        });
  
        // Remove aria-live
        $wrapper.on('focusout', function(evt) {
          if ($wrapper.has(evt.target).length) {
            $list.removeAttr('aria-live');
          }
        });
      }
    });
  
    return Testimonials;
  })();
  
  theme.NewsletterPopup = (function() {
    function NewsletterPopup(container) {
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      this.cookieName = 'newsletter-' + sectionId;
  
      if (!$container.length) {
        return;
      }
  
      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === '/challenge') {
        return;
      }
  
      this.data = {
        secondsBeforeShow: $container.data('delay-seconds'),
        daysBeforeReappear: $container.data('delay-days'),
        cookie: Cookies.get(this.cookieName),
        testMode: $container.data('test-mode')
      };
  
      this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');
  
      // Open modal if errors or success message exist
      if ($container.find('.errors').length || $container.find('.note--success').length) {
        this.modal.open();
      }
  
      // Set cookie as opened if success message
      if ($container.find('.note--success').length) {
        this.closePopup(true);
        return;
      }
  
      $('body').on('modalClose.' + $container.attr('id'), this.closePopup.bind(this));
  
      if (!this.data.cookie || this.data.testMode) {
        this.initPopupDelay();
      }
    }
  
    NewsletterPopup.prototype = $.extend({}, NewsletterPopup.prototype, {
      initPopupDelay: function() {
        setTimeout(function() {
          this.modal.open();
        }.bind(this), this.data.secondsBeforeShow * 1000);
      },
  
      closePopup: function(success) {
        // Remove a cookie in case it was set in test mode
        if (this.data.testMode) {
          Cookies.remove(this.cookieName, { path: '/' });
          return;
        }
  
        var expiry = success ? 200 : this.data.daysBeforeReappear;
  
        Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
      },
  
      onLoad: function() {
        this.modal.open();
      },
  
      onSelect: function() {
        this.modal.open();
      },
  
      onDeselect: function() {
        this.modal.close();
      },
  
      onUnload: function() {}
    });
  
    return NewsletterPopup;
  })();
  
  theme.FadingImages = (function() {
  
    var classes = {
      activeImage: 'active-image',
      finishedImage: 'finished-image',
      activeTitles: 'active-titles',
      finishedTitles: 'finished-titles',
      compensation: 'compensation'
    };
  
    function FadingImages(container) {
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      var namespace = this.namespace = '.fading-images-' + sectionId;
  
      if (!$container.length) {
        return;
      }
  
      var $imageContainer = $container.find('.fading-images');
      theme.loadImageSection($imageContainer);
  
      this.data = {
        isInit: false,
        interval: $container.data('interval'),
        block_count: $container.data('count'),
        finish_interval: 1000,
        timer_offset: 400,
        active_image: 1,
        active_title: 1,
        removed_compensation: false
      };
  
      this.selectors = {
        $allTitles: $container.find('.fading-images-overlay__titles')
      };
  
      this.checkVisibility();
      $(window).on('scroll' + this.namespace, $.throttle(100, this.checkVisibility.bind(this)));
    }
  
    FadingImages.prototype = $.extend({}, FadingImages.prototype, {
      checkVisibility: function() {
        if (this.data.isInit) {
          $(window).off('scroll' + this.namespace);
          return;
        }
  
        if (theme.isElementVisible(this.$container)) {
          this.startImages();
          this.startTitles();
          this.data.isInit = true;
        }
      },
  
      nextImage: function() {
        var $container = this.$container;
  
        if (!this.data.removed_compensation) {
          $container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').removeClass(classes.compensation);
          this.data.removed_compensation = true;
        }
  
        $container
          .find('.fading-images__item[data-slide-index=' + this.data.active_image + ']')
          .removeClass(classes.activeImage)
          .addClass(classes.finishedImage);
  
        var target_image = this.data.active_image;
        window.setTimeout(function() {
          $container.find('.fading-images__item[data-slide-index=' + target_image + ']').removeClass(classes.finishedImage);
        }, this.data.finish_interval);
  
        this.data.active_image++;
        if (this.data.active_image > this.data.block_count) {
          this.data.active_image = 1;
        }
  
        $container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').addClass(classes.activeImage);
      },
  
      nextTitle: function() {
        var $container = this.$container;
        var $allTitles = this.selectors.$allTitles;
  
        this.selectors.$allTitles.removeClass(classes.activeTitles).addClass(classes.finishedTitles);
  
        this.data.active_title++;
        if (this.data.active_title > this.data.block_count) {
          this.data.active_title = 1;
        }
  
        var target_title = this.data.active_title;
        window.setTimeout(function() {
          var newText1 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title1');
          var newText2 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title2');
          $container.find('.fading-images-overlay__title--1').text(newText1);
          $container.find('.fading-images-overlay__title--2').text(newText2);
          $allTitles.removeClass(classes.finishedTitles).addClass(classes.activeTitles);
        }, this.data.finish_interval - 200);
      },
  
      startImages: function() {
        // Prep and show first image
        this.$container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').addClass(classes.activeImage).addClass(classes.compensation);
  
        // Begin timer
        window.setTimeout(function() {
          var fading_images_timer = window.setInterval(this.nextImage.bind(this), this.data.interval);
        }.bind(this), this.data.timer_offset);
      },
  
      startTitles: function() {
        var $container = this.$container;
        var $allTitles = this.selectors.$allTitles;
        // Prep and show first titles
        var target_title = this.data.active_title;
        window.setTimeout(function() {
          var newText1 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title1');
          var newText2 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title2');
          $container.find('.fading-images-overlay__title--1').text(newText1);
          $container.find('.fading-images-overlay__title--2').text(newText2);
          $allTitles.addClass(classes.activeTitles);
        }, 750);
  
        // Begin timer
        var fading_titles_timer = window.setInterval(this.nextTitle.bind(this), this.data.interval);
      },
  
      onLoad: function() {
      },
  
      onSelect: function() {
      },
  
      onDeselect: function() {
      },
  
      onUnload: function() {
      }
    });
  
    return FadingImages;
  })();
  
  theme.Maps = (function() {
    var config = {
      zoom: 14
    };
    var apiStatus = null;
    var mapsToLoad = [];
  
    var errors = {
      addressNoResults: theme.strings.addressNoResults,
      addressQueryLimit: theme.strings.addressQueryLimit,
      addressError: theme.strings.addressError,
      authError: theme.strings.authError
    };
  
    var selectors = {
      section: '[data-section-type="map"]',
      map: '[data-map]',
      mapOverlay: '[data-map-overlay]'
    };
  
    var classes = {
      mapError: 'map-section--load-error',
      errorMsg: 'map-section__error errors text-center'
    };
  
    // Global function called by Google on auth errors.
    // Show an auto error message on all map instances.
    window.gm_authFailure = function() {
      if (!Shopify.designMode) {
        return;
      }
  
      $(selectors.section).addClass(classes.mapError);
      $(selectors.map).remove();
      $(selectors.mapOverlay).after(
        '<div class="' +
          classes.errorMsg +
          '">' +
          theme.strings.authError +
          '</div>'
      );
    };
  
    function Map(container) {
      this.$container = $(container);
      this.sectionId = this.$container.attr('data-section-id');
      this.namespace = '.map-' + this.sectionId;
      this.$map = this.$container.find(selectors.map);
      this.key = this.$map.data('api-key');
  
      if (!this.key) {
        return;
      }
  
      // Lazyload API
      this.checkVisibility();
      $(window).on('scroll' + this.namespace, $.throttle(50, this.checkVisibility.bind(this)));
    }
  
    function initAllMaps() {
      // API has loaded, load all Map instances in queue
      $.each(mapsToLoad, function(index, instance) {
        instance.createMap();
      });
    }
  
    function geolocate($map) {
      var deferred = $.Deferred();
      var geocoder = new google.maps.Geocoder();
      var address = $map.data('address-setting');
  
      geocoder.geocode({ address: address }, function(results, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
          deferred.reject(status);
        }
  
        deferred.resolve(results);
      });
  
      return deferred;
    }
  
    Map.prototype = $.extend({}, Map.prototype, {
      prepMapApi: function() {
        if (apiStatus === 'loaded') {
          this.createMap();
        } else {
          mapsToLoad.push(this);
  
          if (apiStatus !== 'loading') {
            apiStatus = 'loading';
            if (typeof window.google === 'undefined' || typeof window.google.maps === 'undefined' ) {
              $.getScript(
                'https://maps.googleapis.com/maps/api/js?key=' + this.key
              ).then(function() {
                apiStatus = 'loaded';
                initAllMaps();
              });
            }
          }
        }
      },
  
      createMap: function() {
        var $map = this.$map;
  
        return geolocate($map)
          .then(
            function(results) {
              var mapOptions = {
                zoom: config.zoom,
                backgroundColor: 'none',
                center: results[0].geometry.location,
                draggable: false,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true
              };
  
              var map = (this.map = new google.maps.Map($map[0], mapOptions));
              var center = (this.center = map.getCenter());
  
              var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter()
              });
  
              google.maps.event.addDomListener(
                window,
                'resize',
                $.debounce(250, function() {
                  google.maps.event.trigger(map, 'resize');
                  map.setCenter(center);
                  $map.removeAttr('style');
                })
              );
            }.bind(this)
          )
          .fail(function() {
            var errorMessage;
  
            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = errors.addressNoResults;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = errors.addressQueryLimit;
                break;
              case 'REQUEST_DENIED':
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }
  
            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              $map
                .parent()
                .addClass(classes.mapError)
                .html(
                  '<div class="' +
                    classes.errorMsg +
                    '">' +
                    errorMessage +
                    '</div>'
                );
            }
          });
      },
  
      checkVisibility: function() {
        if (theme.isElementVisible(this.$container, 600)) {
          this.prepMapApi();
          $(window).off(this.namespace);
        }
      },
  
      onUnload: function() {
        if (this.$map.length === 0) {
          return;
        }
        // Causes a harmless JS error when a section without an active map is reloaded
        google.maps.event.clearListeners(this.map, 'resize');
      }
    });
  
    return Map;
  })();
  
  theme.Blog = (function() {
  
    function Blog(container) {
      this.tagFilters();
    }
  
    Blog.prototype = $.extend({}, Blog.prototype, {
      tagFilters: function() {
        var $filterBy = $('#BlogTagFilter');
  
        if (!$filterBy.length) {
          return;
        }
  
        $filterBy.on('change', function() {
          location.href = $(this).val();
        });
      },
  
      onUnload: function() {
  
      }
    });
  
    return Blog;
  })();
  
  theme.Photoswipe = (function() {
    var selectors = {
      trigger: '.js-photoswipe__zoom',
      images: '.photoswipe__image',
      activeImage: '.slick-active .photoswipe__image'
    };
  
    function Photoswipe(container, sectionId) {
      this.$container = $(container);
      this.sectionId = sectionId;
      this.namespace = '.photoswipe-' + this.sectionId;
      this.gallery;
      this.$images;
      this.inSlideshow = false;
  
      if (this.$container.attr('data-zoom') === 'false') {
        return;
      }
  
      if (this.$container.attr('data-has-slideshow') === 'true') {
        this.inSlideshow = true;
      }
  
      this.init();
    }
  
    Photoswipe.prototype = $.extend({}, Photoswipe.prototype, {
      init: function() {
        var $trigger = this.$container.find(selectors.trigger);
        this.$images = this.$container.find(selectors.images);
        var items = [];
  
        // Init gallery on active image
        $trigger.on('click' + this.namespace, function(evt) {
          items = this.getImageData();
          if (this.inSlideshow) {
            var index = this.$container.find(selectors.activeImage).data('index');
          } else {
            var index = $(evt.currentTarget).data('index');
          }
          this.initGallery(items, index);
        }.bind(this));
      },
  
      getImageData: function() {
        var haveImages = false;
        var items = [];
        var options = {};
  
        this.$images.each(function() {
          var haveImages = true;
          var smallSrc = $(this).prop('currentSrc') || $(this).prop('src');
          var item = {
            msrc: smallSrc,
            src: $(this).data('photoswipe-src'),
            w: $(this).data('photoswipe-width'),
            h: $(this).data('photoswipe-height'),
            el: $(this)[0],
            initialZoomLevel: 0.5
          };
  
          items.push(item);
        });
  
        return items;
      },
  
      initGallery: function(items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
  
        var options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: 'zoom',
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function(index) {
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
          }
        }
  
        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  
        this.gallery.init();
        this.gallery.listen('afterChange', this.afterChange.bind(this));
      },
  
      afterChange: function() {
        if (this.inSlideshow) {
          var $slideshow = $('#ProductPhotos-' + this.sectionId);
          if ($slideshow.hasClass('slick-initialized')) {
            var newIndex = this.gallery.getCurrentIndex();
            $slideshow.slick('slickGoTo', newIndex);
          }
        }
      }
    });
  
    return Photoswipe;
  })();
  
  

  // Medium breakpoint is also set in theme.scss.liquid and inline throughout some templates.
  // Do not change values unless you know what you're doing.
  theme.bp = {};
  theme.bp.smallUp = 590;
  theme.bp.small = theme.bp.smallUp - 1;

  theme.config = {
    bpSmall: false,
    hasSessionStorage: true,
    mediaQuerySmall: 'screen and (max-width: '+ theme.bp.small +'px)',
    mediaQuerySmallUp: 'screen and (min-width: '+ theme.bp.smallUp +'px)',
    youTubeReady: false,
    vimeoReady: false,
    vimeoLoading: false,
    isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
    isIpad: /ipad/.test(window.navigator.userAgent.toLowerCase()) || (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1)
  };

  if (theme.config.isIpad) {
    document.documentElement.className += ' js-ipad';
  }

  window.onYouTubeIframeAPIReady = function() {
    theme.config.youTubeReady = true;
    $('body').trigger('youTubeReady');
  }

  window.loadVimeo = function() {
    if (theme.config.vimeoLoading) {
      return;
    }

    if (!theme.config.vimeoReady) {
      theme.config.vimeoLoading = true;
      var tag = document.createElement('script');
      tag.src = "https://player.vimeo.com/api/player.js";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      // Because there's no way to check for the Vimeo API being loaded
      // asynchronously, we use this terrible timeout to wait for it being ready
      checkIfVimeoIsReady()
        .then(function() {
          theme.config.vimeoReady = true;
          theme.config.vimeoLoading = false;
          $('body').trigger('vimeoReady');
        })
        .fail(function() {
          // No vimeo API to talk to
        });
    }
  }

  function checkIfVimeoIsReady() {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (!Vimeo) {
        return;
      }

      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  theme.init = function() {
    theme.setGlobals();
    theme.pageTransitions();
    theme.initQuickShop();
    if (theme.settings.predictiveSearch) {
      theme.predictiveSearch.init();
    }
    theme.videoModal();
    theme.articleImages.init();
    theme.customerTemplates.init();
    theme.collapsibles.init();

    theme.rte.init();

    AOS.init({
      easing: 'ease-out-quad',
      once: true,
      offset: 60,
      disableMutationObserver: true
    });

    $(document.documentElement).on('keyup.tab', function(evt) {
      if (evt.keyCode === 9) {
        $(document.documentElement).addClass('tab-outline');
        $(document.documentElement).off('keyup.tab');
      }
    });
  };

  theme.setGlobals = function() {
    theme.config.hasSessionStorage = theme.isSessionStorageSupported();

    if (theme.config.isTouch) {
      $('body').addClass('supports-touch');
    }

    enquire.register(theme.config.mediaQuerySmall, {
      match: function() {
        theme.config.bpSmall = true;
        $('body').trigger('matchSmall');
      },
      unmatch: function() {
        theme.config.bpSmall = false;
        $('body').trigger('unmatchSmall');
      }
    });
  };

  theme.loadImageSection = function($container) {
    // Wait until images inside container have lazyloaded class
    function setAsLoaded() {
      $container.removeClass('loading loading--delayed').addClass('loaded');
    }

    function checkForLazyloadedImage() {
      return $container.find('.lazyloaded').length;
    }

    // If it has SVGs it's in the onboarding state so set as loaded
    if ($container.find('svg').length) {
      setAsLoaded();
      return;
    };

    if (checkForLazyloadedImage() > 0) {
      setAsLoaded();
      return;
    }

    var interval = setInterval(function() {
      if (checkForLazyloadedImage() > 0) {
        clearInterval(interval);
        setAsLoaded();
      }
    }, 80);
  }

  theme.isSessionStorageSupported = function() {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    var storage = window.sessionStorage;
    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  theme.isElementVisible = function($el, threshold) {
    var rect = $el[0].getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    threshold = threshold ? threshold : 0;

    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= (windowHeight + threshold) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  theme.pageTransitions = function() {
    if ($('body').data('transitions') == true) {

      // Hack test to fix Safari page cache issue.
      // window.onpageshow doesn't always run when navigating
      // back to the page, so the unloading class remains, leaving
      // a white page. Setting a timeout to remove that class when leaving
      // the page actually finishes running when they come back.
      if (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) {
        $('a').on('click', function() {
          window.setTimeout(function() {
            $('body').removeClass('unloading');
          }, 1200);
        });
      }

      // Add disable transition class to malito, anchor, and YouTube links
      $('a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"]').each(function() {
        $(this).addClass('js-no-transition');
      });

      $('a:not(.js-no-transition)').bind('click', function(evt) {
        if (evt.metaKey) return true;
        evt.preventDefault();
        $('body').addClass('unloading');
        var src = $(this).attr('href');
        window.setTimeout(function() {
          location.href = src;
        }, 50);
      });

      $('a.mobile-nav__link').bind('click', function() {
        theme.NavDrawer.close();
      });
    }
  };

  theme.reinitProductGridItem = function($scope) {
    if (AOS) {
      AOS.refreshHard();
    }

    // Reload quick shop buttons
    theme.initQuickShop(true);

    // Refresh reviews app
    if (window.SPR) {
      SPR.initDomEls();SPR.loadBadges();
    }

    // Re-register product templates in quick view modals.
    // Will not double-register.
    sections.register('product-template', theme.Product, $scope);

    // Re-hook up collapsible box triggers
    theme.collapsibles.init();
  };

  window.onpageshow = function(evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      $('body').removeClass('unloading');
    }
  };

  $(document).ready(function() {
    theme.init();

    window.sections = new theme.Sections();
    sections.register('header-section', theme.HeaderSection);
    sections.register('slideshow-section', theme.SlideshowSection);
    sections.register('video-section', theme.VideoSection);
    sections.register('product', theme.Product);
    sections.register('product-recommendations', theme.Recommendations);
    sections.register('product-template', theme.Product);
    sections.register('collection-template', theme.Collection);
    sections.register('featured-content-section', theme.FeaturedContentSection);
    sections.register('collection-switcher', theme.CollectionSwitcher);
    sections.register('testimonials', theme.Testimonials);
    sections.register('newsletter-popup', theme.NewsletterPopup);
    sections.register('fading-images', theme.FadingImages);
    sections.register('background-image', theme.BackgroundImage);
    sections.register('map', theme.Maps);
    sections.register('blog', theme.Blog);
    sections.register('photoswipe', theme.Photoswipe);
    sections.register('footer-section', theme.FooterSection);
  });
})(theme.jQuery);
